<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1+kIZo5WwoeHEBr21xVvY0Lx98up9IlRBg=",
    "cpf": "U2FsdGVkX1/XN2c3cdKM+F+AovTaiF1oxHNlRVPeXAw="
  },
  {
    "num_cand": "U2FsdGVkX1/mxG4K6sWBztFgko0J/zN0gHqXHncgQwE=",
    "cpf": "U2FsdGVkX1+6V1VL7TfMFU0V3kUZOnTo9ZZQLaLWvqA="
  },
  {
    "num_cand": "U2FsdGVkX18F0qeq4RQJSpaY8wENFudtGXJ3VqrZj1o=",
    "cpf": "U2FsdGVkX1/rQGE9iXKC3EgtjKi7OfcY7UOsGEtDTlE="
  },
  {
    "num_cand": "U2FsdGVkX19ONivcCjGpbpU4og0uUAK2IQ1yN0KUUzs=",
    "cpf": "U2FsdGVkX19ZTj7NXtov2FkQ7I2r8W6gewZadj15qsg="
  },
  {
    "num_cand": "U2FsdGVkX19M5QP6up7Su9lexfroPUcyvTw2zkQOIjI=",
    "cpf": "U2FsdGVkX1+EtykMs002v6s3LUFRLylyIIr9mNC1Pks="
  },
  {
    "num_cand": "U2FsdGVkX18eu7XTn0kjljQRFnZsWs3LoJ/7bt2ZdJc=",
    "cpf": "U2FsdGVkX18/k7KMgmARf2+QKrXNkP3IJeE1VTxcMsM="
  },
  {
    "num_cand": "U2FsdGVkX1+tD12gtbr4y8QMyg2zahesQFXF9Dc4Wak=",
    "cpf": "U2FsdGVkX1/qwB5qSgfrlg3bEGN3v80RdKEIjSbDuIs="
  },
  {
    "num_cand": "U2FsdGVkX1+ac4t+0LacJpCgZ2bGTwyrWnk+mg5S0YA=",
    "cpf": "U2FsdGVkX1/Nnj3GbC3gfkGZyRM3Bih8/nmjxuVDfUQ="
  },
  {
    "num_cand": "U2FsdGVkX1+Hv09AvrxObY/jPLmT5a0qxHh2Wlm0uCY=",
    "cpf": "U2FsdGVkX1+Dd/+2QHjUR3s7TOePCtAscgXhofu04bE="
  },
  {
    "num_cand": "U2FsdGVkX1+pCeH/ktmDKf3ry1Ghl3dBlRDkaXLkWrY=",
    "cpf": "U2FsdGVkX19vXa8XiNp+OCoclLr6ew4VqmppvWPDemQ="
  },
  {
    "num_cand": "U2FsdGVkX180GcJ58MC6/vr/1OTLr4V1s+v/LN+JNL0=",
    "cpf": "U2FsdGVkX1+a0GPuBb+Xnqy5Zysh8iWt61Vve83fjXk="
  },
  {
    "num_cand": "U2FsdGVkX18+c6iQ4FMHdxNoi9kEdN/V36JXOTeI/Jw=",
    "cpf": "U2FsdGVkX18MyRigJUI+tALP/3V8puT7VO+2PaHQxOc="
  },
  {
    "num_cand": "U2FsdGVkX1+xUm70aDEIqFvSLhlpOJfuiOELRa1PVSk=",
    "cpf": "U2FsdGVkX1+SJmz9kXm1kQ2644EwvcCvz8hdaTvv5Rc="
  },
  {
    "num_cand": "U2FsdGVkX1+OwpM78iF+xz+M6no6ar2/10QGHGmSGwA=",
    "cpf": "U2FsdGVkX1/mQaGA+S8TSIrEKG3SnRoaYgigChOcdfg="
  },
  {
    "num_cand": "U2FsdGVkX184m7AyfEaXAs8UY8TsK7QZLIgqu5ZvRpE=",
    "cpf": "U2FsdGVkX1//JalyHBHJwZSmP+p3UMDaZ539kERRxzc="
  },
  {
    "num_cand": "U2FsdGVkX1+xPnBi90P6Pdzy5fvLbpiM7G1LU8/MKvg=",
    "cpf": "U2FsdGVkX19pz4w5FFxasro2QKoeqV1VfBH+ploOi0k="
  },
  {
    "num_cand": "U2FsdGVkX1+jkVXqGlRA+TG+eOlQZ3S9gs3I6nlN0+o=",
    "cpf": "U2FsdGVkX1+Nt1QeQLFgh6R0tXiuU8FguofKLmfMw+I="
  },
  {
    "num_cand": "U2FsdGVkX18mD/M/U82lWuLSAd6Zm6wyDZ8IUvRfIPg=",
    "cpf": "U2FsdGVkX18KhDZ2U1sB0odkot2P2TD1SSY1garYPe8="
  },
  {
    "num_cand": "U2FsdGVkX1/9pAZ9V2WPHFj+VWORVreXHhRBpWlRNU8=",
    "cpf": "U2FsdGVkX1+fcMgi0KhVBGSDccamwInKwD6AMwRgjlM="
  },
  {
    "num_cand": "U2FsdGVkX19YjJsXway9VjXwyYpfHEFqhlTyfUkzejU=",
    "cpf": "U2FsdGVkX1+GMd012MtXUS5Bb8v5KvVBeSEGYHOJq1M="
  },
  {
    "num_cand": "U2FsdGVkX1/eSIC557MXEDqfgj0m3FaM/jEyC0WrQao=",
    "cpf": "U2FsdGVkX1+V1Zle/wbYc90E3NeMtpr80m459KoNndE="
  },
  {
    "num_cand": "U2FsdGVkX18g9kk3ECmSCx6UnV+4PWDJghXEmYZrLiA=",
    "cpf": "U2FsdGVkX187TcbMGwY6XeZzDY4uPEiv7AdmgUNFGj4="
  },
  {
    "num_cand": "U2FsdGVkX1+1HPlMILmoA2c+etBbVSGCjNdRHcRVij8=",
    "cpf": "U2FsdGVkX1+w513jjdZWoWwHHFOQTFHjROY4DK2vxr4="
  },
  {
    "num_cand": "U2FsdGVkX19UY6S7tfvkgF3+K6aQbm27Ye20ARvnNI0=",
    "cpf": "U2FsdGVkX1+QKF6p3020wzeB9XOCV/Fsu30vWr3Dz/s="
  },
  {
    "num_cand": "U2FsdGVkX18iBOBIzqdS8b5uBObAQJ+SlDb53LWiqi4=",
    "cpf": "U2FsdGVkX19qW9IM12ieApiMv3EvxJoYoG/f7ImdtcI="
  },
  {
    "num_cand": "U2FsdGVkX18VOAtuPi/zulnpUMEbsQ09bQnhCyNHdoY=",
    "cpf": "U2FsdGVkX18z0UnVEmlWZnk5DhVnulvn83kTSZZkbxA="
  },
  {
    "num_cand": "U2FsdGVkX1/w0FO8/ERliddwyvMTSpcTQZmutdYfzXk=",
    "cpf": "U2FsdGVkX19bDK3ob+4VXxpnj3EoV82mGV3YOOMYG4U="
  },
  {
    "num_cand": "U2FsdGVkX18Qe1WkBX5YOZf1f8kugw/+b2Y36H4hYhg=",
    "cpf": "U2FsdGVkX1/9f74iSgOOmFRBTtsxVkYsqQ6l9t/Nl5E="
  },
  {
    "num_cand": "U2FsdGVkX1+gmkrG4okPyhn0W36oDyG7fX5XlwwqWJQ=",
    "cpf": "U2FsdGVkX1+i6smACojmZr6oqdgzC6xP8xaIH6kZqJE="
  },
  {
    "num_cand": "U2FsdGVkX1+tO7eSO3tHrbSjKotl6axpRqghqXt9fDg=",
    "cpf": "U2FsdGVkX19j/rJ362D7v4K0sbbGt+MAUV/AHWNZ6Ww="
  },
  {
    "num_cand": "U2FsdGVkX18c0vI0DhBOgT3udEOfuqReBf1gu35Zgk8=",
    "cpf": "U2FsdGVkX18qwnAZpjqNpuYjvFixHuvfY+HeSlkyrbI="
  },
  {
    "num_cand": "U2FsdGVkX1+bfcKxciCM1fCaLZZvRNVOyZWSqN412Nw=",
    "cpf": "U2FsdGVkX1+kvUArFu/Rv6PRQfsrOg45e5UaFArGgYY="
  },
  {
    "num_cand": "U2FsdGVkX18u/1Ow3BtDpeKPvtu9koLO0FKnIqPttZo=",
    "cpf": "U2FsdGVkX19IkFfVo+A1QvuoVnI+CQgY4ndQcDlDprc="
  },
  {
    "num_cand": "U2FsdGVkX19J30vqMuvOq20W7q6DKLTsfiA2S+q+PZo=",
    "cpf": "U2FsdGVkX1/Yk2a3Mf/XXgZC9kOudKtEadNj5Jc1yoE="
  },
  {
    "num_cand": "U2FsdGVkX1+AZq2NtUzy7bqhaSrlBlmoF9h+sJs1e1E=",
    "cpf": "U2FsdGVkX1/NqMV95jVnNMk/DyWVrl3ptrp6/XM55sQ="
  },
  {
    "num_cand": "U2FsdGVkX19AeYsnJ3RT1dbKp9v0Pbtq3XFBN3C02B8=",
    "cpf": "U2FsdGVkX199BiCPotiOJYts5EgBMnolK0LZryfcD1A="
  },
  {
    "num_cand": "U2FsdGVkX18bNBPni0SYlTQVkwzvXqo9BYRuDnS4plc=",
    "cpf": "U2FsdGVkX1/2VhjCo9FPgtN1kMUI0sPnaTfdFdYM1O8="
  },
  {
    "num_cand": "U2FsdGVkX192eUtND9ly/dNc7qTMlGwV2jtEgCCx3ig=",
    "cpf": "U2FsdGVkX19bYQUFHpU8gvWPCksDojCVI7JAAvsI9wA="
  },
  {
    "num_cand": "U2FsdGVkX1/moleocU/CxnlQycgl9151OmmQrRKixzM=",
    "cpf": "U2FsdGVkX18nApSZq63F4XUpdBNTjUxlCgcjir46s2E="
  },
  {
    "num_cand": "U2FsdGVkX18mppZUDAAmn/vXbzw8lnK+zxJYVBpJ0hg=",
    "cpf": "U2FsdGVkX1+MnJTQg7BP8hd0DaHCXws2CqQPB1Y6sT0="
  },
  {
    "num_cand": "U2FsdGVkX19MC6/l4l/DqXx6no5lckLTNz5dFwFTCVM=",
    "cpf": "U2FsdGVkX18phGtyOdj2mySwNAgAAnqyWv9czQH6Iwc="
  },
  {
    "num_cand": "U2FsdGVkX1/6jeTR2RQvQsne3hDzEIbPtfdqgmCEOBU=",
    "cpf": "U2FsdGVkX182aXS5oDa6GF+9jovSivizzsXs39Fiyo4="
  },
  {
    "num_cand": "U2FsdGVkX1/zi4FY74HCBnDfybjOuFAU33j1vlzTYLI=",
    "cpf": "U2FsdGVkX19nejiF7CI8g+rOHWDr1oitfyv1vWaeuUE="
  },
  {
    "num_cand": "U2FsdGVkX19L0IM8lvVb8p5FKn/X0yApCMBMAMNKI1Y=",
    "cpf": "U2FsdGVkX1/GjaRlO1rrkrU7hgtOGMNLsPcfO3MoAt4="
  },
  {
    "num_cand": "U2FsdGVkX1/g1oBx48B1+o+pLS1N1RaQpMFt6IBEWqo=",
    "cpf": "U2FsdGVkX19rYK3cOgq68IEkasw+pObW3voED7En1ZQ="
  },
  {
    "num_cand": "U2FsdGVkX1+imWw71wsz0GBmGdhGWfqZli7StbM/yoQ=",
    "cpf": "U2FsdGVkX1/Vkn/wAy01HeSRPo/lDmUL3FBAHR+9qrs="
  },
  {
    "num_cand": "U2FsdGVkX1+7JzDV9Eg2FoB0/HUc1Z7jNbNTLx3SGwM=",
    "cpf": "U2FsdGVkX1+rQI6NbFMiKFjFBw5malX6Tj14iEmhxcs="
  },
  {
    "num_cand": "U2FsdGVkX1/fojAvMbm3Cu7L7x/62FLOuesVEOiovZg=",
    "cpf": "U2FsdGVkX1+4WcRMu+N+0NhvVm96x7j20fJFB1IQm4g="
  },
  {
    "num_cand": "U2FsdGVkX1+j38LhinZMckoCcmKA+mhuVJCQG9j7zPg=",
    "cpf": "U2FsdGVkX19mMJ1/hkocbfV1qmPhqkDPrJQPBD5TiqE="
  },
  {
    "num_cand": "U2FsdGVkX19ZCjaRURyaCkRWTnHQWA3uvqAAQe40yIU=",
    "cpf": "U2FsdGVkX1++gRP9pRpchjm3oUgOGAYwwkEXFXDBIKU="
  },
  {
    "num_cand": "U2FsdGVkX1+ObwK3rNHB64Fl1ge2uG9hM3aI7ubTB0E=",
    "cpf": "U2FsdGVkX19EBZ0MJ/gtVuPQNVps6c1DfEAIgGpykKY="
  },
  {
    "num_cand": "U2FsdGVkX18EOsPm7+2EyFK4luSCdbPuvnY0dFgsn0U=",
    "cpf": "U2FsdGVkX19+noqMKU1IkBp9DAI0CXd1ryFniV/uPvY="
  },
  {
    "num_cand": "U2FsdGVkX18d33YycE9nwaotPfMl8UwWFpSBeOQTgeA=",
    "cpf": "U2FsdGVkX1+UlMif1bWBrKPtCb9ifRwB5kP/HsNDV0I="
  },
  {
    "num_cand": "U2FsdGVkX198RdK4f/hEZKS8sYTIcpbHr6aFEcaaloY=",
    "cpf": "U2FsdGVkX19T4aZ2MGC7z+90FsDYowjwD1WCjo3j27I="
  },
  {
    "num_cand": "U2FsdGVkX18P59aNaAi1o5T1Nvic3wY2mOsoTnsO0rQ=",
    "cpf": "U2FsdGVkX19cTvWkmZuIl/7cDLJIdPJRp91P5ZRYxL4="
  },
  {
    "num_cand": "U2FsdGVkX1/OwJYNEeiFfGatKvHkmBONIO69e8sO4d0=",
    "cpf": "U2FsdGVkX1+uXgDRQ8k/eZE09TWZsXZdoxG8WewmAf8="
  },
  {
    "num_cand": "U2FsdGVkX19BV3gGo/XTJJvsE7sxw+TNYe59UQJD0pU=",
    "cpf": "U2FsdGVkX1/uc28HKIQhO6LnZ5fDUjY7G6MkHNKYtw0="
  },
  {
    "num_cand": "U2FsdGVkX19tC8WatmAYLeZPEluRGCaleC5zfr9gSKE=",
    "cpf": "U2FsdGVkX1/mexsT8jqeI1e0ADMSUCKuunq3DfeyNXo="
  },
  {
    "num_cand": "U2FsdGVkX1/m2034NCdb7YPlayKpYqNPmyAOHYPq6c0=",
    "cpf": "U2FsdGVkX18wri+zVsfduuaAP59DVXgPcve1u3vFORE="
  },
  {
    "num_cand": "U2FsdGVkX1+EGCNR4oLVxcwvP8gMjfaEyW3HEehYCpc=",
    "cpf": "U2FsdGVkX1/RzkTDF88JY3mEhykN8KqCGIN1+5Re1PU="
  },
  {
    "num_cand": "U2FsdGVkX18FHfCl7e/cMkRKJ+zipXR0IWyVXATuERI=",
    "cpf": "U2FsdGVkX18aaiwcBekGVIO7yHAcy5jZV6t62A7kMyU="
  },
  {
    "num_cand": "U2FsdGVkX1+P7dR2CbowptufGeNRqYmDh5A/xuR3OkE=",
    "cpf": "U2FsdGVkX1+t7+n7rp9cLgEQ7lC76PesICfcL+Wk3+g="
  },
  {
    "num_cand": "U2FsdGVkX19zTwyVd1ePLbWW/h8xU4MS5m4goV9ts+M=",
    "cpf": "U2FsdGVkX19QX4SQsKfclkDrvg5Y1Jqwd1riFJZBYSo="
  },
  {
    "num_cand": "U2FsdGVkX19PSumusH1sneFaI8fyEqDPX3vnTCWdxwA=",
    "cpf": "U2FsdGVkX18Ncy82KB9ANBzlK09nByaA/BihOQzh8sg="
  },
  {
    "num_cand": "U2FsdGVkX19dSL4RT7vVlJdHonC0sgZZSyllD/YXf9k=",
    "cpf": "U2FsdGVkX1+Qakqqb/whyzQytUE448dr5jS7U1S/sgU="
  },
  {
    "num_cand": "U2FsdGVkX19G7p8JdcGCxCTHnRpwYmIg8h3vehfmWAY=",
    "cpf": "U2FsdGVkX182Ps2OI/tc2gEKxUpezFxfrX3qID0R3Jo="
  },
  {
    "num_cand": "U2FsdGVkX19ERBGSGAZDStXAdSu3nWbOztiUxSMLedw=",
    "cpf": "U2FsdGVkX18su+Ufbh4e92eka6rPloV0X5tbTCl/bW0="
  },
  {
    "num_cand": "U2FsdGVkX18QbeGC+2tWRMri0ofjeCT/Y+c9trucUTk=",
    "cpf": "U2FsdGVkX1+8h6eLnw+iAHDWbVNwAHNT+F493hFCTJ4="
  },
  {
    "num_cand": "U2FsdGVkX19sJgbr/K2ITohNaWLDezZf0vX/Sj5FIw0=",
    "cpf": "U2FsdGVkX18ZXwO+I70Ac6pvQb5IJkLnJCGDxmcC9Uc="
  },
  {
    "num_cand": "U2FsdGVkX1+LFI9U9kYAPyaJiyXJ6gkKEoSfIjehsNo=",
    "cpf": "U2FsdGVkX18dZTgEwqYtSiTQH5O8ixcwYTroRTPIyQo="
  },
  {
    "num_cand": "U2FsdGVkX1+Xu3pTw0LdzyVlFCRIf3yON19BAg/6Vmg=",
    "cpf": "U2FsdGVkX18ODw+OCCVUL3LXuR17l9k1VgmO0FiCmKM="
  },
  {
    "num_cand": "U2FsdGVkX18Pfj530PvpG81V/jMcUIQ/v3ya0Mx5bx4=",
    "cpf": "U2FsdGVkX1//Au+IgqW5/1TNeQQeA7m5i7GQ4yivIxg="
  },
  {
    "num_cand": "U2FsdGVkX18xFVJ8/FCDDtxZLRN7uF1ysavgF2ggdG0=",
    "cpf": "U2FsdGVkX19OLZZZOwqT8+8Ih6BbWm+ehPDbhymahkI="
  },
  {
    "num_cand": "U2FsdGVkX1/OuLhBhugU4sB8aRnctUnFPTcFqB/9fdM=",
    "cpf": "U2FsdGVkX19KnVXiyLnfZlAsi2hVdrngOihd5xGxA1M="
  },
  {
    "num_cand": "U2FsdGVkX1+btRhB+G8ShFBc2zl1WWiyX9m1dMt1Glo=",
    "cpf": "U2FsdGVkX19oqDIfqGmtxdzGIlMd2o45wulW0Oz/G5w="
  },
  {
    "num_cand": "U2FsdGVkX1/oYPNdx0y+BOYBcnvJ6n36ixSDdKRONUc=",
    "cpf": "U2FsdGVkX1/hxGKBy5LJkFMFEr/Oh6Mv6pybFAKK89Q="
  },
  {
    "num_cand": "U2FsdGVkX18Dos0h4TeSav7zWisWOGZpMovUlenXJrI=",
    "cpf": "U2FsdGVkX1+cgdqibkzM4k+rfK0uIUJ3TT4TA/QlkDA="
  },
  {
    "num_cand": "U2FsdGVkX1+OdcN26YuP/iN8aakF8xN4e8UYMh2XRSI=",
    "cpf": "U2FsdGVkX1+ZLDAtOgkvzN8fVAayF+6q6UrYtMk/ThA="
  },
  {
    "num_cand": "U2FsdGVkX1/Cp/oprLJIxFAThGWIng8iy+f69MUsdfc=",
    "cpf": "U2FsdGVkX1+KgOql0LNJ7csqgpg2qsDk79HC0Mq2XUA="
  },
  {
    "num_cand": "U2FsdGVkX19BxqkI6Y+EcND7bZrinp66/RTuDWNy5as=",
    "cpf": "U2FsdGVkX1/PhTvfNu6RBgvPaB8RlD3qAfcKQS8to4I="
  },
  {
    "num_cand": "U2FsdGVkX1/H3BfIP19TZBzxSV+qYviTSg02S+OVC2g=",
    "cpf": "U2FsdGVkX18Y/5kNIdZNCC+ONzm1q2/JZx46J7BPu0E="
  },
  {
    "num_cand": "U2FsdGVkX1+pXm7UaJQ6vHodk89QbXRs89w4SC1oRKY=",
    "cpf": "U2FsdGVkX1+LnKaiLp256Ij7Ux1JYk96d11wKXC6eUw="
  },
  {
    "num_cand": "U2FsdGVkX19PdkkksiWB9X7gBey2MNUxfBejRn38I/Q=",
    "cpf": "U2FsdGVkX1+dKg3jLHYSJoDc0kWZ57D/fKq9X9gDU/s="
  },
  {
    "num_cand": "U2FsdGVkX1/lDGe2WPu4TbAUytD0Ork92eHXVeqvU9A=",
    "cpf": "U2FsdGVkX18fuv/nuFCUnKi1jD9yaqG2+bixQSY3KhM="
  },
  {
    "num_cand": "U2FsdGVkX18uSb4Wl9H29WsGuOcOKPkzMtVF288Hkac=",
    "cpf": "U2FsdGVkX1+voAekMOsUW9YmKjhRI9zXVvZIhrzhawA="
  },
  {
    "num_cand": "U2FsdGVkX1+hCxi0lPUh3GqsmX5PLrVIEBUKfLoTv0U=",
    "cpf": "U2FsdGVkX1+WWMDJuLSJ71eu5bkbpFaly8VsUfmAQA8="
  },
  {
    "num_cand": "U2FsdGVkX18cg7LyiHZbNKhF3i1vxUrBtCdgphW7x5E=",
    "cpf": "U2FsdGVkX1+QVrW9zhYRcH0019EnEKYrz4pV9GOdFeQ="
  },
  {
    "num_cand": "U2FsdGVkX1+T1dHiLxDpAEQuz1Zecpn1gePh9olJRHc=",
    "cpf": "U2FsdGVkX19839tVb3iBw4kAc1waNdy3GA5FJs7Fr/4="
  },
  {
    "num_cand": "U2FsdGVkX1/l8ZZsPGQs6Ynryt6hQVV81Y9VVewDz3w=",
    "cpf": "U2FsdGVkX19zpk8XFsmOkm6UencjEJO0xVt9veNDaM0="
  },
  {
    "num_cand": "U2FsdGVkX18/6DYlo9qN//mDruvumnLbkuxUKiq3tyU=",
    "cpf": "U2FsdGVkX19sPJH9WynQCyERe2akva1p5IE33GnQbf0="
  },
  {
    "num_cand": "U2FsdGVkX19SlipMOcAQ/6erUpu6x2xrakvzoOLtnp0=",
    "cpf": "U2FsdGVkX1/gXLHWEaYpcSBDhHNUfgbCBQ1MR9a2XM0="
  },
  {
    "num_cand": "U2FsdGVkX185jEPFiVZ7qi3+xxAA7pG5PUaGnsi4RpQ=",
    "cpf": "U2FsdGVkX18zEpWpd+7oZdg3gTWmj9vMDbiIX1CB2mI="
  },
  {
    "num_cand": "U2FsdGVkX1+ALZK7f+lruJoy/31xUyivemSlWo5iY9Q=",
    "cpf": "U2FsdGVkX1+TCYs1vA38n9GA+mXl3f+ErlKM33oJxbY="
  },
  {
    "num_cand": "U2FsdGVkX1918PGT31eynebgSh0su0K3+Bbdm1JGlZs=",
    "cpf": "U2FsdGVkX19ZC4B4AW+PFbl7gqlKUUxKg9mz8yz3PZU="
  },
  {
    "num_cand": "U2FsdGVkX1/7/ivyUwxz2bGOQn16JcTpFx3oRDThc/0=",
    "cpf": "U2FsdGVkX1+0RrrEaLYAL2YdYM+rs7AL9/QeCjsxCJQ="
  },
  {
    "num_cand": "U2FsdGVkX18U3flnlFFpt1oMCYb5sYz3jhkT2VPGY+4=",
    "cpf": "U2FsdGVkX1+16gVPWOEDi3a86iHGfa339oObuyAEN3Q="
  },
  {
    "num_cand": "U2FsdGVkX182vAd5vnZXF/4XlQsGWeWL1kxRNbwnXo8=",
    "cpf": "U2FsdGVkX1+41D0zpaixCAZnZCyFPDYcQk5QkMYouZ4="
  },
  {
    "num_cand": "U2FsdGVkX18rcykr3R/AkXQeAHkYtFeAoJDLh1n7yrc=",
    "cpf": "U2FsdGVkX1/Lq7MK2y+SmSQ0oTQ9vpnInw7QrUJgU9c="
  },
  {
    "num_cand": "U2FsdGVkX1/7rmAFK2AnE84MjZoSY7u41iVYXhfm6Wk=",
    "cpf": "U2FsdGVkX1+yKviwLcg5NyodKaU3FXJcIGXSdLd41So="
  },
  {
    "num_cand": "U2FsdGVkX1/UAY08MJcU2MGay13IU4ARK44yzbhKH5k=",
    "cpf": "U2FsdGVkX188r76qph7aXZWVyuiRYvpHCJcaplADGpw="
  },
  {
    "num_cand": "U2FsdGVkX186KGlHPDXHH40RO6C57EVkzCoQPlZP6Rs=",
    "cpf": "U2FsdGVkX1/kTkQA9hLvUGYZyjaAMizAui54D5Pg3m4="
  },
  {
    "num_cand": "U2FsdGVkX1+H2GFMAWl/QTPHgoBW2pRZunlUeKllhDA=",
    "cpf": "U2FsdGVkX1+hTlAcgVl4izqYqFeBRMB9/ck2uBraDNU="
  },
  {
    "num_cand": "U2FsdGVkX18VqZXmWCyUhM9NXygDCgmziCmCOSCI++o=",
    "cpf": "U2FsdGVkX1+3tbPkPxvpZ9g5g+c0iN5S1eUDiwatDAw="
  },
  {
    "num_cand": "U2FsdGVkX1+94MbyGszr2CVwtxYpA0a85atGUdxmjsA=",
    "cpf": "U2FsdGVkX1/NkhI3Sx4Jw3ra0ZRqHoCDUclWGIWHy8s="
  },
  {
    "num_cand": "U2FsdGVkX19bUpmOLBFdLDS4KlP7i2/MlL1KgsaiKTo=",
    "cpf": "U2FsdGVkX1/zFE9hrrNJhuMfHnIiS7XIOPkmd616WjE="
  },
  {
    "num_cand": "U2FsdGVkX19E+0JeCooiQGtYPySflNTG3DQX49pr4aw=",
    "cpf": "U2FsdGVkX1+Y8TQSPmC1HZXTU9s05ETG9IluYwNz0+A="
  },
  {
    "num_cand": "U2FsdGVkX1/EODxZyoD3hxBcnL1FSyoKhRaygenOp8Y=",
    "cpf": "U2FsdGVkX1/6dwtfbqqrMtslkPh5fNfo2DPbgcigrP8="
  },
  {
    "num_cand": "U2FsdGVkX18O5mSlxRsCm0j59km++wS5feCZPuX9mVE=",
    "cpf": "U2FsdGVkX1+d3TeA3XPiLqJd9c8HMX+B+HYSAQTcB34="
  },
  {
    "num_cand": "U2FsdGVkX18A2q6N8dMMdeHwWdvw5biHE93a5WDfOnA=",
    "cpf": "U2FsdGVkX1+cUzNoqqB/7gIXKkno+bP+QaHWT/rWFFg="
  },
  {
    "num_cand": "U2FsdGVkX1/57jWOZppta6NZnOYSuL6tuZWhGWwtnnU=",
    "cpf": "U2FsdGVkX182FkhNyjZbgYbWlajj3ZKe5lBBpsggKZc="
  },
  {
    "num_cand": "U2FsdGVkX197WVBisOq9y2GC7ALG0SurY6tf3Z34cIU=",
    "cpf": "U2FsdGVkX19Bqhan/L6K6NlTSonDwaofs8rmwUEKeXg="
  },
  {
    "num_cand": "U2FsdGVkX19WBAxTJNt2gIR0GtaOWAAZ01jRNxZR8z0=",
    "cpf": "U2FsdGVkX1+Mhnt/yzKCFIDDQEoB2DWjX6hQXeEv2RE="
  },
  {
    "num_cand": "U2FsdGVkX18ziEYVf/UY78uxiC2oCJih1yw3/nn3oTs=",
    "cpf": "U2FsdGVkX19GcZc748dLt28BYOBHbko5H64lxHu6wk8="
  },
  {
    "num_cand": "U2FsdGVkX1/BDJszRAoTfJ6HXk7KBvIEBvg5IUSOgJQ=",
    "cpf": "U2FsdGVkX18pT1n7IZn7AKEiifuTuodJXE7Z3vTcrjI="
  },
  {
    "num_cand": "U2FsdGVkX18U3KTTW5euG+7B1vVXuY62W7AVGlXkYD0=",
    "cpf": "U2FsdGVkX1/7xiN/jHtclHYwwGUSJeKRfmh8WhOWwp4="
  },
  {
    "num_cand": "U2FsdGVkX18ylZJTi5sEN6KOjaH7xVUZkBLrgewFre8=",
    "cpf": "U2FsdGVkX195SnY91VobYIG3EkIUJ8tIZf+IRUO/HDc="
  },
  {
    "num_cand": "U2FsdGVkX18jk9kQw33jCM32MsUqDR/wO45v/w/FhXE=",
    "cpf": "U2FsdGVkX1/Fmndg6fgOhqdCoFoos49HoKwnmxCeF2A="
  },
  {
    "num_cand": "U2FsdGVkX1/KNp1qJBvL7IN0Nx+5BbLtJg3X7MLH8Fk=",
    "cpf": "U2FsdGVkX19Y1F3RR/79wc5QNmNL3y6KN3aQRPRH0I8="
  },
  {
    "num_cand": "U2FsdGVkX19x+f/B5JxLidQKa4QmrIkvxSWjjXWtR5M=",
    "cpf": "U2FsdGVkX18/p193G4nCqBUE6MpmFI/O4HNNJFoUuQo="
  },
  {
    "num_cand": "U2FsdGVkX1+lWuDbrI1iWG30DY/gJhgE7JnxMOnNdLY=",
    "cpf": "U2FsdGVkX1/KWf+be66jQcCrAqrkG92kFfGYOYvpi4U="
  },
  {
    "num_cand": "U2FsdGVkX18gRTx2td91eruX0DzPcR9+iBbnyeMWX9E=",
    "cpf": "U2FsdGVkX18J57IcP5xE1BmvDkZOuvsv4334e99LANw="
  },
  {
    "num_cand": "U2FsdGVkX1+CCC1YyYJu6nGEYLefiLOrnOhOV7EbJm8=",
    "cpf": "U2FsdGVkX1+tdpHnxgmOnhfijy2dQVG4yd0ggyMUpKg="
  },
  {
    "num_cand": "U2FsdGVkX1/31C1JD5/x9TfrwWiwNJ3LY6YF+SUgt7k=",
    "cpf": "U2FsdGVkX19V2aJrVXvHk43neoh/pAk8lwKYMQmjp7s="
  },
  {
    "num_cand": "U2FsdGVkX1/0PgSe50vBZ+3QAbW4Y1jftzfRmA+lYvA=",
    "cpf": "U2FsdGVkX19/IRddjYxJxIsdmjLSGSWNyZ3Ov58jIZY="
  },
  {
    "num_cand": "U2FsdGVkX1+EIxVa7wgybuk28XkM2ZLWBuZbc9l7PeE=",
    "cpf": "U2FsdGVkX1+E4RLXG7+7f7A+1AKl3Dpj+ONa54uWktk="
  },
  {
    "num_cand": "U2FsdGVkX1+qSTRnmblIwF74Ti2g0X6Qicu+T8gryV4=",
    "cpf": "U2FsdGVkX1/RXWhvTiplmUHTVyT2Cp9W2IL+hgakhA4="
  },
  {
    "num_cand": "U2FsdGVkX19UpP2FM0f84chd4az33B+UHuCOb4X0cic=",
    "cpf": "U2FsdGVkX1+jEWBtQi+UeEMVRBT+SoI302R0mPjtLik="
  },
  {
    "num_cand": "U2FsdGVkX19zr/JRf5ahFImsnlEhykvcS/HFqVQ49Y8=",
    "cpf": "U2FsdGVkX1+g/ONYq1jV2ZQAB6tkICN6EJMQWx4MLNU="
  },
  {
    "num_cand": "U2FsdGVkX18PKjpbXZa2SgBCDH6vpPJVtYL0VM0gRPI=",
    "cpf": "U2FsdGVkX18GhLpYA0O+aYHDGYLP8493+PBBFbgWNH0="
  },
  {
    "num_cand": "U2FsdGVkX19sSCm72A3SLuwO+aVvONkZm3sD2Hjs07g=",
    "cpf": "U2FsdGVkX185ARN0kvyZwSKc5SJBk4qsFUvM2IylOS4="
  },
  {
    "num_cand": "U2FsdGVkX1/BaLyiaBkcit5SghTUCkGLnyp6SMNeQj0=",
    "cpf": "U2FsdGVkX189cFLOsvdB5Sh9k53BoDREyscz/M3rXDA="
  },
  {
    "num_cand": "U2FsdGVkX1/ZzI7pF5QnIQS/kUwkw54vCPUnH+IBePw=",
    "cpf": "U2FsdGVkX18zHuEmiVVo65FxYyTjZUj12udTC8BGfbc="
  },
  {
    "num_cand": "U2FsdGVkX18CFLjiyTXdqxrEGU2oNG3i1RqMLEFRnoQ=",
    "cpf": "U2FsdGVkX1/7gkRN20frlVpcy8JMwsr8ldsXy0ks4SI="
  },
  {
    "num_cand": "U2FsdGVkX1/DJaLpEgD2qq2iOK/Dt4kDFZ1awfRkITw=",
    "cpf": "U2FsdGVkX19TXdSbHJiL6bndBQhW+n0WqKsbxQhRvaU="
  },
  {
    "num_cand": "U2FsdGVkX18LWhkrXLOf6GQN6iiKPGK2VnzjESbafvg=",
    "cpf": "U2FsdGVkX1/M5ZPXBsYjeO8r5jo6mkVUHOkAjCDSgiA="
  },
  {
    "num_cand": "U2FsdGVkX1/s2WyTQb6xlJtpFv2xXtc6UmrLbgbmzqc=",
    "cpf": "U2FsdGVkX18BwVtkUstPrsHSQ6HewqVTflWc0amWOhU="
  },
  {
    "num_cand": "U2FsdGVkX19MQRnOXTI0C9s9fJrTCgGZerEKuBU256k=",
    "cpf": "U2FsdGVkX188+POjvdQ/fivxHlSslehFOTSwUzEOLcI="
  },
  {
    "num_cand": "U2FsdGVkX18y4kPO6wnjIV59jC1jZYZkuBXs3ks/34c=",
    "cpf": "U2FsdGVkX1/obnX9peOAyXRQLYOm7sk+/cPpvaH6zDk="
  },
  {
    "num_cand": "U2FsdGVkX1/FhOD05B1DU+HuJt6YQnfijTjT1a/7xPo=",
    "cpf": "U2FsdGVkX19BLjXZSmF0qXscFJq1nAcCctyslXx3S0E="
  },
  {
    "num_cand": "U2FsdGVkX18DVevy/LdJfYpY4QpQPOp3gk3yQg4q8Co=",
    "cpf": "U2FsdGVkX18XzVBYsQeH6z8YR0gPvUOzRf/YumEyDjQ="
  },
  {
    "num_cand": "U2FsdGVkX1+1Z8Wqbgv4IXQ+z33aQKiqN1T2A9bJij4=",
    "cpf": "U2FsdGVkX1+tqgm9GU7SGHUP8VgwA4nY+QIf66BN7Po="
  },
  {
    "num_cand": "U2FsdGVkX1+p6tCucJqKbPV7I7H8ktpBckuSjNZp7Og=",
    "cpf": "U2FsdGVkX1/N9GP+luQinFdajCEbNOaIYksjDoM6gDs="
  },
  {
    "num_cand": "U2FsdGVkX1+XPzZKxXwaj9JocoSVRXeMFBWgxYUSSFs=",
    "cpf": "U2FsdGVkX18tBc5GaPP+//X4Vacz4Cc+yYWkrh1+WuU="
  },
  {
    "num_cand": "U2FsdGVkX19jB6aKxDnJ+SW3FpwvpFWiNbfkqNMRPyg=",
    "cpf": "U2FsdGVkX1/PNCJ5l+BUnhcD4ChreSI7jYq1qA0YpiM="
  },
  {
    "num_cand": "U2FsdGVkX18Uo+8JQweYcZuCZ5GK7rZCPchHO5ioIQ4=",
    "cpf": "U2FsdGVkX19SE90E7vnmTDqFjKfJHBtiNbUJ0e2NkG8="
  },
  {
    "num_cand": "U2FsdGVkX1+EKilK2xHBpFdAv9Z2DubCs7YVtr8Nq6Q=",
    "cpf": "U2FsdGVkX198Pp5vToN8ny94ds83BMZGm4UMDkc+qbo="
  },
  {
    "num_cand": "U2FsdGVkX19VHgiBE4MrKsNMo7OeDdQtdoZavJ+FGaA=",
    "cpf": "U2FsdGVkX1+TrvB7n8C4gBuqZ//X/1Z4hnRs6p0lVyc="
  },
  {
    "num_cand": "U2FsdGVkX1/oxwC/JZFxVSsaud+29hF5Z6Qq9DBVaDY=",
    "cpf": "U2FsdGVkX1+bzRgE/qZZcSDGD7kK7xN7zuETej8MbGg="
  },
  {
    "num_cand": "U2FsdGVkX1/U5VjezwuRD48yuYolGDzntDjMm6IUBE0=",
    "cpf": "U2FsdGVkX1+3oi9DeTiz6b0VFYCfndk/klg3FjGpALw="
  },
  {
    "num_cand": "U2FsdGVkX1+EvDBuSz7o4dZNnRBTMu7O95KqGxEHxr8=",
    "cpf": "U2FsdGVkX1//HKIuBMlPSd/uc7KSXgTbYC3Lu6Qg27I="
  },
  {
    "num_cand": "U2FsdGVkX1/lo3RFrvKc8CTwy54IFTjPBTwklvttUmc=",
    "cpf": "U2FsdGVkX1+nDkO1Us88ijWg/j1+ZIs/7PMp02LHpdc="
  },
  {
    "num_cand": "U2FsdGVkX1+xcdRzrO8ojet9OwvvoOK6BeWGHHkVq6E=",
    "cpf": "U2FsdGVkX19PgJKgxvn5qEEJv785NMHO5074DXxfVvc="
  },
  {
    "num_cand": "U2FsdGVkX18d0fSBIPm1WNkHzrLoGOFQBZlzGQlGX6I=",
    "cpf": "U2FsdGVkX18RD+lcejiDY+PKjyDbGxsXIMbtWbhPIR4="
  },
  {
    "num_cand": "U2FsdGVkX1/7GopIEEWGVgIBbcTaFUIKeJykWI7d+vw=",
    "cpf": "U2FsdGVkX18lVrtn7ZT4aCEED/xzXPvgNbwI98eAxbc="
  },
  {
    "num_cand": "U2FsdGVkX1/PpGAsoskFSZpzh1CNVL2bxEQYdUXFJf8=",
    "cpf": "U2FsdGVkX1+Vj4bqnXaDaIWD66KkKWXzdO/jFChAxRE="
  },
  {
    "num_cand": "U2FsdGVkX1/smlVFRl0BZidKqQXp5AT6Z6fdm0ZFQHA=",
    "cpf": "U2FsdGVkX18tW3zg5yERXBsNUWsM+qf7DeO+rbwmOm8="
  },
  {
    "num_cand": "U2FsdGVkX18aZ4jjfT443kb9EjRU7OLgCFJFTxHcK6g=",
    "cpf": "U2FsdGVkX18nI4ILqFEybpHq/d47UzYJnwTF64iu9Yo="
  },
  {
    "num_cand": "U2FsdGVkX1/Eo2qgXvB1jm1dpQw59RpMEsvo0VWuLmE=",
    "cpf": "U2FsdGVkX1+KErPU7AeM9SwWGCHuGOD6wBj+MGcDeNk="
  },
  {
    "num_cand": "U2FsdGVkX194BpZkVXxy+tCwu4fzjS4zv6YBHsdj2qc=",
    "cpf": "U2FsdGVkX1/MXveSbD2MB5Jpk2QA1klZiSf8vS3sikM="
  },
  {
    "num_cand": "U2FsdGVkX19sSIMOjhDibrXgJUtMb2n3s5Hsk/1Or94=",
    "cpf": "U2FsdGVkX18qgSSgCZVfrRkhR+xoobIzTgvbj8pcqWU="
  },
  {
    "num_cand": "U2FsdGVkX199e9A3niHgeI8018xmUbHimFr4OzqAXmc=",
    "cpf": "U2FsdGVkX19GGGj1XZ6RxdMKFJKEFW4XO+1iObnVz9U="
  },
  {
    "num_cand": "U2FsdGVkX1+aj1EKIfAltlbC2GZz7ubxzrMrPyzgNI8=",
    "cpf": "U2FsdGVkX18N7Nyi0x/AUZumMIgTaD7IxSLq1yzAdyk="
  },
  {
    "num_cand": "U2FsdGVkX18cnFihragIPXSlPsCy8FC0wwp1YHQlkc4=",
    "cpf": "U2FsdGVkX192zDb8VKgkkvtzwdmqL2rra1XwCZbtkGI="
  },
  {
    "num_cand": "U2FsdGVkX18EL5FPov9/MeSgVdiPrgWIgxqiq8Vv/kk=",
    "cpf": "U2FsdGVkX1+RKs/kx2XtTLO9tANN+gcBp3UXMFE1EVk="
  },
  {
    "num_cand": "U2FsdGVkX1/Yq7iTSYeZMBlSvnzthmfM5jyCJRhY2GU=",
    "cpf": "U2FsdGVkX1+LuolQobAubk2X+/rhi7+f2/wbmVvMXpw="
  },
  {
    "num_cand": "U2FsdGVkX1/fZd2u+r0cmCjcoxT4bVZ6Z1nW3yOhg+Q=",
    "cpf": "U2FsdGVkX19VO0bh+AKTSZdRH0NNuZeKT1xnggduwi4="
  },
  {
    "num_cand": "U2FsdGVkX1997uOgjaPl83FnL+Aj/lZGizsgd14hcnU=",
    "cpf": "U2FsdGVkX1/KCr2QIm5ZDaGB5t2p6fPLInHTVNCFGU4="
  },
  {
    "num_cand": "U2FsdGVkX18h1mCQ2fnO1yQkmUXsRDGyO5uDGFAqSlY=",
    "cpf": "U2FsdGVkX19fPESrJuvOAkZPcL1736fu9pJOeFqpaUY="
  },
  {
    "num_cand": "U2FsdGVkX1/g+UA7VLA/xVkLUQZmtQep3c4myTepkyk=",
    "cpf": "U2FsdGVkX1/ZAyjtjkyzcCqbTUE2F5scpU51WsQVo1w="
  },
  {
    "num_cand": "U2FsdGVkX18NQDNiNTWd8KN25pAP6BNXA1UuGEiowqM=",
    "cpf": "U2FsdGVkX18TDUE2sN+kfHZqs6LZwCP8hYZQM4Vt2VM="
  },
  {
    "num_cand": "U2FsdGVkX18v+S8KnD+IcJw42JLPalJpdbzyvD+FbvU=",
    "cpf": "U2FsdGVkX19wtOVn7wnC5khxvgBy5a1F9kkDHAcCpqc="
  },
  {
    "num_cand": "U2FsdGVkX18Q3iagEWLWthviVdcCVMlWMpxLyQISRfM=",
    "cpf": "U2FsdGVkX1/28BiLnK5cq2U+9iT04o+jazjEbV6iwKo="
  },
  {
    "num_cand": "U2FsdGVkX1+PpZpx51JnHCvND+VnTf3hI3eJ1MUnW3E=",
    "cpf": "U2FsdGVkX187Z8SgSgPnkGCKsMzdMZTRuvVwULQ9hfA="
  },
  {
    "num_cand": "U2FsdGVkX19IXCfLdN1hBQpSGXVQSc877mVcJAfAx2I=",
    "cpf": "U2FsdGVkX1+vXsfkX5dCbtThiqIuGw9cK6zEZln6Tyc="
  },
  {
    "num_cand": "U2FsdGVkX1/4LhEMJDZIJIDZYISSEcN7LLYPn4F20Bg=",
    "cpf": "U2FsdGVkX1+QvpS9sakpQwxrI07Yzvms9ghofjz3rjQ="
  },
  {
    "num_cand": "U2FsdGVkX1/sNa+OzTQpcqeIal0KBtaz7yScUClKnAY=",
    "cpf": "U2FsdGVkX18o6chyoml1RAot0otYsVYxBG36sex7UDA="
  },
  {
    "num_cand": "U2FsdGVkX1/a00fLilpV974kq+Np4/BakygbqWB22fo=",
    "cpf": "U2FsdGVkX1+cYPAwV25ISn5nT3hf3G9GuOWIr/VcV40="
  },
  {
    "num_cand": "U2FsdGVkX19wsLNTWPAzxwwLqkp58hJb3YKjIL2TlsY=",
    "cpf": "U2FsdGVkX1/A1w2RnYC6TqBuFa17nQxE3UibV2k7JVA="
  },
  {
    "num_cand": "U2FsdGVkX18xsm8iEDlyph0jL90IrKcNfvpqODfRvk0=",
    "cpf": "U2FsdGVkX1/7zL5vZdGHoR+kEBoY8QRJaWkR6HoSfs4="
  },
  {
    "num_cand": "U2FsdGVkX1/BgEXAKsN0FzOw2OKJIuNgbcUSttIPoKI=",
    "cpf": "U2FsdGVkX18Ocg1NdpEYSyNkMrxfrfXVrbrb3L92mXo="
  },
  {
    "num_cand": "U2FsdGVkX18tcViyJzj2MNJtrwBVxRH2WU4zOrjTDTg=",
    "cpf": "U2FsdGVkX18ag3jVSHLVkAvyzl2xyKqDiv1syOtUkSc="
  },
  {
    "num_cand": "U2FsdGVkX1+i4e58aYvxHelqDWtiTziev7jr3NdxjdY=",
    "cpf": "U2FsdGVkX181VEx8Ad4pzti6YDHLAa1K6unL4OcxBOs="
  },
  {
    "num_cand": "U2FsdGVkX1/Cutld2/N5pVN44MqTCCq2mMdfv0Sj0ZM=",
    "cpf": "U2FsdGVkX1+Ph5Ueo0c5GbJ5YkrdBqDTtKeMmvC8BqQ="
  },
  {
    "num_cand": "U2FsdGVkX188foXrzwz6qA3l+Jzl3f28TnPqPxSVZ8A=",
    "cpf": "U2FsdGVkX1+Tnaw2ISx804LdyWJiaFV5qBVhUCmzER0="
  },
  {
    "num_cand": "U2FsdGVkX1/f7pxn+AjISNBYTQ7+qVUQyFJz+tFnJbA=",
    "cpf": "U2FsdGVkX18zCgzY2HZrYXSF7MGtIN+UZeKHKKLi4jg="
  },
  {
    "num_cand": "U2FsdGVkX18l55UcPqmAy+zwRLSWfroF42oTqxDt+LU=",
    "cpf": "U2FsdGVkX19gwnw9ZJBPSYuGjF9I4KXff4+IqeLg4Dk="
  },
  {
    "num_cand": "U2FsdGVkX1+4veIMJIVPZalF/qn0/nEkmlxryEjrkFg=",
    "cpf": "U2FsdGVkX181JCfaT0q/fQnBvCWfTmn7WjYXa0a3TCI="
  },
  {
    "num_cand": "U2FsdGVkX18K5johDGRN41kIBVAIkLXhT/4LQoodtgo=",
    "cpf": "U2FsdGVkX18i91tmx822syk3Vx+b4oLVJ2f0TC8w2OM="
  },
  {
    "num_cand": "U2FsdGVkX18gcn4JtS1P9eHWk2ZTLf0frbm9lloGNas=",
    "cpf": "U2FsdGVkX19TRh1q+y+3BOz4feZ99ipGYoPefRsUu3s="
  },
  {
    "num_cand": "U2FsdGVkX1+buI83fBFGPmZ6zWWmsRb0jI8K+1+Mug0=",
    "cpf": "U2FsdGVkX18juYr+F9nd82GP2bdx8YesLN2DOwN6Z5A="
  },
  {
    "num_cand": "U2FsdGVkX1+OTYl8wXXUa+2V+GLj8EqyN+p+da68/0s=",
    "cpf": "U2FsdGVkX19PhuXoWxEMlaG97Aqvyc6t65UtrQDQoPg="
  },
  {
    "num_cand": "U2FsdGVkX18A1dqj2xGWpFcr2G5Byu9LbeUEqI5KnXw=",
    "cpf": "U2FsdGVkX1+K72wLtpYyuOJJ3d7jQqtYcK/F/cfY0b0="
  },
  {
    "num_cand": "U2FsdGVkX1810Dct8WCfamV/FbzCjTs+KitkaoD/k9w=",
    "cpf": "U2FsdGVkX1/oFubwZW1XMAEqOzdTNJGOHrJADF/WM0k="
  },
  {
    "num_cand": "U2FsdGVkX1859eYFsMELTkwy9y0ZXKUvolV+lI4XvL8=",
    "cpf": "U2FsdGVkX1/eBbXflTuCv25DuD8ndX9qeYP7WhAL5OI="
  },
  {
    "num_cand": "U2FsdGVkX19MLKeunu4BgUNEFWgv6xXCpFuuOGI1gnM=",
    "cpf": "U2FsdGVkX19m9nivwo6CBLg6FAr5oVqd0LlI4QNudi8="
  },
  {
    "num_cand": "U2FsdGVkX1938lTi95oDlqQf27piJn2WN00TZ7m6l3g=",
    "cpf": "U2FsdGVkX1/wHP5+n9/KEkQKimT/uDz9VYab348AMkI="
  },
  {
    "num_cand": "U2FsdGVkX1+WvWnyIMtS3zfvwckmdjrPNJk/qrB9e7E=",
    "cpf": "U2FsdGVkX18tRGnlAL7uPbe/Osne/4weDf+4w/++538="
  },
  {
    "num_cand": "U2FsdGVkX19/brMgWj2r9tL5vsRdxQMcfWOGZow7BnY=",
    "cpf": "U2FsdGVkX180wnkO6ppndW0awz3jJAorDJ7NTZL9jhc="
  },
  {
    "num_cand": "U2FsdGVkX1/zwyQGLE5BXa9G8c0Si3MAS6OwyWTYmqg=",
    "cpf": "U2FsdGVkX1+ydQuw7oKDn2ChMjLqvwAharPI9mPdHvk="
  },
  {
    "num_cand": "U2FsdGVkX19jK7uAjVq+NrbdHwTlGkr2LnlJklHdqZQ=",
    "cpf": "U2FsdGVkX1+YhSCJag9CrXhNXuNOwXTkZu0CCPeJhIA="
  },
  {
    "num_cand": "U2FsdGVkX19KbjCVHM6bLRwR06U4YA2ASfrarm2EGmU=",
    "cpf": "U2FsdGVkX19KEBLVgkqVk5l38Wxoj+0PFfYzq6k5FVA="
  },
  {
    "num_cand": "U2FsdGVkX1/ajD4ToADZtxlwcwJBmOaSGc43smcc0rU=",
    "cpf": "U2FsdGVkX19gwvge7Om7L/UAQFpYVGeGsRQ1zcB9Sz0="
  },
  {
    "num_cand": "U2FsdGVkX1/KhZeF3ZKA/F873PghP0VInNwz4jCV1iE=",
    "cpf": "U2FsdGVkX19r2r33uBueypm4do4QGyz2XfHY+BEldFo="
  },
  {
    "num_cand": "U2FsdGVkX19LCjvQlkxwzPpPSNNeaqTxKdFdlh+NUMI=",
    "cpf": "U2FsdGVkX1+7rTdxJiaVrE6gC2s5tLNuumWSOOfy6HA="
  },
  {
    "num_cand": "U2FsdGVkX1+Q+DQswizanmLjasIFmJHVg/vqX4QxNts=",
    "cpf": "U2FsdGVkX1+//C05HysdjFBGAWyYoTuvhdvyqzWSeog="
  },
  {
    "num_cand": "U2FsdGVkX18uBKT1/Sz2D75IQ05ZL8qMwsLgd1wuNcg=",
    "cpf": "U2FsdGVkX1+IFzCCDlbHrF+pYvBvFSI7Hn2v1vf9WTg="
  },
  {
    "num_cand": "U2FsdGVkX18jjhSudVQun38RU8YsfzFGFjqKp+3gRkc=",
    "cpf": "U2FsdGVkX1/72MZMVTd9oUnWs8VzZVjXjtMYyZ1fll0="
  },
  {
    "num_cand": "U2FsdGVkX18jDnkKGi08uAPEmuO49EQJMRU0pA4b4No=",
    "cpf": "U2FsdGVkX18raOn16Vgfm6BaB4+DihNAk1eoK+H+x+o="
  },
  {
    "num_cand": "U2FsdGVkX1/LS4UkS+XeytRPKh/v4j7h85OCkJcCubw=",
    "cpf": "U2FsdGVkX1+f+5nwvYJKl63LcXJ4LKZxOeUFeUa3HtU="
  },
  {
    "num_cand": "U2FsdGVkX19q0gUu7F41+MJ2MF5zMVVAUYdiqIkEbe4=",
    "cpf": "U2FsdGVkX19OzzQDCkAqJtFrW3xru0qB55JlOOxiVp8="
  },
  {
    "num_cand": "U2FsdGVkX1/A9k+ecsu2oOo5hpwRrvj8Fo3RDzwcxQ0=",
    "cpf": "U2FsdGVkX19/Z19SswUFxbrnz/GPEi2MP3LQvyA4uyY="
  },
  {
    "num_cand": "U2FsdGVkX1/AjZ/mo6WEDFv1wA9gbjQ5IIZAJ3fxPTk=",
    "cpf": "U2FsdGVkX1981UYsUYM0L8Qb074w1dAgl3FDpMAx97w="
  },
  {
    "num_cand": "U2FsdGVkX1+sF3aepa39AEBax986Ur9IugOrfmkN/zU=",
    "cpf": "U2FsdGVkX1+eMIBir2fBasWZsht50P65ubxFhDEyBQU="
  },
  {
    "num_cand": "U2FsdGVkX1+sQcblhnA9HGkiz/7ywR1yGnAZFUWDfe8=",
    "cpf": "U2FsdGVkX1835s13HMpML/8aRz37yAxF6Pu7VJd1ZoI="
  },
  {
    "num_cand": "U2FsdGVkX1+FtD5vGaHVp0NEac3TXCV9tZIcct9R0do=",
    "cpf": "U2FsdGVkX1+DKephJ2wxlilVKR5Pe1bJjNmBhrCJo0k="
  },
  {
    "num_cand": "U2FsdGVkX18mxGECTWiLU2PoMHOrbwpu7CpHsFk3aiY=",
    "cpf": "U2FsdGVkX19nh+o2yitSL0AA6JM9+RiLXqDJs3Qh2Fc="
  },
  {
    "num_cand": "U2FsdGVkX184MprrWqgfs9qDiqryoMzWB9wRj5Q+z4c=",
    "cpf": "U2FsdGVkX1/d7dHEgWxH/7H6gTUnHNuT7Ill554yh+M="
  },
  {
    "num_cand": "U2FsdGVkX1/vfOcPchEHtYyz84FKb4++rDazmLiYlPU=",
    "cpf": "U2FsdGVkX18Vyb1yunISQp/fMnJpNNESWak2S8KVCVE="
  },
  {
    "num_cand": "U2FsdGVkX19n2xoYjrlKfDwvyx1or6VzDczI9WggYqE=",
    "cpf": "U2FsdGVkX1/XnZ5lUZYbPY+8cHqmOegHi8O4AsVrNF4="
  },
  {
    "num_cand": "U2FsdGVkX19u5GQc/rmUNAy3hTtt1FNuTwgCwvhAfN4=",
    "cpf": "U2FsdGVkX1+Ks3EagbIaYcCLhuJYrw97nUixW7n0unk="
  },
  {
    "num_cand": "U2FsdGVkX19OgFvFrK4GL8OtHR3tZwYlzheZMVvsrOw=",
    "cpf": "U2FsdGVkX1+A5r+puuSOxkWhyKiST3O5LM74h/gS+/0="
  },
  {
    "num_cand": "U2FsdGVkX19gHTsIHG4C8a/rdc3I3k0Jp922Fjy7Cho=",
    "cpf": "U2FsdGVkX19Kp0YZxch6IP1B+e96284Uw+bglAxNHDc="
  },
  {
    "num_cand": "U2FsdGVkX1+IlUwpWHo+LUhNKhdHlehNMLtZkhiTDY4=",
    "cpf": "U2FsdGVkX1+Mm3OyfvIZ4niRrKg7CKfuSgpwzGEzKfo="
  },
  {
    "num_cand": "U2FsdGVkX18tRBF2FtADneiL2lIgKpZWWTRa+Ce5b84=",
    "cpf": "U2FsdGVkX18mljJ2cEZewM/Z3l2F7KRoCTf6RKUN4QQ="
  },
  {
    "num_cand": "U2FsdGVkX19u8BeZMNi3V405j3e9z/bjTwXotxWSKrM=",
    "cpf": "U2FsdGVkX19o6L9MIZumFR8U+WUdCOVYe8jFvPRhKB4="
  },
  {
    "num_cand": "U2FsdGVkX1/ATt6r3khf2aK1iHijUi2tMdUu6AJAef4=",
    "cpf": "U2FsdGVkX19krlqKIJC8pMHN4LpRqWYM8yDgqe+7ntg="
  },
  {
    "num_cand": "U2FsdGVkX1+VOSnw43KTF/nC5zZKIZxSQ7vndnu6N2w=",
    "cpf": "U2FsdGVkX19F4RgXsVOv1il3+kWzpY74zyis/MrrYps="
  },
  {
    "num_cand": "U2FsdGVkX18jwFylc8OPUE/AKU7dwCrZsWO5GflkCPQ=",
    "cpf": "U2FsdGVkX1+SueF7uK3NAB/HrVm3QVkn22Qd6UNiz6M="
  },
  {
    "num_cand": "U2FsdGVkX19VzIz1q7e/r8/ysCT6L3S635CB8W3l6Eg=",
    "cpf": "U2FsdGVkX19Z3OtIz19BTvDQdbJyOVwYAKtXu5lomkw="
  },
  {
    "num_cand": "U2FsdGVkX1+yyb/rWRJZusgkKIXH0Fl2fmhGNMZWtmQ=",
    "cpf": "U2FsdGVkX1+37jrYwmTemK95dFGi2kxFd1+jvPTlmEs="
  },
  {
    "num_cand": "U2FsdGVkX19ATFz917rUF4qPDxSDG/r5qxusdDIONro=",
    "cpf": "U2FsdGVkX1+tfq6ztV+/1Mrz2rwG1Zqzas5yj9M3hZQ="
  },
  {
    "num_cand": "U2FsdGVkX18jZrq6eAEnbOEf/69SMYlC5pvXk80DAn8=",
    "cpf": "U2FsdGVkX1/4JxoC6ee0f/eRsp1tnRg7Sq3gO0gynMw="
  },
  {
    "num_cand": "U2FsdGVkX18rDhgpEhrWl5zpI3zrYVmzMDvecCS2Hro=",
    "cpf": "U2FsdGVkX1+FQ3dSdbCpehQLGcUKVSGGO+FtX9qI7yw="
  },
  {
    "num_cand": "U2FsdGVkX1/uCtYntyyfRz3W28589eHJDZX8glpba5k=",
    "cpf": "U2FsdGVkX19RWJdaZ8Dn/WnlmQuNcj2TA2Hkm4EeWA8="
  },
  {
    "num_cand": "U2FsdGVkX1+jrt/EgLtumgaiZsgkVyoagtGy5yBRdNk=",
    "cpf": "U2FsdGVkX1+d4d691CoPRgLp3GDW6Z/6jLKmpyRblLk="
  },
  {
    "num_cand": "U2FsdGVkX1/WAz+rQbcs+Wvy7sGeyeO5avYQ/9vu0wI=",
    "cpf": "U2FsdGVkX1+BiNZSn8dcEyFUsUnTNrPHqqvuJFDPVx8="
  },
  {
    "num_cand": "U2FsdGVkX1938JEgMGIhXjV38Elear+h22s6lK1UWRY=",
    "cpf": "U2FsdGVkX18fQDbykWrXo2qX4LJgaWlV5ZapfbaJFTQ="
  },
  {
    "num_cand": "U2FsdGVkX18+QPSzv3867DvzaL1UvgrYGUTVjoTWLDo=",
    "cpf": "U2FsdGVkX1/t5Wab3ULEiAL+tDdqpyEahJy0m4aXXvQ="
  },
  {
    "num_cand": "U2FsdGVkX1+ovJ9itaEMh6Sfigm+8OFIpHYSbXTVL4M=",
    "cpf": "U2FsdGVkX1/hae8zPl1VpGKiS4UQE/WPGmj4aTJcEdo="
  },
  {
    "num_cand": "U2FsdGVkX1+drmLQORyx/ZxZYn12RDo5kMJO93TBUvc=",
    "cpf": "U2FsdGVkX18QWMBej+6bfxqHrqT3n+j4kx1z8MIRaXk="
  },
  {
    "num_cand": "U2FsdGVkX18dOAWvRO5QqRiatwuu49tHCAEw6vk0Ypk=",
    "cpf": "U2FsdGVkX1/8tal5cXAmEL0g8sYxTjm2wemFJTkOlqI="
  },
  {
    "num_cand": "U2FsdGVkX1+7NNCxdMIrO161RU5eMAHGOkhDgeedBoY=",
    "cpf": "U2FsdGVkX18jkJsCm40kLrJ6zARjCLj+OTh6QArkbTo="
  },
  {
    "num_cand": "U2FsdGVkX1/m6jsiQ5Qfo1hsm+bI0GNoxr2NttjzgIk=",
    "cpf": "U2FsdGVkX1+NCrizrsDx9J0Ky6OA/+BYbwK5GeZJ4tA="
  },
  {
    "num_cand": "U2FsdGVkX18finoPlL9cvyR7KY//LyTkFn0XTbHqyIE=",
    "cpf": "U2FsdGVkX1/lpZOFV0iNtp8imWJ+pzFurwyhWBwbPi4="
  },
  {
    "num_cand": "U2FsdGVkX189VCtsKq47xabA6tjxP0630VPkSjUkVnI=",
    "cpf": "U2FsdGVkX19fUX5seabN2udD79eUeLgPKBHoEvMkR10="
  },
  {
    "num_cand": "U2FsdGVkX18xej6kiMORMbRB3B4uqANJhE5QnKvK9lk=",
    "cpf": "U2FsdGVkX18C7IG/iA+eDtAKmAvMHtJDYdTM1Oo+684="
  },
  {
    "num_cand": "U2FsdGVkX1/60GyKPKZbHlMJEiu0j62riOVN3VvcgrY=",
    "cpf": "U2FsdGVkX1+MLWzRzLIjCtGvLOLETO9/hr67RbvA8V4="
  },
  {
    "num_cand": "U2FsdGVkX195JkuVugvPQ5sEsr3cdf9KyWw+bG1dlMw=",
    "cpf": "U2FsdGVkX1/m5QoCkuI3fF70dCt9kmQFz3Aro5ZtwKM="
  },
  {
    "num_cand": "U2FsdGVkX1+WEDY0sUEHrM4xaxt0QupLp3o3h7/lGcM=",
    "cpf": "U2FsdGVkX1/NsgvVcRDbSKDnV4O1HXY7763ba3WgMXM="
  },
  {
    "num_cand": "U2FsdGVkX1/CnwkSFwkSlFt7i+a18yy9mN/lFWCBFi8=",
    "cpf": "U2FsdGVkX19vCLaMVLXS1WMMK/pCW31gO5nz+1aHbBs="
  },
  {
    "num_cand": "U2FsdGVkX185jrU3bBmQcNmVBE+TrJwcjKH73sQYfs0=",
    "cpf": "U2FsdGVkX18QXKMdnyI7FtCAQcOF4tSO/DDFa2HsKUg="
  },
  {
    "num_cand": "U2FsdGVkX1/y5VFkCjwpsNtqIgQ5FF8ohwSy1t40k54=",
    "cpf": "U2FsdGVkX1/8knUTT06DHxaL6QNJ9KHrh/TArTbCIiE="
  },
  {
    "num_cand": "U2FsdGVkX1/FaVp8QAmr71h4+M9WUXUCWcpe8JySYxE=",
    "cpf": "U2FsdGVkX18tBwXHvX7R+tICEQFim0EJvLEmcI99pLY="
  },
  {
    "num_cand": "U2FsdGVkX1+ex18NwabLdv9W8e8fBy/bUaePFQndQyI=",
    "cpf": "U2FsdGVkX19/uhj9iiCsfQ+sPdAlQLhAn53ZtB4UnRI="
  },
  {
    "num_cand": "U2FsdGVkX1/pYGT6Be7bI6uyYaxSlElDEOznqmbX5s8=",
    "cpf": "U2FsdGVkX1+Bk84wQ1SzQ6QEtm902OqaiHRAcLT6F3w="
  },
  {
    "num_cand": "U2FsdGVkX1+OQtW0sHklZ1BW+SAJmSEQuT8Dr/unolo=",
    "cpf": "U2FsdGVkX1+MuWTFdRLqU0oWu0PMCcbHsubRBVqt0PY="
  },
  {
    "num_cand": "U2FsdGVkX1/hk1k8rqBndDNtnktLOLIfudokQ48BdcU=",
    "cpf": "U2FsdGVkX19PeDoxPUHCaQ6GcOnUY02xfnGqz4yjO0A="
  },
  {
    "num_cand": "U2FsdGVkX1916zjcJOw5y01gLS8Cf2GqRlNdzXs836g=",
    "cpf": "U2FsdGVkX18a98OJnP/vBzLc/xxi4p3hBoc4U/JtKgs="
  },
  {
    "num_cand": "U2FsdGVkX1/Ctqod9ahHTysrESzyag86Op1NQK6fJyE=",
    "cpf": "U2FsdGVkX18sinH64BUoSOJpWTtZtLasIFlncHJ9Gt4="
  },
  {
    "num_cand": "U2FsdGVkX19v70gV3eJWYhVuOQrSNic0GE/QYLbR9Yo=",
    "cpf": "U2FsdGVkX18kwTPv5Zg0EyS3XekRJmSp6SrcqUjrXtU="
  },
  {
    "num_cand": "U2FsdGVkX1+shbIHS74azKLn596Ey2kzT/fDmDHWH48=",
    "cpf": "U2FsdGVkX1+KAzRHtbnzFlNuMRCQX0F2U3y6dU1fT5I="
  },
  {
    "num_cand": "U2FsdGVkX18+PtG9PwVYSnVKJy5J4ywZv3NOv8Oqkvk=",
    "cpf": "U2FsdGVkX1/biDG7Ey537aDVBc8SkYlbz/qMXcIE8fI="
  },
  {
    "num_cand": "U2FsdGVkX1+Don/iE7jSVSk8lyoE0u0AQF8Quvhj3A0=",
    "cpf": "U2FsdGVkX18GcF9VK67Itp7HWhjUEulo5+ulMww526g="
  },
  {
    "num_cand": "U2FsdGVkX191sEpGhsKQlnFeu68kyPyKvjk6Z9J38O4=",
    "cpf": "U2FsdGVkX1/8wwUXo2BczdatQhtJil1q9+F8vrdPCfY="
  },
  {
    "num_cand": "U2FsdGVkX1/ThGRS7qSMdIT0HTre1nxxniHsGL3gxbs=",
    "cpf": "U2FsdGVkX1+vOVev3kuWdzXdauWbIlSuhdBDFt20kz8="
  },
  {
    "num_cand": "U2FsdGVkX19SJfij9Eldu9/0M8KUcEYRKXsvHLTRI6I=",
    "cpf": "U2FsdGVkX1+6hX3iBYSC5NGYL29upd498Yz3iHGNly0="
  },
  {
    "num_cand": "U2FsdGVkX1/Yf5jeYjkJ88Gt1WqLslMvkr8rAgbBC5Y=",
    "cpf": "U2FsdGVkX1+xmaTFbL+WYNTviPpJ6wSz5O1r2PzdIN0="
  },
  {
    "num_cand": "U2FsdGVkX1+36N1FmFJqAB3ZKh4C4bITwv5mOhxW+mQ=",
    "cpf": "U2FsdGVkX18tMczvXA/j2v5FteNkzMvjJXh1hhYXbmM="
  },
  {
    "num_cand": "U2FsdGVkX1/5U3PntajDYd29acelOMosIwWKNEq4w50=",
    "cpf": "U2FsdGVkX1+rlO93joflQsJZSA49UE0+G7Gi9COaNv4="
  },
  {
    "num_cand": "U2FsdGVkX19J53TJOkMSxdqC7RrlWij2cQ3oqFyBeSI=",
    "cpf": "U2FsdGVkX1/7mBRhTxYmVs6J8gM9QQWRj7zqwkjmAzU="
  },
  {
    "num_cand": "U2FsdGVkX18mxrCLzNv5CPgIAlVcLHDSrUudmJM7d24=",
    "cpf": "U2FsdGVkX19JB+gJxR5h2Nr2hRfs8Xs0XO2izHHpsoM="
  },
  {
    "num_cand": "U2FsdGVkX19M+1Yx9cjceOVckUICfiSHyNVdAnPU55k=",
    "cpf": "U2FsdGVkX1+3XSC78Fl+VJf7WzTZlhQn3bgJAxqFspA="
  },
  {
    "num_cand": "U2FsdGVkX1+mkjGYx5oBntcqQ3htKI5YBMqMGh4cuA4=",
    "cpf": "U2FsdGVkX19A8iUVaz/yEjk8Rps5giSMmzxfUfbjRY4="
  },
  {
    "num_cand": "U2FsdGVkX192VNxkKRh+iIY1yOK18ILTVhhQevCEIx4=",
    "cpf": "U2FsdGVkX1/zpuBppaBhJfSx41zK8ey0v4+c9s3VoYE="
  },
  {
    "num_cand": "U2FsdGVkX19fMNtxpL+jd4I8AK7Fax0n8IutrMaWc5g=",
    "cpf": "U2FsdGVkX1/RQ3XQkY+15aW3gE9padDU4mgdFKCZGiY="
  },
  {
    "num_cand": "U2FsdGVkX18Gm/wrNmbQBd9fKCihRjPE/omM8N1hUWY=",
    "cpf": "U2FsdGVkX1/dNxpMH4juzChH0Bw0FQuvHPtazXmllKI="
  },
  {
    "num_cand": "U2FsdGVkX19awpVpm9sjYNjSXJ82YZri7h0T8tIAvBU=",
    "cpf": "U2FsdGVkX180MeI+x8yLsehanqIijNccO3yzIkitv2U="
  },
  {
    "num_cand": "U2FsdGVkX1+EtD8XjuPD15RZEdEv7fVlEZPIYdez+i4=",
    "cpf": "U2FsdGVkX1+IJmRAd/nuFuf3cy81G5WI03Gl5jrMhKg="
  },
  {
    "num_cand": "U2FsdGVkX19aeFnF6DAUkXW0TKZI15egQhultizM6cI=",
    "cpf": "U2FsdGVkX1/CoOUwXAMhRT8C70NGfCu1oxly78ITNbw="
  },
  {
    "num_cand": "U2FsdGVkX1/8547kf5NtjISi10jZP01XYQVG3/ARskY=",
    "cpf": "U2FsdGVkX19/cZMR5FfM//Mu911ra23VXmkM3PihusE="
  },
  {
    "num_cand": "U2FsdGVkX1/UzPi1Yr5yBVP4M1PvvYeqJH4JBX5Ou7k=",
    "cpf": "U2FsdGVkX18Q3tyv1Obj0MI9AG+KUGESE31UhE/x9xY="
  },
  {
    "num_cand": "U2FsdGVkX1/emTCsUACYWoe7JOvWvrgaTjKqbI1ZE/I=",
    "cpf": "U2FsdGVkX1/lWI4/sPGk0dfHq6MXV4Y8QHRP/PBKBkA="
  },
  {
    "num_cand": "U2FsdGVkX1+rPCTYVvLcLr/AuYsaHJuKBpUmKFW6R7Q=",
    "cpf": "U2FsdGVkX19ctZHg+ECVXkB8r3OGSUVmW7AUgDOnHmQ="
  },
  {
    "num_cand": "U2FsdGVkX18WMC8crNv2CiXl+oKz2l4oAS5w8Al/5yI=",
    "cpf": "U2FsdGVkX193We9N8zOBbXcwnzOmJDUoiShZPwlgDKs="
  },
  {
    "num_cand": "U2FsdGVkX18X7QPIh1d989a4+6nJAy6BknDocNNw35o=",
    "cpf": "U2FsdGVkX18n6EZApP0Y/v1ztR4fxg772tunC8+E8nM="
  },
  {
    "num_cand": "U2FsdGVkX1/YrEkX1Z3MpUAwcddjJvB8G2hA5TztT8s=",
    "cpf": "U2FsdGVkX19eHQ82WzXtht5fJ/nexUEEUaNlzXtYtek="
  },
  {
    "num_cand": "U2FsdGVkX19k2Z8MwlmJ9ksGnZsCoZqfxYWe2kMwo70=",
    "cpf": "U2FsdGVkX181fA79cIyoFb6I7JJyGzH8jZE1prIZa4o="
  },
  {
    "num_cand": "U2FsdGVkX19zpYh8U66t1izMRFq6mqCbsfCXGs9dctE=",
    "cpf": "U2FsdGVkX1/+ymNWDjlxA3DAfZ2OpuPP0njwEKRXU4U="
  },
  {
    "num_cand": "U2FsdGVkX1/RO/ez9eTVyinuHEAehLdLv88ZHBL9wlg=",
    "cpf": "U2FsdGVkX1+jM0Uv3jcRNSpj/qzKPivvW2IPVdPCsHE="
  },
  {
    "num_cand": "U2FsdGVkX19je/r5QLEHUJ6Xsm74prnAwpQhxfAIEC8=",
    "cpf": "U2FsdGVkX1+PGt4BpDisgVTy9rcdryv+/+9d01ZtEhQ="
  },
  {
    "num_cand": "U2FsdGVkX1+G/MKE1NCmEKbx7/7N7pJMwqWTUOwdijc=",
    "cpf": "U2FsdGVkX1/XklYM7rt6AMN8ofM2y8Fj0JPKp/9Wh9g="
  },
  {
    "num_cand": "U2FsdGVkX1+XrO6oIny8m56J3GAmJsL9xTF9d33G7NE=",
    "cpf": "U2FsdGVkX1/3WBeO8Vr6yTPaGTfFPNdw29M8qDM3EuI="
  },
  {
    "num_cand": "U2FsdGVkX1/aodmoFH2ycun7CKxzakMKa+3s+KbUqVc=",
    "cpf": "U2FsdGVkX19sJeHpaigqM9GWhEyImx0FZdEAS+xl+EE="
  },
  {
    "num_cand": "U2FsdGVkX19350msfcoQtl3PgvgqfzEFtBb3TncbGIo=",
    "cpf": "U2FsdGVkX18jW12WuEck8FxZ4lnU6jXVwBfpv6pWsQc="
  },
  {
    "num_cand": "U2FsdGVkX1/szamFuK11H13DpzcUdgdRJw6nfhwhR0Y=",
    "cpf": "U2FsdGVkX19Rg1WjAr87DVTRKpxtRwsj4TTxIwkhcEs="
  },
  {
    "num_cand": "U2FsdGVkX1+0TZT83ybPjQ6Jd6ZjhBs4O4HPLNIQh5o=",
    "cpf": "U2FsdGVkX18tRRuw9DgUS918PBn3yLEa8XxuwtfN1+I="
  },
  {
    "num_cand": "U2FsdGVkX19Z5cBjYxf+Vlw5sxpq8CodKdE2FyjYz14=",
    "cpf": "U2FsdGVkX1/G8GEuzPFV4WlPtBBzyAIcT7Gf7eJpZK8="
  },
  {
    "num_cand": "U2FsdGVkX18VBwpZeh1OxvkSvUcocJoIS+j0iCnvpbk=",
    "cpf": "U2FsdGVkX1+6aOmil72LOasDL4V0r1eiLtpKSCyUGgU="
  },
  {
    "num_cand": "U2FsdGVkX1/rs9BnLcxFdmE2Pr0NQA30odwNB1EiBnM=",
    "cpf": "U2FsdGVkX185JJJjFw4BWkH61vtOnG2A5qC5OEZPBlk="
  },
  {
    "num_cand": "U2FsdGVkX18aalKaePhf26w8w+N8B/9IKjY9HoFvQxc=",
    "cpf": "U2FsdGVkX18QYDFEAkB8vlaRaVeOzROPJB+D2R77KTk="
  },
  {
    "num_cand": "U2FsdGVkX19N2UeY2XfQ2m4BB8WUwyENofOS94TZGUA=",
    "cpf": "U2FsdGVkX18wjhrOzVI2Xwv5L1inWbJYKkb8daPCJZ4="
  },
  {
    "num_cand": "U2FsdGVkX19b8H2eFEJwbpl/SAlEjVafgdmZ3UZ1CAI=",
    "cpf": "U2FsdGVkX1972OXwsQw0P88QLUhp/QU4lPZQ54OLw3I="
  },
  {
    "num_cand": "U2FsdGVkX1+f1dKR5NTkHk9S0jSa7xEobm8yF+8qJQ8=",
    "cpf": "U2FsdGVkX1+JmIJv2ZY/5kVZIAdoap7MDpSOgisjkSY="
  },
  {
    "num_cand": "U2FsdGVkX1/MRbrv63m5k8xS6RBLF3YZNKPFgTuXh3I=",
    "cpf": "U2FsdGVkX1+QAaYOcS8JJ43gKc7Eqk54jCVxX78IAYM="
  },
  {
    "num_cand": "U2FsdGVkX1/lMObf4sQxVS0E/K1SuBb/eNGc4MSUoEk=",
    "cpf": "U2FsdGVkX1+BbX8rkD3FZJaPYJO39FaAfODEw6zlK1s="
  },
  {
    "num_cand": "U2FsdGVkX182FE2vXf6SnNy8xDy0iw5PVTPCf4cFGB0=",
    "cpf": "U2FsdGVkX1//r3ahE1h18W4eXyM5tkMVZ4YPIcdNHbE="
  },
  {
    "num_cand": "U2FsdGVkX18UjVfwF48ffqlMd1x+L26cBHJyr40cr8g=",
    "cpf": "U2FsdGVkX18T3lQ7TwX1i6XdIvunp+AF/w1mrRjqxoo="
  },
  {
    "num_cand": "U2FsdGVkX1+XLeSU9qAsd7mwux1cskaNkSMmWsHw+CU=",
    "cpf": "U2FsdGVkX194jP4VyWHb4g4PO0rHjuYt7j3BCNKbN+c="
  },
  {
    "num_cand": "U2FsdGVkX1+HxeNB7L9jbq8lReqfPiOke4Sp7Tz+olc=",
    "cpf": "U2FsdGVkX19nT3cYrm0knj7ZfjQ3/MhguW9n3X6yXIg="
  },
  {
    "num_cand": "U2FsdGVkX19GRn82W2TmLfOjx2XlqJ491As3N6qclls=",
    "cpf": "U2FsdGVkX18S8YfZ+bk5Qxlja3I55Unv+NdlxW3sD3g="
  },
  {
    "num_cand": "U2FsdGVkX19eUz2KkiBfEuI919KCxIKmCh+C0HEdFME=",
    "cpf": "U2FsdGVkX18PeyBrwzzfAuPup6XTpuamOGiI9veazdo="
  },
  {
    "num_cand": "U2FsdGVkX1/9XAQeEhvzZTpTZDA7yt5NK6xQZks9jYo=",
    "cpf": "U2FsdGVkX1+st6AcVRPcOrngLywUdeN28X4ghGMcDTU="
  },
  {
    "num_cand": "U2FsdGVkX1+owDfcujiFUT1isHu49b4Im8lSP9kc6R4=",
    "cpf": "U2FsdGVkX1/irtIM4SjVi3GaDJhmBqKCYTv1URuiY4Q="
  },
  {
    "num_cand": "U2FsdGVkX19k7vifQ1XD1L3UoA5sK/rvhyzpsB7AEzQ=",
    "cpf": "U2FsdGVkX18+qu5zuU9uReHrPcKWKkZSsM2oUmE+E48="
  },
  {
    "num_cand": "U2FsdGVkX18B1zZBJCVJlUqg2iaXv3bmasDReWLqPGs=",
    "cpf": "U2FsdGVkX1/Z8lTGh6p0gjy1dREUIvxFedMx1AfjkQQ="
  },
  {
    "num_cand": "U2FsdGVkX190kg7K9HpU4clTAUqeLFTc9I+OUS/BLNM=",
    "cpf": "U2FsdGVkX1/LKMYhT7BvEmVv84ZgffUiGIrQFsgETkY="
  },
  {
    "num_cand": "U2FsdGVkX18VNGyGhGnkr81rQeQIFl/1f398o6dukzI=",
    "cpf": "U2FsdGVkX1+w8xx/vU8Bgo9WRHVJ+nGaUR2CS3a/s6U="
  },
  {
    "num_cand": "U2FsdGVkX1+PHNYYgSKjJ8u3PJWtNL9aB7fgBVROYPU=",
    "cpf": "U2FsdGVkX18Ck85TzjVwsdDxKw690oMJqXsJK6lr3R4="
  },
  {
    "num_cand": "U2FsdGVkX1+dnKs024JONVukbVif39sj7ITCPxZjlTU=",
    "cpf": "U2FsdGVkX1+deET0UQbHFlzt649XhM6HSI/l5WiClZs="
  },
  {
    "num_cand": "U2FsdGVkX18e+milHoakrTWhQ4jAPK4od9PzOxdI1kg=",
    "cpf": "U2FsdGVkX19kq1EGI1y9J9bKWYysaNVP5TC/MAXNSFc="
  },
  {
    "num_cand": "U2FsdGVkX1/ibspV0LSpxCYiWQEUB6Pse2p4s90IZa0=",
    "cpf": "U2FsdGVkX1+93UylP7V291pEbGHRHTvDbkH5WBHP/YE="
  },
  {
    "num_cand": "U2FsdGVkX1/CxqryU+GI6GsoZDrj1Lbe0bFqqYVtHoc=",
    "cpf": "U2FsdGVkX18PpNtfmNHRibZ4DliZLf2z6rJsXU3JT3Y="
  },
  {
    "num_cand": "U2FsdGVkX1+G1YiEgFqvgj3GhiCkyf352FMXxlR5kK4=",
    "cpf": "U2FsdGVkX189dF5Cgc9Y9ZFuBADSmQK1USwcgIPN34A="
  },
  {
    "num_cand": "U2FsdGVkX1/LIiA4lDlIaRa5RaeJhRXRoSxXPQjMoHA=",
    "cpf": "U2FsdGVkX1/CWQKOGl6Xp445uE3DASoiD6KGaGRptQU="
  },
  {
    "num_cand": "U2FsdGVkX18YSSnG1s0ApoTe1yjAbpgW1eY09WA4+yA=",
    "cpf": "U2FsdGVkX1/DSo44CbyjZgUl3hL//klJ8OgXeyVfjoU="
  },
  {
    "num_cand": "U2FsdGVkX1+MUjyt+x/bQzTH9X2rSDUuWnMuxCZpWYo=",
    "cpf": "U2FsdGVkX18cxRQpgk9BdeSe/BYb6b+mCzxLBSrjMTI="
  },
  {
    "num_cand": "U2FsdGVkX1/zxGVeq8qo4vuNm3+VKMVXjgm/K2VMC2Q=",
    "cpf": "U2FsdGVkX1/nZpiYRgDu/gPqg5DRnThfmIFb/aLQga0="
  },
  {
    "num_cand": "U2FsdGVkX1/niiPUKz0eq9c0kR99hCilDoLA8m3rfaQ=",
    "cpf": "U2FsdGVkX1/qPhIACeyVjLHoX8FX0WirMMeuI2EoaAk="
  },
  {
    "num_cand": "U2FsdGVkX18CgTX/VR6UEBQZwNXfEEcQkha8Em0H6vQ=",
    "cpf": "U2FsdGVkX1/eFwJjNPl5xqZxIVxeFbI/0ddLY7OqKsU="
  },
  {
    "num_cand": "U2FsdGVkX19gGC7OreoIHiifVBtCtz7as819zhMONUE=",
    "cpf": "U2FsdGVkX1/rjX3zt/niRTuIc4vkqhRXCWMwY7kYLYE="
  },
  {
    "num_cand": "U2FsdGVkX18crWC9pveWUxRw2hP6ofmZS+th9OTpyEQ=",
    "cpf": "U2FsdGVkX18I3W6UlLJE6TqvHTB36t2zMLpb85l9Gss="
  },
  {
    "num_cand": "U2FsdGVkX1+T7X4k0DDJdCbyj0UprL4pSZDy2wlFCI4=",
    "cpf": "U2FsdGVkX18SLT+bMoUf5NmmhoD7ka3p8txgVqbBMXI="
  },
  {
    "num_cand": "U2FsdGVkX19+e4jlLkZo21pOgohvlDDDym31S+IF2ek=",
    "cpf": "U2FsdGVkX19c+sNfgGYvLwpY2eHXoxnPYOgZMJTT+ig="
  },
  {
    "num_cand": "U2FsdGVkX1+02hcsMuMUrw2l5nIRZtaiW4XpVeHRr8o=",
    "cpf": "U2FsdGVkX19hbs6cAyEguq65ce/MQHXPxVkP3BPlfCQ="
  },
  {
    "num_cand": "U2FsdGVkX19TEXU2ASOWGqQo8ZEEfiUWqASArfbQ1/A=",
    "cpf": "U2FsdGVkX1/4QPbcOkmAqt0wbxbKAXCJA3hqDABzJAw="
  },
  {
    "num_cand": "U2FsdGVkX19XHitYaZ3Su19p1mwEmHWeCtdb1QvFvXY=",
    "cpf": "U2FsdGVkX18O3NGdjAC+UQRTae1YEOBDlOkSDmRam6Q="
  },
  {
    "num_cand": "U2FsdGVkX19IfoP0RvfQDMBlbQ/bOfu3C8vFF9sFsgE=",
    "cpf": "U2FsdGVkX1989PSY+vB2XjY8f0nbYTrPbxLHPW1EU4U="
  },
  {
    "num_cand": "U2FsdGVkX18m/1QdU0pnr0Hr/ZuR/kptWRdeklmda/w=",
    "cpf": "U2FsdGVkX1/CfJdOSoJLoaElb36C1oTYfpAtGhEfK08="
  },
  {
    "num_cand": "U2FsdGVkX1/zhbGZ5BnEgIWUNwbrCY/MJXd301vnk1U=",
    "cpf": "U2FsdGVkX18pfyou+f12Ce6BwJTyq4vAKLFVsc2148g="
  },
  {
    "num_cand": "U2FsdGVkX18P/cEVwtch4ErjhdgXqmAUTicTHDtEjtM=",
    "cpf": "U2FsdGVkX19h0xaKT3VYmXetiQ2YyZd5BSba4cQgwds="
  },
  {
    "num_cand": "U2FsdGVkX19pE4JHvcWBnutzCAPbxOCfUrx/Md9+6pQ=",
    "cpf": "U2FsdGVkX1/8W3k74NSF7u8jmeaf02s4T1m6cqivxw8="
  },
  {
    "num_cand": "U2FsdGVkX1+O3fbUmFCrjACLByo5F8YdSZmzZpTIiVg=",
    "cpf": "U2FsdGVkX19/cuc9aT6EcUOtX6TeSh74HahkQuHOMKs="
  },
  {
    "num_cand": "U2FsdGVkX1+YjwKnLQvTmZVSYwUd3TmC4q1nqICZ1a4=",
    "cpf": "U2FsdGVkX1+sAaj0eOmdDh86sAJz7OxY2ZZht+7qyCA="
  },
  {
    "num_cand": "U2FsdGVkX18bgsxwsPs4+SOCWMzB1vwjXiyF4GYPBj4=",
    "cpf": "U2FsdGVkX1+Vq116nAQ13DjZFOg9WByD4eflLa4HHN8="
  },
  {
    "num_cand": "U2FsdGVkX1+PoN8fvOLNiNQIlEmR9BZXta6wAOcuqjs=",
    "cpf": "U2FsdGVkX181QO57wYcqd3zgnOPb2kS9+MqbQA/k1RA="
  },
  {
    "num_cand": "U2FsdGVkX1//MZ59FTJ7jJT2owlzIIi1aireINnE7so=",
    "cpf": "U2FsdGVkX1/kMAiy8IXBEIwvv3/ZYX8WS7O9i9DoDho="
  },
  {
    "num_cand": "U2FsdGVkX1/bpxvm9ll4vgbaTd+bnsqACxeJAIkP0i4=",
    "cpf": "U2FsdGVkX188i0IuzBmFHSS0Euw10tjK0FxIOvwqMgM="
  },
  {
    "num_cand": "U2FsdGVkX18bI8UPgDtQwW9SHH+Suaus9TdwYNQtClM=",
    "cpf": "U2FsdGVkX1+G6XTOJAWB/Bpxng0FMvvFtbzNbAsl31Y="
  },
  {
    "num_cand": "U2FsdGVkX188q5L2/UnGEZmSv+x4X9aJGbk6JdXryiQ=",
    "cpf": "U2FsdGVkX1/yx58HPTOsBbBtuVI4mG05jGNUNbPrEdc="
  },
  {
    "num_cand": "U2FsdGVkX1/DHuk/L1XVYINXrTgMxUf7H02uEbeAVyk=",
    "cpf": "U2FsdGVkX1+gqRcJYESLDlkhWGXFgy5XW9Hn+8yGlbo="
  },
  {
    "num_cand": "U2FsdGVkX1/3zXSpP7R835+Wjz558w9CllHZPz6yr+s=",
    "cpf": "U2FsdGVkX1+lOcHnsswoo9OOv9OnQofHhaWAIZUMJco="
  },
  {
    "num_cand": "U2FsdGVkX1/1zFkXBdWgcx0jK6Aj1Glrvf5uNFJlS30=",
    "cpf": "U2FsdGVkX1+IedzpId1DplxOqZ/lb7g3PPn9gyvkorQ="
  },
  {
    "num_cand": "U2FsdGVkX19vWzuQ/Y1E6dD99gzyMfvvOkk4jb6RkEM=",
    "cpf": "U2FsdGVkX19MsNHlZxCDhDYuq+CpM6bFQiOFPDDzIZA="
  },
  {
    "num_cand": "U2FsdGVkX19kRdbNwfcXuG84/KmNar7bFGWLKNpy604=",
    "cpf": "U2FsdGVkX18woA2IWj3t3x+NTVm6lJqWELpY2B49i4o="
  },
  {
    "num_cand": "U2FsdGVkX1/K2cMr7jkzT658AAB/aZ6Ww9dwoViZBkU=",
    "cpf": "U2FsdGVkX19WZKYQIW/F6hGlnfpWJ+xFP3oh/PSaepo="
  },
  {
    "num_cand": "U2FsdGVkX1/LiUBgE+fgPFnpo4Hq7FsoBKXi7equQBE=",
    "cpf": "U2FsdGVkX1+DzVvV3A6WXR6vNuD2geGc7O8ofRukkRc="
  },
  {
    "num_cand": "U2FsdGVkX1/jv1Zfy8ouYxrBIGC+SUZFGiJchr2I9ZY=",
    "cpf": "U2FsdGVkX18ddQJRvoNXMt57/MgTE4hTEwpSJqNkA9Y="
  },
  {
    "num_cand": "U2FsdGVkX19pw3h0wJZyTrdW0reuRkMUj2gBqcbtpVc=",
    "cpf": "U2FsdGVkX1/RM1yPVOvyCfgOrFmSZQGdcDgESdXa+1w="
  },
  {
    "num_cand": "U2FsdGVkX1+UJhqaC+pRS+BOEK7x5oJMPQRMH4DGLfI=",
    "cpf": "U2FsdGVkX1/mBSqbR64Ahl7wYp1krEU0viA8VFLiA50="
  },
  {
    "num_cand": "U2FsdGVkX1+qoxKnR6hFA7f7LWn7a5jovzUHY/XpRLY=",
    "cpf": "U2FsdGVkX1+R9M+j/zWhDG7wZT/QCdHzPIZIj2W2jXc="
  },
  {
    "num_cand": "U2FsdGVkX1+nX07bWhxMBAf/cjWN7FOXBLag5CxVx9A=",
    "cpf": "U2FsdGVkX19q6FxiAVLvSNkFyMY3JHr+UJffQK78Ukw="
  },
  {
    "num_cand": "U2FsdGVkX1/GN6+OLnGecl4O042LZ4Hd+nOu7XhpZxA=",
    "cpf": "U2FsdGVkX1/guUsa+EuaAG9T1HkyGsOL7mOZh9xyRp0="
  },
  {
    "num_cand": "U2FsdGVkX192s6O8co/h8NZ33cL3lLoC4E+QsLDe6R8=",
    "cpf": "U2FsdGVkX1+8Aq3AG8MXgaTmACcxLDG8bjO41HnstA4="
  },
  {
    "num_cand": "U2FsdGVkX1+/h56r/HapjVPGQdzhNEynBP8pjqCXJM4=",
    "cpf": "U2FsdGVkX19R0ZPVfJoJh3xxXaiRLqc8Zp1ZG437alM="
  },
  {
    "num_cand": "U2FsdGVkX1+U74u7HYIMW9kzkP8N6qPMQvcP9FxVzTc=",
    "cpf": "U2FsdGVkX19uOeXwHOIubWo3Av+lv23cCDV7Rg3J88s="
  },
  {
    "num_cand": "U2FsdGVkX1/4loM5EDdYK7tNc/wpqLcY9MmobBd9WFM=",
    "cpf": "U2FsdGVkX19pRMrZ0pAtcwq8r/Kzvcjhcjwspr/gioQ="
  },
  {
    "num_cand": "U2FsdGVkX19Mf7MV1rmw1+nzFjqtUSCe2i5NmtiaYyU=",
    "cpf": "U2FsdGVkX18wHif+jSGTSkkcNpT+JahGcXX0hJaVnzE="
  },
  {
    "num_cand": "U2FsdGVkX18ioBG0NhV4ezBhkjOWj3tOsk5m4b80g48=",
    "cpf": "U2FsdGVkX19J9LRkVaQy5bFDRUw991yM0AhGWusQaeE="
  },
  {
    "num_cand": "U2FsdGVkX1/UDwSyLCESMSerlUsfQeT8ZyjMEZU7bjk=",
    "cpf": "U2FsdGVkX1/YLHMd3696WwNCkLZdfUy9tgdV+x6cYH0="
  },
  {
    "num_cand": "U2FsdGVkX1+lzqKegQGUswxFtrgsnUJ/v/YzCqEBTc8=",
    "cpf": "U2FsdGVkX1/9rqpbCZLsb3iDYfra+u5DRerLUvgX9wU="
  },
  {
    "num_cand": "U2FsdGVkX1++CXTnGERlV8AiylpXdcUkoUTaBRseNdE=",
    "cpf": "U2FsdGVkX1+A5ZEgbpj9d+WpgPT24cGmiK7oEEhJ938="
  },
  {
    "num_cand": "U2FsdGVkX19yWI5+iIIbqarr6uHpAqJhwyrnbJKNYVI=",
    "cpf": "U2FsdGVkX19SgMREjMzTAUb5+GX37N1UhT5xWwrME7Y="
  },
  {
    "num_cand": "U2FsdGVkX1+Uq/7OGY79febKedjoFcatck7Hrc5f4jo=",
    "cpf": "U2FsdGVkX19J/U6q9Pnm2zpk2YL6L4uL66qicPbp0Bw="
  },
  {
    "num_cand": "U2FsdGVkX1+ZzEXq78cQCoctsyxqgodGhZyrTsj01sE=",
    "cpf": "U2FsdGVkX18qhoORxnqwtMve2tynC3VdE1XtqrH03zg="
  },
  {
    "num_cand": "U2FsdGVkX1/RR5CcxWHfEcKRjPuJtD4F6F6ojtIW+dQ=",
    "cpf": "U2FsdGVkX19RdNJKUPrOg50mskLlQTqcX4r6FvYrVvI="
  },
  {
    "num_cand": "U2FsdGVkX18+EkkbpbGfU9l1oTIRMpFewipaMDRl0II=",
    "cpf": "U2FsdGVkX19g4pJuOHWIADVEhpbodJrghZ5wuKi42/o="
  },
  {
    "num_cand": "U2FsdGVkX1/OuH0SAN4B70r90ncx8st2y8/XLk6WY+s=",
    "cpf": "U2FsdGVkX1/1KS7X9h1+O8Dj19dODqJTEzGoCM1m0iU="
  },
  {
    "num_cand": "U2FsdGVkX1/T4ksgLwPrR7cn57fZ4VoxCgfV+vPu3ec=",
    "cpf": "U2FsdGVkX1/RefinCg5dxi+56TXSsMY/CG3Gfc9NaR8="
  },
  {
    "num_cand": "U2FsdGVkX19HM3SRNXtPiD4Fw6Sw5C2/tlYLM3GzrDk=",
    "cpf": "U2FsdGVkX1/7iNJ+WgAXAb19WnxBOziZPCT7fedrYpQ="
  },
  {
    "num_cand": "U2FsdGVkX19xvtwx5Mkzoa8a+bd1rNnKW2u99o8dacE=",
    "cpf": "U2FsdGVkX1/9GlVgXEVvTTmou/MKdRa4LWoc7Xaxvmg="
  },
  {
    "num_cand": "U2FsdGVkX1+tDb84m8IK+L0PvTnA0nX+WLqdjOgydE4=",
    "cpf": "U2FsdGVkX1/O/NFHG3rzsbz77xKlhPX2HPazpNJzLSg="
  },
  {
    "num_cand": "U2FsdGVkX1/lSj0CGaSNZF6Xad3Y9xwHl8tsOOkonQs=",
    "cpf": "U2FsdGVkX19NyndK7BvQj98HkgJzV+im6W8JpoDpDwA="
  },
  {
    "num_cand": "U2FsdGVkX19UiDvmZzaWFfh6g92H3+xXkSCO/zYGaXU=",
    "cpf": "U2FsdGVkX18kGifY36yRlAoD+QsGUMWhvYR00HCljkA="
  },
  {
    "num_cand": "U2FsdGVkX18ZqI0a2coOi1LFq3UgbPkQbQ+ZkCtTj00=",
    "cpf": "U2FsdGVkX1+tby0fOfGxImTeMPy9mbuEgnyKvguH8ik="
  },
  {
    "num_cand": "U2FsdGVkX1/JBaN96TZZZGwebmmwRJdRdPbxX36q/y8=",
    "cpf": "U2FsdGVkX18PWx+UAWxYTL6ff0A1hpOtHmrtNixULR0="
  },
  {
    "num_cand": "U2FsdGVkX19amwiCh7R+Kswa8p56VV8lwpmB5CHeoTI=",
    "cpf": "U2FsdGVkX19cmRttVNkGPGLTzk4Ju8dLmAw4WSm8/Tg="
  },
  {
    "num_cand": "U2FsdGVkX19mo3R5PpKyqfxL8l6Y7+eiIhUu14sRPKk=",
    "cpf": "U2FsdGVkX18urcFRGXkUjaF7t7HID7+zeeK8wr1/zJc="
  },
  {
    "num_cand": "U2FsdGVkX1/ILyHe9JiAA35tqPi9WMUqCxbt5hccoJw=",
    "cpf": "U2FsdGVkX1/u/RS7MdLuwfeAQYkYn4o0lv+Z2lao8tc="
  },
  {
    "num_cand": "U2FsdGVkX18bevYJYC8Iu8kGunBlaO3pWHf0ZxHMFtw=",
    "cpf": "U2FsdGVkX1+EDLPXTQlVQg8gyMirBSBTWk48cx7SGjM="
  },
  {
    "num_cand": "U2FsdGVkX19asl13yWoBpEax4ra1kBiX2dAqM2mI6Eo=",
    "cpf": "U2FsdGVkX18/paTwQHgaHtpR/6tJSuFBrNcVxv2YaxI="
  },
  {
    "num_cand": "U2FsdGVkX18shFh6vyHQ1ZkaHZjutSmgUmI0Mp0nNyU=",
    "cpf": "U2FsdGVkX1/u25uzDZedGsWducMMEBnB0+iFStg3AeA="
  },
  {
    "num_cand": "U2FsdGVkX1/a5t5lXTBPZ1qfBbOivhPuZg2e6fwk4u0=",
    "cpf": "U2FsdGVkX1+ttDyNw6bLeU7mf1X2xSks9yflejw/o5M="
  },
  {
    "num_cand": "U2FsdGVkX19FVw/SZZC4sFIOt3zsxvmMX4SmHbNmkIo=",
    "cpf": "U2FsdGVkX195akw+NKUnKAh7MERoabTVxQsy1ZlgxLo="
  },
  {
    "num_cand": "U2FsdGVkX1/9lte5eEtCVAxE05xEgOZ0bN8aKxf+xJI=",
    "cpf": "U2FsdGVkX1+xNKUOy/GaghyEC77XZMEzxWGJN3WTN9I="
  },
  {
    "num_cand": "U2FsdGVkX19Ea3mstwf5N5ccGlB6aMl1zxDhR5MAqmw=",
    "cpf": "U2FsdGVkX1/nq2fK6XDfNaFcdOr/7mlXCxskZoksDdg="
  },
  {
    "num_cand": "U2FsdGVkX1/wfMhwT/ZZnUEawrgUGLAnToPjyujgXmA=",
    "cpf": "U2FsdGVkX1/cmbxg+vEMSwIFmRTTkJ0Ko8rrAOIxpEk="
  },
  {
    "num_cand": "U2FsdGVkX19nnZWeCUCymtGU2BUQg4hY6SsQNmSblOk=",
    "cpf": "U2FsdGVkX18WqwobHcoZ+Lb0hMsUvhpc8E2KXcpGYNI="
  },
  {
    "num_cand": "U2FsdGVkX18iyzrE0qdjHkV9eNBQ7t1JVd4F0WRCWHk=",
    "cpf": "U2FsdGVkX1+WvsYXXZTa7PzV/zIiMHx0eiBROQq5Z6M="
  },
  {
    "num_cand": "U2FsdGVkX1/fnmSK58cNOy0aPds+gQ9LfYgICoyoLMQ=",
    "cpf": "U2FsdGVkX1+h1AwjaiLoNykUNWF7gpogfzsE+Rbf+zY="
  },
  {
    "num_cand": "U2FsdGVkX18nAPHE6iIE1iUD2rqjPwlZy/euAz5Y8V8=",
    "cpf": "U2FsdGVkX1/HmLAG2e0WDF/Abku2bavSwkJTbAWXQcY="
  },
  {
    "num_cand": "U2FsdGVkX197EeZ4NLaocICgheO2lbg4/InlbyG2t2M=",
    "cpf": "U2FsdGVkX18Pe35FbMq8qqfbyd/3GX/eY/Duqhc+lhg="
  },
  {
    "num_cand": "U2FsdGVkX1+dSYWRRclVV0RszBQKvaxm1H5Je0uKtsg=",
    "cpf": "U2FsdGVkX1+4vxX9YD4MXlnfUYsHi+5v6/kHmAmnDMI="
  },
  {
    "num_cand": "U2FsdGVkX1/WBh6qcw0aTIulpqlGsRj6Y1NyGgdwiH0=",
    "cpf": "U2FsdGVkX1/5U91SiaU1bzrA6Y5sruhAFt0Rt7xc3s8="
  },
  {
    "num_cand": "U2FsdGVkX1/tuJqjbvBQeUIzdLPJ/1mHpYS/oZOjk+E=",
    "cpf": "U2FsdGVkX188PqrbjY4iOY0PagVTamCMhv2oLc8UJnE="
  },
  {
    "num_cand": "U2FsdGVkX1+ZQrlpn4dfZY2JDQobrbn7WA3/G7H9+gc=",
    "cpf": "U2FsdGVkX1+jc4YxKub2KztwaLWpSXw5U3grxR3o1IQ="
  },
  {
    "num_cand": "U2FsdGVkX19pCtZ/YG2w84HgwL+lSaIi5R1wC6zwpbo=",
    "cpf": "U2FsdGVkX18tpB3gvp32byEl8QyGyg37bwQKRSDgBo4="
  },
  {
    "num_cand": "U2FsdGVkX18nT41pp/5isXPWqPd/1fQf3J+haqqe+NE=",
    "cpf": "U2FsdGVkX186P5W1Al7iOt20VA1GiEtIBuKu2Ni1qS0="
  },
  {
    "num_cand": "U2FsdGVkX1+A6rUhEqQ3dR2Ws8uVfA+jVUFboFzynnQ=",
    "cpf": "U2FsdGVkX1/pSGInAaI4qpGNVaga7lgyp6fIj4yV+7U="
  },
  {
    "num_cand": "U2FsdGVkX1/sgM0GcHR2QzSUtEVROdGChnGX43dmJ1c=",
    "cpf": "U2FsdGVkX19sA9CJtEMY0IPzaQs7SaUL0fMyQbdJRD4="
  },
  {
    "num_cand": "U2FsdGVkX1+SyhjYYnv0lineFRZCKiSddhZ3sdeXlEY=",
    "cpf": "U2FsdGVkX19zVwqygl5FRbu30OwepxWN7RwM1cWuH0I="
  },
  {
    "num_cand": "U2FsdGVkX1/Yf3lS//QrkplOI5uc11MZzLbf6awkCG8=",
    "cpf": "U2FsdGVkX18p4uN9XzUMMuUA6MpXJ1w4DEmoGKGfbS4="
  },
  {
    "num_cand": "U2FsdGVkX19w/MKZ3J22C83d8nm/jrE2cM5s34e2ANg=",
    "cpf": "U2FsdGVkX1+dp1xSOLAztX8W2cZY0tIX00yRAQUGBA4="
  },
  {
    "num_cand": "U2FsdGVkX19NoirxDKXxoW3jKimeF0kymYO/g8z/9XA=",
    "cpf": "U2FsdGVkX1+yzKX/WZGZ7u4VhVAktDfPwzYe244HVGE="
  },
  {
    "num_cand": "U2FsdGVkX1+Gey4IYsHlUr6kUXLTokPAMfAiDgDagew=",
    "cpf": "U2FsdGVkX19aMHMjibJ6cYmqrdczD8AZ0+j1VZmWut8="
  },
  {
    "num_cand": "U2FsdGVkX1/H0B1ySAofrBHSbv0w7K3jP5BvKfJ5wqc=",
    "cpf": "U2FsdGVkX19DpnMQXnTLEgmr0dWS1vo6jrPOlWUQIYw="
  },
  {
    "num_cand": "U2FsdGVkX19Wb+JkXCF2Xht2j4/+oVuM3/KDRwDeS+c=",
    "cpf": "U2FsdGVkX19z3J/euz6GMxXy2RkS3GqnazmchezhL5o="
  },
  {
    "num_cand": "U2FsdGVkX1+R1KiRBj13y+xteqULNO2zHBoIHyvyBjs=",
    "cpf": "U2FsdGVkX19rlefpHSX34GmhHpTkfEZdydM7rVocAxk="
  },
  {
    "num_cand": "U2FsdGVkX1+IE/YDB1MHlzG+JBE7fy0OzCp8cJGACvY=",
    "cpf": "U2FsdGVkX1+LWNf4TEcK5GCKoAOC7DSANkfwxHv+IO4="
  },
  {
    "num_cand": "U2FsdGVkX18EB2noPnvgluEq1ey9SgYhsXLfti5GvqI=",
    "cpf": "U2FsdGVkX19jdwtdnG7s8sA4cnPik3LwHhQHHiHm5sw="
  },
  {
    "num_cand": "U2FsdGVkX1+eBHOI47ozDWZWK1QIwZK6eB5tncb91G0=",
    "cpf": "U2FsdGVkX18KsrujcJhc4uA1t3vWX767wY/62DDz0rY="
  },
  {
    "num_cand": "U2FsdGVkX18xmnfpHKOCUQQJ1y52Ypo6R/1kAj7Gi08=",
    "cpf": "U2FsdGVkX19Ybxw53ziXcekoAl4CB2OckH7+MZmBT/E="
  },
  {
    "num_cand": "U2FsdGVkX19XUYrMcrSbBzqCbz4oQn/z3llUyWdhN+I=",
    "cpf": "U2FsdGVkX18sCiJDFZoO88/KcG/wQWtdNvnUvurTkaU="
  },
  {
    "num_cand": "U2FsdGVkX18oOqr/JW757rXCMcq8EcmXMiLHswK2K+g=",
    "cpf": "U2FsdGVkX1/baweZayOzSkb2jQUcKCTJRnngEns24H8="
  },
  {
    "num_cand": "U2FsdGVkX1+KDsz+cP+8zO1Zhv2/q/AZtoTTN4XSfCg=",
    "cpf": "U2FsdGVkX1+dFqedgupniqfZ/Yo4v2ysEZOby/CjEaM="
  },
  {
    "num_cand": "U2FsdGVkX19uOU5QUkGriN31FQju2dq6svL7w0SmhHw=",
    "cpf": "U2FsdGVkX19ZatajoadTDSw4TccuAzlKGCeDVu+UTa8="
  },
  {
    "num_cand": "U2FsdGVkX1/rX3r2pST+VwDy3lbl+2uyogXewlzREoE=",
    "cpf": "U2FsdGVkX1+IZx1veDLLxBCKiwS0ox9DzFe1pY9xvcI="
  },
  {
    "num_cand": "U2FsdGVkX19xTYkr77pqQQ5QK0SW2ryr/Tq013QoXPw=",
    "cpf": "U2FsdGVkX1+yjDtmO9kn4h6Ipab4glVOGx73DK9yRrY="
  },
  {
    "num_cand": "U2FsdGVkX1+b8VzfNOfydxsyQVeOVsAxIkyXNo9fUK4=",
    "cpf": "U2FsdGVkX19clNcFenNmOwPsnqzZE0DI+ik86+JYjhE="
  },
  {
    "num_cand": "U2FsdGVkX1+NY/o3tr7+NNaehLQq+1dB27k51BXGp4c=",
    "cpf": "U2FsdGVkX1/W3lg1QHI1c/kgK3LfVBNU+ieAxaiAdRg="
  },
  {
    "num_cand": "U2FsdGVkX19OmZ0cbgJOxc6r5TcQqWJxbwjR6uN5k3k=",
    "cpf": "U2FsdGVkX18ZbkHIU9Lug5cyPUFDinouyAC/Zs+PWNw="
  },
  {
    "num_cand": "U2FsdGVkX1/zYmIQrXHjInDyOpJy8LXAD79q1N856as=",
    "cpf": "U2FsdGVkX19OeR/TArgEX1MuLOgWWaLR4fuivrTHV5Y="
  },
  {
    "num_cand": "U2FsdGVkX1+XZmVYTYQ0ZF5ZJRWdwzYqNjfParRQ+VY=",
    "cpf": "U2FsdGVkX18jUqqh/bRfZEu3tJMknMNQMV3zEELk9Bw="
  },
  {
    "num_cand": "U2FsdGVkX1/u8GgQQOUS8eu7iboq/1i4Ju/iQu35iJ8=",
    "cpf": "U2FsdGVkX19m/+yt9mkKlKO4UrDQP6sFs2aoOtsXI74="
  },
  {
    "num_cand": "U2FsdGVkX1/h9a9RwGZvj3GoR96dMttRdARNvzTURKA=",
    "cpf": "U2FsdGVkX18+M5J/fiW5AGiW6/xiri7xpLnmvs/VuN0="
  },
  {
    "num_cand": "U2FsdGVkX1+9aQyIORZkOTg/6ANOLAnEhEcwngtzzR8=",
    "cpf": "U2FsdGVkX19salgjbwHSeuxqIkpatm2+rnOjUGxJIOw="
  },
  {
    "num_cand": "U2FsdGVkX1/wSvVecHJzslAlA9WzmZFxTSJs2ZblDlo=",
    "cpf": "U2FsdGVkX1+W/5rrRo/WqB1kmjefmf5rMS2lRe8Ci/Y="
  },
  {
    "num_cand": "U2FsdGVkX1/pN2gmuSZOAfYSLQ8YgRBh5fr8ZX/DAVE=",
    "cpf": "U2FsdGVkX1/s12thlzaL4+dGht6iprdBh278Vc2GCzg="
  },
  {
    "num_cand": "U2FsdGVkX1/zdPrl9b3Yu/X8E4A/SD1We8Hdfstlt4Q=",
    "cpf": "U2FsdGVkX1+c48lx8L4WxTm3tvy1kbUoRcko42Nq50E="
  },
  {
    "num_cand": "U2FsdGVkX1+6jDjQFoGkD2Dpo7ERbSXjcJRjnR6J/m4=",
    "cpf": "U2FsdGVkX183nxjuhXMZyRgYsj1mboukboxM35ByxPI="
  },
  {
    "num_cand": "U2FsdGVkX1/BlwlSYS4rBilsd3VKiDR3nho5Maukozo=",
    "cpf": "U2FsdGVkX19Q0b6f70BCgy+Bg0ObOGClqtUS5psJXa8="
  },
  {
    "num_cand": "U2FsdGVkX19QNBoZEuUf9xfwElg85Bz5+b44RcLgQ8M=",
    "cpf": "U2FsdGVkX1/AnOMZF6Z7zIxFxz+omE754Vr4i5u+cgU="
  },
  {
    "num_cand": "U2FsdGVkX1+QwrrkLeiDi0D5VL7e6zFVaMTCgqE8GRc=",
    "cpf": "U2FsdGVkX18x6Og7XA1YbNXVmvgfEHPvye+qXTPj3bM="
  },
  {
    "num_cand": "U2FsdGVkX1+NQhKWUMgd9jHsk74J5DP0t0HYv5kKcsE=",
    "cpf": "U2FsdGVkX1+d7omrYBEOefla/W4CneKarJbEZKW3avI="
  },
  {
    "num_cand": "U2FsdGVkX1+PO72Ov9QmXJQdqWNuEkhUFOzAuk5ikGA=",
    "cpf": "U2FsdGVkX1+IkBW+5FIsRC2ggS7aXf8aIwCzndz4vbg="
  },
  {
    "num_cand": "U2FsdGVkX1/HTI27K6YjFsFa29BisRyabnvR5QKigik=",
    "cpf": "U2FsdGVkX1/oYFKDyR4RMpA97L7X4gjgmHmj4b7x3C0="
  },
  {
    "num_cand": "U2FsdGVkX1+Hq6azVVnsOtgnC7qRlqlKYaYlCT6fOAA=",
    "cpf": "U2FsdGVkX19D5n4f1SQwkE+CBgBon+deSKMh+R5ClME="
  },
  {
    "num_cand": "U2FsdGVkX1/YbIUz/Y1qUDBHsSdWQBOuJLhr71skIto=",
    "cpf": "U2FsdGVkX18FNmPscayeEQFyHzKZZo39Jh9XfIt7GRI="
  },
  {
    "num_cand": "U2FsdGVkX1+RBB+YnGwxjpI0hEPVwVCjNmhc6PxtOkc=",
    "cpf": "U2FsdGVkX19c3e/qd0xG+7uQQ8ZHFLDDDN+UZ49xBbM="
  },
  {
    "num_cand": "U2FsdGVkX1+1ew2dG5EKValr8JfYC4uHqLRvvlREoOY=",
    "cpf": "U2FsdGVkX1/cLG81kyxAIHZV91K0imqRahRaL+GYPb8="
  },
  {
    "num_cand": "U2FsdGVkX1+f4UKupkZdOc6NcFslHYrzItpvV0gP4D4=",
    "cpf": "U2FsdGVkX1/DyhwxvFK6EjYPGbzMUqG4Tz30G8NMEyo="
  },
  {
    "num_cand": "U2FsdGVkX19AVPsyOCfTL+x5yYSjd87fgcwZrFkDlP4=",
    "cpf": "U2FsdGVkX1+1QooxYOiKPUbvUk30UlCwcVRIILirORI="
  },
  {
    "num_cand": "U2FsdGVkX1//lPaRFyougCDBYWdtLUNVUzDQyyBlMBM=",
    "cpf": "U2FsdGVkX18CWQGeoa1zFHUB7ku28UsowzSIt/U7Tko="
  },
  {
    "num_cand": "U2FsdGVkX1/2CBwnzF4/xRPeKFoWichOCcM3da95d2E=",
    "cpf": "U2FsdGVkX1/qfwtiXqyqY4kECIM3IN/RLd0lGKWj8tA="
  },
  {
    "num_cand": "U2FsdGVkX18cqmtAPYLTE87brkCfH9aZDEwbw56D7Rc=",
    "cpf": "U2FsdGVkX18zITBDEvSVdZPFRlu1wdIlpN9uUOdy4lA="
  },
  {
    "num_cand": "U2FsdGVkX1+iGcG7AzAowr6o/6zP7ruT25V55rXMehQ=",
    "cpf": "U2FsdGVkX1+MdnKawrOiH3bpzJ0wIgJUKzuTYhOwoz0="
  },
  {
    "num_cand": "U2FsdGVkX19vxFVuP+VLIdYgTsEyh19mXY3ig90BX3w=",
    "cpf": "U2FsdGVkX1+rajsjCyoJEQ0Bq+agW0YmoMg/CHNWv8M="
  },
  {
    "num_cand": "U2FsdGVkX1/k/lzj942G/SN8E/8qy62FJ9Uikxqlwc4=",
    "cpf": "U2FsdGVkX18w/dbLxM91gelYDCT4rMSLorqy60/jzRk="
  },
  {
    "num_cand": "U2FsdGVkX18dFoOHXlTkajQ/+189koAlcnP67j34qm8=",
    "cpf": "U2FsdGVkX1+VLsL1pxPUaC+02SAh/zifFREIi093/pY="
  },
  {
    "num_cand": "U2FsdGVkX1/fUvf/mEFFurOlZ+JuOSJQBMeic/H4+18=",
    "cpf": "U2FsdGVkX1910G0l9+7y7L9Po0Rrferr45Qrvpu0+w4="
  },
  {
    "num_cand": "U2FsdGVkX186y6H+fx04NgIhyP4j+rAxqay3hrUguoo=",
    "cpf": "U2FsdGVkX18rP7562wmKD9JfAghg5h3ObsxhnEoIom8="
  },
  {
    "num_cand": "U2FsdGVkX188wznmHkXtLGYJ1i6vdfIJGeqMi7WBOUM=",
    "cpf": "U2FsdGVkX1881strgSD73K5vbNKHe1yuX8GVUodaKMM="
  },
  {
    "num_cand": "U2FsdGVkX18yTDCuB0gpM5sLhVB4LQrV/J94AztxKKQ=",
    "cpf": "U2FsdGVkX1/vawZSqgolItg/KSOKnjfatCKZ+pUIpcc="
  },
  {
    "num_cand": "U2FsdGVkX1859XsQIoNaaSmBLWpRGek9pHzXzho0avY=",
    "cpf": "U2FsdGVkX1/NhXTNVpHUJV6q7Kw0rXpLPOdvPFupvxk="
  },
  {
    "num_cand": "U2FsdGVkX1+5gbZjdaNu3057KZ2c+NAaSKeIcs7LtxE=",
    "cpf": "U2FsdGVkX1+/FZC/cegf5YhkoDf2fsiVKA9xVwGJlpA="
  },
  {
    "num_cand": "U2FsdGVkX185fa2w3hdaR5XYAUSQ2004zRjfJto21lE=",
    "cpf": "U2FsdGVkX1/2tMBCq+PfqBgw242Kz0IOeU7Fa3hCNbY="
  },
  {
    "num_cand": "U2FsdGVkX1/js5qufZY99bt4mDnyvos+ZAtwLljjLoA=",
    "cpf": "U2FsdGVkX183bCGRoiYdSV/w2RfhRglm3HYGgSeONQY="
  },
  {
    "num_cand": "U2FsdGVkX1+Q1VHALV7cj8HQj2G0Me2K1IjrEvzIUFY=",
    "cpf": "U2FsdGVkX19Q94nHO3FZF+0RJRFfg4HBhBYkITHhVc0="
  },
  {
    "num_cand": "U2FsdGVkX1/kSxnC5wrTDPtRSvmcFYaGSvLCfqYtxak=",
    "cpf": "U2FsdGVkX1/GGuHuKqwhswpnBB7ZIZrQZ/QhbH1dw8w="
  },
  {
    "num_cand": "U2FsdGVkX1+VOt9KE7y10kKRxXJ+Eo7dyv7/LhQzPVg=",
    "cpf": "U2FsdGVkX18wgY9kHIt+5ieSc2d6tZdIBa4ETdzjy54="
  },
  {
    "num_cand": "U2FsdGVkX186FeOAQPaUG+jBsHMDwaLlQcLHwRxZ0Vg=",
    "cpf": "U2FsdGVkX1/T54wYL4Ws0Mxmu2cVutxHbzDe3eY7Sxc="
  },
  {
    "num_cand": "U2FsdGVkX18Qmcq6ahQcD2RCSDMVlUCoAXGnNHLHgHw=",
    "cpf": "U2FsdGVkX1+QxrpOPh9cnCrnjIbB0M8CZXWh1vtZ90s="
  },
  {
    "num_cand": "U2FsdGVkX18Ia6QWo+hxxvAEhdn5XIIHLJlr0jWO1C4=",
    "cpf": "U2FsdGVkX1+PMf9sYa4YMKbP/KajDa2CKQB+B+fOl6A="
  },
  {
    "num_cand": "U2FsdGVkX1/W+HeYNlLbNGxCebLjl3MsFJQ9sPKFpP0=",
    "cpf": "U2FsdGVkX18CrDAyeHetmzNvsK+l9oBKXHBjgbgDPFg="
  },
  {
    "num_cand": "U2FsdGVkX1/IqRwXI/pEjYoIztCygEjejK4JYJsj8I0=",
    "cpf": "U2FsdGVkX1+chwQjY6DERD/TszN6ihXrFXBruPM94hk="
  },
  {
    "num_cand": "U2FsdGVkX1/3B1ji5lVSqepfwKgx99Ef7+hfmNrKJg0=",
    "cpf": "U2FsdGVkX1/FUqpKhG2GLsQkVxzQuCH8c7DH9jsTOvk="
  },
  {
    "num_cand": "U2FsdGVkX19DA+tJ5GOAuZhcM3kND6ybArNRMJ7CZd0=",
    "cpf": "U2FsdGVkX1+fNrBM+JW6GspeoH96v0n3qXvtLckpMjo="
  },
  {
    "num_cand": "U2FsdGVkX1/rMiucWGHwSkwC+FAODc/ANeh2ZJ5NwgQ=",
    "cpf": "U2FsdGVkX18nY+k1anTwSYEFDx9BkGEdlFv/5ZuHQTc="
  },
  {
    "num_cand": "U2FsdGVkX1/odSnzxzuhzcTUr4Z+syzw4EoUm+RRgxM=",
    "cpf": "U2FsdGVkX18fW9C5nHNf+Hguuc6XMmFklQk+H4ybwTY="
  },
  {
    "num_cand": "U2FsdGVkX1/bFnma59F8cr3NeuHJuZnsqplV2s7oq6E=",
    "cpf": "U2FsdGVkX18JrG4dXvHXawqrk1Ln71tAbEwD8zkRyhI="
  },
  {
    "num_cand": "U2FsdGVkX19ZZcIKPVDjT4u3qfe9goKy8u6gf4fNwPg=",
    "cpf": "U2FsdGVkX18RqbrcNssM6FeoVBcJND+f38sRCvmASwI="
  },
  {
    "num_cand": "U2FsdGVkX196wEtFQ7xMqTbmj87LD041+QQ0FgipNCE=",
    "cpf": "U2FsdGVkX19erMnM/TKYmNwGMqbf1xmwNO83o2TXyX8="
  },
  {
    "num_cand": "U2FsdGVkX19Z7RtZhxzRoE5NMLeRI0CFauPisdluXwQ=",
    "cpf": "U2FsdGVkX18Qp2hZ9fhA54mpgu0y66gV5aiHDla+N6g="
  },
  {
    "num_cand": "U2FsdGVkX18K8tjF6B+7wuQshsKcFjUt5t+AEkth9Y8=",
    "cpf": "U2FsdGVkX1/3FJCwFTRdV9HkefI4FU/ubY3ISkWRqHI="
  },
  {
    "num_cand": "U2FsdGVkX18QI5W1jD6BCNbRck8hmUZ7Ah/6AvrZ5fs=",
    "cpf": "U2FsdGVkX19UJU7WN++zeNZ/P0FyOjrh0/NhNedrDsY="
  },
  {
    "num_cand": "U2FsdGVkX1/IUWFul5oxxXWzBHkpDped45nG5DOqTTI=",
    "cpf": "U2FsdGVkX1/XsY0DhkogEvzxevbppZSVu0njDHvknMM="
  },
  {
    "num_cand": "U2FsdGVkX18uuMttGK/ZeDB5ugtJoZahiZmUvyprlTw=",
    "cpf": "U2FsdGVkX19ijyaRmKVfxYk+fnMLMxf43DvDzl8bsA4="
  },
  {
    "num_cand": "U2FsdGVkX1+0QZYsNg/rBGfZVQjxed5bpDqtIEos5oI=",
    "cpf": "U2FsdGVkX1+jO20qgjdLmjYXO/m5K4HjmAkOBZBp8ZA="
  },
  {
    "num_cand": "U2FsdGVkX19e35V0TYly6Vn51sDZ2kjkYR9VVyrqOyY=",
    "cpf": "U2FsdGVkX18HTM8A8IlSSLN5NMYg6Ym+VCV3TnxTp3k="
  },
  {
    "num_cand": "U2FsdGVkX1/reF1X7X7DQq+sL5PdIgXKDs5myLvslTo=",
    "cpf": "U2FsdGVkX194Uu1QedU0mWaQlh2nmatHlqJXaQkDBGQ="
  },
  {
    "num_cand": "U2FsdGVkX1/tEYZcgF0bb20zySxTM5snQxCB3Rqi1d0=",
    "cpf": "U2FsdGVkX1+/0lpOwbFZGSxplaTLp9LfDMKr5Mf/ZZk="
  },
  {
    "num_cand": "U2FsdGVkX1+W3TCV5HJ08lKvb7bJ/hP+4X9RQJqmfLo=",
    "cpf": "U2FsdGVkX18FXvKCikpe75/kOYCb36mUdXVJIqYo9Ww="
  },
  {
    "num_cand": "U2FsdGVkX1/L8jxWz1+Bpo+DVpqZPkG+Kh+w/AqJE1M=",
    "cpf": "U2FsdGVkX19/Wzkxj9YL2Kboc24TcELW15l0OaTfAi4="
  },
  {
    "num_cand": "U2FsdGVkX1/L9yIIpztNr3Mb8R+XLFhV10JVuMKiwCE=",
    "cpf": "U2FsdGVkX19u1gzGWZvgD1i/xiRU6pj/OYVruWXUSdY="
  },
  {
    "num_cand": "U2FsdGVkX1//JiTiW2ZisCpkSU2RMHRmagTH3Qhn6Jk=",
    "cpf": "U2FsdGVkX18yIRaGa/aSoqQwCqWTUV0mxnhi/a2RFvM="
  },
  {
    "num_cand": "U2FsdGVkX18aKw08D1eNjMjsaZW52Xp3wzaGWxurkTw=",
    "cpf": "U2FsdGVkX18ovBCMjnujw8+sPAbaNHqRXKK9QxaFWjA="
  },
  {
    "num_cand": "U2FsdGVkX180jUM6Xq3sK1P+bPRH+yCIPjy+sBlspU0=",
    "cpf": "U2FsdGVkX18d7tBzWDKQFMY9heK6BphgEm/BQkj/grk="
  },
  {
    "num_cand": "U2FsdGVkX18loWktR9ZFrf70EYwOw3plUp9YrtqBjvk=",
    "cpf": "U2FsdGVkX1+7bCYa7cyv4IPCvu+C/9CZJiUGWfU6VYc="
  },
  {
    "num_cand": "U2FsdGVkX1/thxSyMWfY2BjUbZhkK2jGRh3gEybH/Fw=",
    "cpf": "U2FsdGVkX18HoQWf2LkuKucuK8up4DZqaoBO6t11wCA="
  },
  {
    "num_cand": "U2FsdGVkX1/YljVNcZ+beR2+k509Tj4WiOmRuxbZXfo=",
    "cpf": "U2FsdGVkX1/m1ow7o8oihsOflqe4VoxaCS68MmDxzsM="
  },
  {
    "num_cand": "U2FsdGVkX1+amKbHNNAiKwRWqjduMxYf8UnEW/kCtiE=",
    "cpf": "U2FsdGVkX18W07UIcwZlW5PUpc99944PqZo/hNyybgM="
  },
  {
    "num_cand": "U2FsdGVkX19AHoGVSd/7NnWP9qNKyN4rrfbCqERNIBc=",
    "cpf": "U2FsdGVkX1+zKPOHpIA0/qq9GaRq8bRQItBPRwOfA5M="
  },
  {
    "num_cand": "U2FsdGVkX19cMfSs7GVWlDaOEJGpoiyG04zahdUhobg=",
    "cpf": "U2FsdGVkX19jzy88zz2au5hrKXX9otizAKh1SLUlZmI="
  },
  {
    "num_cand": "U2FsdGVkX19KcRZWt/uHE8qLSm8deBzIRsQXPi6CDVw=",
    "cpf": "U2FsdGVkX19ftx/oJjt+ChF30cQOk9+is5bvnj6uTA8="
  },
  {
    "num_cand": "U2FsdGVkX18mbOrDWQcDBIs8QPGFQQeM0MG7Wfs3wAI=",
    "cpf": "U2FsdGVkX1/Ox42+x2JvhUWIPS8pHsffOgrgRMGDJ/I="
  },
  {
    "num_cand": "U2FsdGVkX1+R/PiE6VTlOllX8H52oBJ7cdS/OozYzBE=",
    "cpf": "U2FsdGVkX1+qmEett4DQZnJfw7Q1Ng7cLDCAaQ702RU="
  },
  {
    "num_cand": "U2FsdGVkX19RZLEe4RmBswpWfXoDXs3qORzFCNe16RY=",
    "cpf": "U2FsdGVkX19+DVUJhxOkGQPym8PPNPtp+5Mh5+PVzMo="
  },
  {
    "num_cand": "U2FsdGVkX19NAtNU2EV8U9P8HCwS7L93gIj12c4gUpc=",
    "cpf": "U2FsdGVkX1+ShrwH4vT8gHqJ7+6v+aVV3tHU05ihfjk="
  },
  {
    "num_cand": "U2FsdGVkX1+HvSDQsWpqxZ33g4hz+/5couev5ztTGwg=",
    "cpf": "U2FsdGVkX1+cAJ19d9N2HcHhT2h7uJ4JzK2Lb45cTXg="
  },
  {
    "num_cand": "U2FsdGVkX1+dm3ka0B3JN1Hyxz5OkvkDTM6N3FAC0fM=",
    "cpf": "U2FsdGVkX18RbaD3wCg9V98VMCjokrCUNpqS16XSPWE="
  },
  {
    "num_cand": "U2FsdGVkX18cChJDwa+9xKrmJE0qoKonn66AoXvYZIk=",
    "cpf": "U2FsdGVkX1/mqmyIgljxMiXoLaxEiTYFf27FrUy6Gr8="
  },
  {
    "num_cand": "U2FsdGVkX18F0I9XBW7Eq9WTe7XbQYV7jJNrBehxxwQ=",
    "cpf": "U2FsdGVkX19RbT51kqrkGZzUq8MgyR6uU4nD+YckLiw="
  },
  {
    "num_cand": "U2FsdGVkX1+v2XOU0KyrX6HNDxL4qmxtCRfgQN0cFo0=",
    "cpf": "U2FsdGVkX1+pI7uZtnY40lzFOq+xebyk56H2aOdq/7E="
  },
  {
    "num_cand": "U2FsdGVkX1/sdCjF492Wsp8NBjKqe/sBCKq+O7QhCww=",
    "cpf": "U2FsdGVkX1/GAmCOQ7a3XKtM1zwORD237FtFQPx0OJ0="
  },
  {
    "num_cand": "U2FsdGVkX18M/rsh8azG2ONgJdz70Vk/pgAPhUseU0A=",
    "cpf": "U2FsdGVkX18YC68XQ99/LBX0sjncrWFnLQryJBJ8AxQ="
  },
  {
    "num_cand": "U2FsdGVkX19lDQPaAb4NhVtiqZHDUypbxJ7dUpJmZy4=",
    "cpf": "U2FsdGVkX1+PbwTjA7z27g9zEW04ix7pkEUWHqszCKQ="
  },
  {
    "num_cand": "U2FsdGVkX1/1c3ijLoJOqiEUoboSs+YZP0DMU9fTqRM=",
    "cpf": "U2FsdGVkX1/pDHRweewEcjWO28suhP6egCm/nO4Psrc="
  },
  {
    "num_cand": "U2FsdGVkX1/7bzywz1PGqSDd6niVbjPvcAdoy9nKoLg=",
    "cpf": "U2FsdGVkX185JYBO4xfmUWrcCgmBHTCiiNTeWlxQ5vA="
  },
  {
    "num_cand": "U2FsdGVkX19naF7qjsydbvh9OOE31e7kGbxCAcb2HHE=",
    "cpf": "U2FsdGVkX19ip8wQRUvHp+b5y444TAkcrn9zx2WUsdk="
  },
  {
    "num_cand": "U2FsdGVkX1+wgib7stMODODJs92b1Im+YmikYRK1n8U=",
    "cpf": "U2FsdGVkX18QrkN+kfNDJPvaCpAi/u/D4JtiCxhLjf8="
  },
  {
    "num_cand": "U2FsdGVkX19SZJP12ByYtqtDMDprAEyTFXHGQ4BqvY4=",
    "cpf": "U2FsdGVkX1/uTkcAEKS3PLKr6FRiVZUoj1FnBUGNrkk="
  },
  {
    "num_cand": "U2FsdGVkX18UkWWzeeBhmYAUiIz6f08u++myy1z6f7M=",
    "cpf": "U2FsdGVkX1/NUMLxBTrbKPUEguX9QH1Vt0TzNFqmt8c="
  },
  {
    "num_cand": "U2FsdGVkX1/t0WtL87wtaKula8o8fqDaqDUD/uKjVtg=",
    "cpf": "U2FsdGVkX185P1ZLxdoTo7CmuUrVBJO1fxGSwyQRtqU="
  },
  {
    "num_cand": "U2FsdGVkX19d17RcQLg/Y2nCe5w2WzEq2WDakbpqjzM=",
    "cpf": "U2FsdGVkX18ECJWrti63amZS4XDWbyzerRhRoYJsbb0="
  },
  {
    "num_cand": "U2FsdGVkX1+60/2Q2969oJqKZjQXSVKlIAL2o1usplY=",
    "cpf": "U2FsdGVkX1+D8M0kHbNmtD62vGe8eLovh6ekmsOFimE="
  },
  {
    "num_cand": "U2FsdGVkX19m2rl/ichTGuf7QmMR0QujFNkMTzFvKn0=",
    "cpf": "U2FsdGVkX1+6z57TyAbFRx1saWD9mIpaH9XmaMB2NPU="
  },
  {
    "num_cand": "U2FsdGVkX19RoS9fuUotAyQHr2j9VPkd8xRrCL6VgR8=",
    "cpf": "U2FsdGVkX19k3QpkZjEYt4SbYksu5OROrPxFVXIQBuo="
  },
  {
    "num_cand": "U2FsdGVkX1++PV7E2ejSbtE1II7Rk7Ch5Wk+TyZzWMk=",
    "cpf": "U2FsdGVkX1/InCSG4kp3dZZ4hHZJcbDTMIJYCMPYots="
  },
  {
    "num_cand": "U2FsdGVkX19sO9JGLDAvKdBPtQdjb7hEK4wEUdB9wtE=",
    "cpf": "U2FsdGVkX19PmAlk+hHVJ1un1IRM1aJaIYwVH6kyR9M="
  },
  {
    "num_cand": "U2FsdGVkX18JOO/giN4ulq5eUi7+Nk0ARradsWZRdHM=",
    "cpf": "U2FsdGVkX19KnZTXnUVW4DT7IIBI/ozJ4WUj7L9dvrQ="
  },
  {
    "num_cand": "U2FsdGVkX18/cDW18VOV+LMRS/N/o2kNhRU9iirGbI0=",
    "cpf": "U2FsdGVkX19G0n87VKkKBx6GSaEfP/2Vd3fCh95NEAo="
  },
  {
    "num_cand": "U2FsdGVkX190u3bq3LLY1lE7+k7WP0r0+KyyjdQOnLw=",
    "cpf": "U2FsdGVkX1/5xrFLOezJbbv0mdjJW/dJihyejkPTD0s="
  },
  {
    "num_cand": "U2FsdGVkX18QsLed/4FdqwjoD8PFbKLwAXsMl4FrTsM=",
    "cpf": "U2FsdGVkX19L6aI3vOp2/S4LHWRqhxWyDo9h2QNhlfg="
  },
  {
    "num_cand": "U2FsdGVkX18e4Yx8//gMxw7/9mPKggS1mQCUvGyNY/s=",
    "cpf": "U2FsdGVkX1+ezNYUvsP7mJH0BF+f1wDqcgL9R0tlSK8="
  },
  {
    "num_cand": "U2FsdGVkX1/47bpM8ABqf25zqCqRNO1eteninoLqpXM=",
    "cpf": "U2FsdGVkX19/vYZerS8Y2ov+bwGNNzKHkDpSv1cKLuM="
  },
  {
    "num_cand": "U2FsdGVkX1/PRdF6jnHhFlcQNtbk1z3JJcdz9WK8x4A=",
    "cpf": "U2FsdGVkX19LRbYwj/2LBzM2wR9vgVwj6E3ppBu7pvA="
  },
  {
    "num_cand": "U2FsdGVkX18/1aR5L7u+WTPXcUA8b4crEXc/Emlc+WA=",
    "cpf": "U2FsdGVkX1/oqvVjnYdXq3ULEZ1tem4iw4S2+4eYKdE="
  },
  {
    "num_cand": "U2FsdGVkX18udtTpriPy8hc7Jl9djt5KPlybqmBbrAk=",
    "cpf": "U2FsdGVkX18koWcb0DQ49YsBd0y+cRvWaHPuP4kj7g4="
  },
  {
    "num_cand": "U2FsdGVkX1+UvckGChfWHkTizSYw7Fe79qfFGmQUT6Y=",
    "cpf": "U2FsdGVkX1+rqxoH8dfkHFwXslxLTumSPnaQ2/UBQFo="
  },
  {
    "num_cand": "U2FsdGVkX1/qKB40Lmx8sJ8JMBHCM+29IQ1VX2sbgdM=",
    "cpf": "U2FsdGVkX1/QKgY5W6CZKZ38gEjtZZgBPg21whSvTuc="
  },
  {
    "num_cand": "U2FsdGVkX19wmHw/7LABpq0pfsI4UhjPFHIg8FcTMJs=",
    "cpf": "U2FsdGVkX1/A1EB19/x76m6pB289AD4bjnBP9XT3qk4="
  },
  {
    "num_cand": "U2FsdGVkX1+8DVYbY8asGrbg5IzgZExSBHa75Q9lGu0=",
    "cpf": "U2FsdGVkX1/3S95vpH/6Wjkcyk+gbo3H0wvOiyBCwLI="
  },
  {
    "num_cand": "U2FsdGVkX18ITDvDh8vLJLHuT8SyBV2YnQSkrCs8D5k=",
    "cpf": "U2FsdGVkX18c+boMsyklG4MM3+Vl0oqRzg0T2kVSiJs="
  },
  {
    "num_cand": "U2FsdGVkX1+IDN2D2vzsLz8ymFthgLdmGenXdUDgoM8=",
    "cpf": "U2FsdGVkX1/YzjgBdEhP/MbZ0IOYDAQFMd827SIHcJE="
  },
  {
    "num_cand": "U2FsdGVkX18KJqkUybwOsDmJ18p1MDzKkbpjjLzq4n0=",
    "cpf": "U2FsdGVkX1+roiGqWOIXh6MU23k6oQyDh1cu9f+8MG8="
  },
  {
    "num_cand": "U2FsdGVkX1/jvMmgsnK1lhSmE02OnuE+1tFHONXI2EM=",
    "cpf": "U2FsdGVkX18Tz5I5aD2A8aQDngBK/Idq++B1bEApRlM="
  },
  {
    "num_cand": "U2FsdGVkX1+qYiwdcXn3gXX9GDVMM3zWnEpepFC6J6Q=",
    "cpf": "U2FsdGVkX183Zq6F1hcglm6MzGl86iH2z95K3dlqhzs="
  },
  {
    "num_cand": "U2FsdGVkX1/zLyWsETS6CDd4GW2mhmwsAYknWCYUXr4=",
    "cpf": "U2FsdGVkX1/dpkouh46TmqyeTcqgc0IxwDTKrc6eOkQ="
  },
  {
    "num_cand": "U2FsdGVkX187XwJpaeosEB1KP6JD65U6cVMxLkCwMnU=",
    "cpf": "U2FsdGVkX1+XWaoIb5L36S/6Ac6UkGkAnj57JJ7CL6I="
  },
  {
    "num_cand": "U2FsdGVkX1+OIScFi/VSyg110KpO8CRHpNah3mwsazM=",
    "cpf": "U2FsdGVkX18KVpkgW4NbeYh3lmfS9uU0Zo74S7IjCak="
  },
  {
    "num_cand": "U2FsdGVkX1/UJwi43292MpRICqaYuHuDXweHc8IX86E=",
    "cpf": "U2FsdGVkX19c4PdVzd7Jo2ZtMZQrQTgySjtsbgXAeEc="
  },
  {
    "num_cand": "U2FsdGVkX1/bsOeTTg7YdR9KisqTy1ptIjWFeqq2f/M=",
    "cpf": "U2FsdGVkX1/Rh/WIw3QHnRW3FYGwD13/hHliSF+JnXc="
  },
  {
    "num_cand": "U2FsdGVkX1/jSg6zJJfFNvNBoBqm3rw/jfNgYxeNVDA=",
    "cpf": "U2FsdGVkX19/AWpzqwmlMxmbk0IOSJrIb08jbGfKaYA="
  },
  {
    "num_cand": "U2FsdGVkX1+ahyA57nosckZltxftzWAEZCY5B5HBJFM=",
    "cpf": "U2FsdGVkX1+vFIigtY9Hdw6kaVTDtAfmZo7wWs5vSPQ="
  },
  {
    "num_cand": "U2FsdGVkX19snrL1ioLSmlR06EUo3sXEo9ZA9bla42M=",
    "cpf": "U2FsdGVkX1+Ks29hPFZw4D6FgxoFt4ns35xdkfdTJ5A="
  },
  {
    "num_cand": "U2FsdGVkX1+vdkmsL0BtZm4qpvWzYmPmS1TzqeaIOTM=",
    "cpf": "U2FsdGVkX1+sZ14vt6ODnXIgYDa30wg+yugGfNt6thA="
  },
  {
    "num_cand": "U2FsdGVkX18KB7EmHKdkTkhSrdmpU737vircMOHxouo=",
    "cpf": "U2FsdGVkX1/FhdwUlqY2lyhv1EqBFplWnH+KyE2Xf24="
  },
  {
    "num_cand": "U2FsdGVkX19J/k+10iR3LjJJknfknOaiEAl0VYpxE8g=",
    "cpf": "U2FsdGVkX1+zlIv3dCeTAkfIRmVuyiqrBqHEpMNOyvY="
  },
  {
    "num_cand": "U2FsdGVkX18wvVg6mY9XVFU29QI6ZiO1T0AdHUiH6Jg=",
    "cpf": "U2FsdGVkX19SjMesjm3fxXelnrjXr95+betPTWrZEc4="
  },
  {
    "num_cand": "U2FsdGVkX1+au7/VzLxSoepPh5KkQDNyP6E7/UjbGg8=",
    "cpf": "U2FsdGVkX18J0scFVThviemCZjQCjzt38xNMXaIhdXY="
  },
  {
    "num_cand": "U2FsdGVkX18n3+j974NbS2lZ5E6n5wZtiJbQj/XVagk=",
    "cpf": "U2FsdGVkX1/LvNTRDy+sD18TIpkovEe1tRKJ7U6Eb/g="
  },
  {
    "num_cand": "U2FsdGVkX19kLJMmH/T6p0KnII7IlYaXMMGbCviiVm4=",
    "cpf": "U2FsdGVkX1+PWn8bfdub3jsUF9bX6zvsfVa1WkmfX+c="
  },
  {
    "num_cand": "U2FsdGVkX180bUC40Qzk0C1E3vvQ8HCgGD9ZQaQup0Y=",
    "cpf": "U2FsdGVkX1/1/mVisyEGeclXoA2PmxIQyP0Zz7++fs0="
  },
  {
    "num_cand": "U2FsdGVkX1/5X5znnyiatvBB2vMGSA0OquOdZNcqD1M=",
    "cpf": "U2FsdGVkX192pmI8MrTN8p6xJhnePI+fH3NiyRDbx+A="
  },
  {
    "num_cand": "U2FsdGVkX1+vRuvWRH3PkBy4ef/R6+Yc7uGg28CzOd0=",
    "cpf": "U2FsdGVkX18AhVIj2ttodklCwTeQIEx9/jHOASfiMVw="
  },
  {
    "num_cand": "U2FsdGVkX1+yQqqFsyBfwBxQ7ufNhK6fESlb7YSOXjM=",
    "cpf": "U2FsdGVkX182uq3i9Nk4g+vYGVxfr78prv9J1pzrgDY="
  },
  {
    "num_cand": "U2FsdGVkX19A85wzDlkN9hqUBiO9UngJ9HzeV/nknps=",
    "cpf": "U2FsdGVkX1+8z42uINyqW3w8MPoPgfvf3PMRjaAN6m0="
  },
  {
    "num_cand": "U2FsdGVkX19LOOBGsVq0adx73lBwAiRcTroPhVqRg6Q=",
    "cpf": "U2FsdGVkX1+DMDJnBWBJJeBdA1iPsGFCEnVIWxD8/d4="
  },
  {
    "num_cand": "U2FsdGVkX19jyRjU1OMBpLS9ajo8WSCS4JvUh6Xr8qI=",
    "cpf": "U2FsdGVkX18jjK81EXX201jdrz5lHuDfJ4Ly6TH3UCo="
  },
  {
    "num_cand": "U2FsdGVkX18w8oxfgsTM1VeqtPkffprec2aDVwJx3Bc=",
    "cpf": "U2FsdGVkX1+5343AbtQ0bw1uqiaxdA9dumH1+ICDiTA="
  },
  {
    "num_cand": "U2FsdGVkX18kDLMARD6bM3HfzPcM2PXJ17Uz8fy5mcI=",
    "cpf": "U2FsdGVkX18RQ7mjhn7la1bWz5WiAF/mZgax5ZPitjI="
  },
  {
    "num_cand": "U2FsdGVkX1+KAKxavFdW3bXAi5Zn6qDfeGT7cFTRQhk=",
    "cpf": "U2FsdGVkX19x37Ncbv5JCuQ8mfDDu7PwR5720WPhUQc="
  },
  {
    "num_cand": "U2FsdGVkX1866RbB8UvctZJq421yAUjIPZ08GVEjwBk=",
    "cpf": "U2FsdGVkX1/D83//dq2Sk+km9BHLb7Kmj/QgwvawDgI="
  },
  {
    "num_cand": "U2FsdGVkX1/30rSKEcvtZTuKEXXg8q6WO0EWMSzIGHE=",
    "cpf": "U2FsdGVkX1/Se+9vFZRZ2dRkue5spaStqp8xfutoVg8="
  },
  {
    "num_cand": "U2FsdGVkX1+boNcODb0LfXRr6pNvPDZqfP1B0FeMay8=",
    "cpf": "U2FsdGVkX18okb6tSMSawFLOao5XR2uqU+M4+snXntY="
  },
  {
    "num_cand": "U2FsdGVkX1/qJA4pQlo/SPBXrf6hZW1pHHDSjg1SxgE=",
    "cpf": "U2FsdGVkX19CiiyLk9pcL5fJ1MGxNvQbekfH+yFqryw="
  },
  {
    "num_cand": "U2FsdGVkX1/R2mYGsN2mPgdne+2jcH7bAq6V9Ai2j5c=",
    "cpf": "U2FsdGVkX1+9yasDvOC9mGjkxqJ4/2a/MavL6vBmQ08="
  },
  {
    "num_cand": "U2FsdGVkX1/J6IRcgVp36RiAhg1cMMtMx+w2h6fhAyg=",
    "cpf": "U2FsdGVkX19TAGLwaQ/YtnEL9wSIVrua/8tCnSXfuHc="
  },
  {
    "num_cand": "U2FsdGVkX1+8EdaKbGzWTxt+X4yGsFUuT+2RMwFPuRc=",
    "cpf": "U2FsdGVkX1/Pe5ULONMH49TVWT4y6a59XfzdBhOJ14Q="
  },
  {
    "num_cand": "U2FsdGVkX1+H4tCR2Y/1mmMaSyj/rWRNu0SCshxuemQ=",
    "cpf": "U2FsdGVkX1+iwVDqe5h2vMcmFCYUJZTNiRMQfF0iOMU="
  },
  {
    "num_cand": "U2FsdGVkX1+iUh29C1QxuifYVBSaYpbG16a/1IhBMuw=",
    "cpf": "U2FsdGVkX18geYhXxnTYOtlmmeUxSRJXHzdsN9PAqxk="
  },
  {
    "num_cand": "U2FsdGVkX18zpj1uMx5EGa+pXpLG/u3sitiLFd9WBpk=",
    "cpf": "U2FsdGVkX19UGt8uxzcSuOLKAYW5YEKbP5NcDTcso3M="
  },
  {
    "num_cand": "U2FsdGVkX19GLvpEz47Mcw4amJHVcYE6Zjc+/CgOdIE=",
    "cpf": "U2FsdGVkX194bSsfXqkvcb0bXgkvIIX3YhegSKKnlXs="
  },
  {
    "num_cand": "U2FsdGVkX18RwHfkmvlN21k/U5BQNVPTck1bUw2aHKk=",
    "cpf": "U2FsdGVkX1/dDcNMXDhe/Oe/YshA86IHsLvLIOJKU88="
  },
  {
    "num_cand": "U2FsdGVkX1/FDEA5fzJz+/9gN7PEGQtAYyQEDBBh/Nc=",
    "cpf": "U2FsdGVkX19yfHqL8V725sQJiX59O1Bzi0QIymhAYsg="
  },
  {
    "num_cand": "U2FsdGVkX18HGBSBW/OTM0LAYMz8LBhZsljt9XA2lnI=",
    "cpf": "U2FsdGVkX198MLerGY+ajUAKTPrO7xVBXEy4LjpGqEg="
  },
  {
    "num_cand": "U2FsdGVkX19V78GHH7UZSTe8g2T66N2cxLhnBSycAtg=",
    "cpf": "U2FsdGVkX194AnUuK1TCvp9Z4MrUguN0y6CU5PlaA+c="
  },
  {
    "num_cand": "U2FsdGVkX1/NuJXf9cOOYciNjsI0DXhXGLmUCvBtp+E=",
    "cpf": "U2FsdGVkX19mzy/sX/GGB+NLZLpFWCdNYsIAr3Fobks="
  },
  {
    "num_cand": "U2FsdGVkX1//imZIKTJtC1t3UxPDz8LxtG8D5iJ11I8=",
    "cpf": "U2FsdGVkX19AkYoBoeky1ieic1oPybp5GWNcclnxDaw="
  },
  {
    "num_cand": "U2FsdGVkX18NyXECIwf3tJ2HpVb3Ue7jkhzn9QzibaA=",
    "cpf": "U2FsdGVkX1+HIsLUiDwcLeodCqS8bqE9RWd/bOr3gAo="
  },
  {
    "num_cand": "U2FsdGVkX18hBdh7rJdsTiPQDC8Tq3eijnplk4ffwQ0=",
    "cpf": "U2FsdGVkX1+T0hELN23JJ5LyYhNLNuPLYUsuSyVyPeg="
  },
  {
    "num_cand": "U2FsdGVkX18tXGFAUyKa/eK4iwqUVwBK9kAUtsCyqNo=",
    "cpf": "U2FsdGVkX1/cvcZudVbT1c0aeouLd1SjCzk88KpI53E="
  },
  {
    "num_cand": "U2FsdGVkX19gghSQaMQYtwXJdJuvpkL1KGPQILWrO4s=",
    "cpf": "U2FsdGVkX19owd7ZKUfm65uQkmbVRwg7UgW3HByO6Is="
  },
  {
    "num_cand": "U2FsdGVkX1+t9Jpse4cL4Vs+T/m2YyMn/FlEVe1XivA=",
    "cpf": "U2FsdGVkX19S8AlIBF1bDvkR++x+vg2bi1lbQ08jSbU="
  },
  {
    "num_cand": "U2FsdGVkX1+EKn0c5tB3dTEFypeNndhfKrk7oKF4d/E=",
    "cpf": "U2FsdGVkX19yii1XbsJj+qmkAWCnWEqrUJ9Dz2gJYN4="
  },
  {
    "num_cand": "U2FsdGVkX1+o5AbaYEPNOkrbQfADtPzJpcFRB5cRq3k=",
    "cpf": "U2FsdGVkX1+r0syghbmXhXMRg43E7m8cYqqE85spNRs="
  },
  {
    "num_cand": "U2FsdGVkX18JI5kvykTb0NdeImvEWIPI62oToy/UJEc=",
    "cpf": "U2FsdGVkX18Jo7R/ZFIoYeexxXgIMYaWQxe91Vqi85I="
  },
  {
    "num_cand": "U2FsdGVkX1+LaJYZ2JRwOpB6K8wYJTsifbLdtxaBFhM=",
    "cpf": "U2FsdGVkX18Xg71jUnn6Y8B9XHujUcuTgUY2Cs+biDA="
  },
  {
    "num_cand": "U2FsdGVkX1+qFW41Y7EoTm4uvM9hTwpecEwLuugG5pQ=",
    "cpf": "U2FsdGVkX1/UI1JnWsdo+2rNpk6q7dU3I5kDmSq7Aec="
  },
  {
    "num_cand": "U2FsdGVkX19Qhvm8UuQRhTZy+B3UfA58OYxtYL4rvKs=",
    "cpf": "U2FsdGVkX1+r+WBLHM0Zhk3C6IILYO28KfQiYpnH1ZM="
  },
  {
    "num_cand": "U2FsdGVkX1+yKS+s9xeFxAe0npcEZGOgkbXkIhTJxm4=",
    "cpf": "U2FsdGVkX1/hGgL4FzL1rjSJnkEzMBitrvmdNslISIw="
  },
  {
    "num_cand": "U2FsdGVkX19vxlXHGgyGD19fIlX5EFt+N6E7mbRwHtc=",
    "cpf": "U2FsdGVkX18hXxP/o8MI2ug2rCveuyXnq1FTtXWFHPc="
  },
  {
    "num_cand": "U2FsdGVkX1/6B1fv943U7xeKRVuOlR3ytNaINKFQu6w=",
    "cpf": "U2FsdGVkX19hTz/nLVKPjGBwvXkBvzLQzV35pTrr8dQ="
  },
  {
    "num_cand": "U2FsdGVkX19O/T6okU0Y4JV0VG2t+3FtL4uwTPCoYps=",
    "cpf": "U2FsdGVkX19j/oj4k7e3rdbjJQWEfE0wxgGcjJy63DA="
  },
  {
    "num_cand": "U2FsdGVkX1/LdFtf4yZDP8MZM4v5o34Y1d7iaXxuRrQ=",
    "cpf": "U2FsdGVkX1+9LGQunuMMvd6JcgW93gJO3x2IR/VHjpI="
  },
  {
    "num_cand": "U2FsdGVkX1+VAlnIeuKNSPs+21BqxOnuirjACQ13roI=",
    "cpf": "U2FsdGVkX19motBuieXJ+YmKjB+XFpCqYOu/irmXQ9Q="
  },
  {
    "num_cand": "U2FsdGVkX1+P2nQ5FCAr7cZCWn0ecolP82wgxqSQjnQ=",
    "cpf": "U2FsdGVkX18z1r15SRa/67/97/+qE3ENnko31ziMFjg="
  },
  {
    "num_cand": "U2FsdGVkX1+KFiFZ7hjo6nInv/SXA94KH5ZNxXtYgFI=",
    "cpf": "U2FsdGVkX18eJuOjzlx9nxgnTn0VuRWnJ0KGRsVAcIk="
  },
  {
    "num_cand": "U2FsdGVkX18R/fFVAq2cdQYWdqDUbO7AST7sBRe4ECs=",
    "cpf": "U2FsdGVkX19DeJk0JiHvA4D9UXWjGTFzY6HfQQTIyYQ="
  },
  {
    "num_cand": "U2FsdGVkX18KM/klWNxdLknjHGErrMWy/77xIRo72z4=",
    "cpf": "U2FsdGVkX19R4Yc2xeyqit/C9C8H9n+f8O5k5uYBUl4="
  },
  {
    "num_cand": "U2FsdGVkX18bSFw+5UP0IBUhfEo1uJbeCd6el9PG9A0=",
    "cpf": "U2FsdGVkX1/VPaUJQfOfhpABcrFdMuC6vd2LluP6W98="
  },
  {
    "num_cand": "U2FsdGVkX1/IsgQMe++dwgO86DB0yZgyf0uW4oAPOJw=",
    "cpf": "U2FsdGVkX1/mFOIcVcFWLp+VnjlTiL7tQtijxnufRQM="
  },
  {
    "num_cand": "U2FsdGVkX1+BBeSrT51H1H04n7LQr/4+ZAa60CLjXHg=",
    "cpf": "U2FsdGVkX18lQ0BpCmN+KyLnTaZeFoiwmpdTbGLhBXQ="
  },
  {
    "num_cand": "U2FsdGVkX1/+68PtMboazvqtQClu5/mBoc9J2fy+EGU=",
    "cpf": "U2FsdGVkX19KGgYrYg+XhPOuJt5dHkncMMpytmcbBXs="
  },
  {
    "num_cand": "U2FsdGVkX18BCSOTysC3MeGsfi2Mb1NzT4l7SIqMAQA=",
    "cpf": "U2FsdGVkX1+dnKtr/Ef4XvGq5kJ/4gmEQ9bQUh1Rg1I="
  },
  {
    "num_cand": "U2FsdGVkX19Hv6kZub5V8muDJ3sYMef7AJa1kPr/vyM=",
    "cpf": "U2FsdGVkX19chIS3zjoURCw4NIIvjqSY1mTZ4MPLZbM="
  },
  {
    "num_cand": "U2FsdGVkX19+6nbjuHmz6zL++Hglxi/V54b4UhuPOow=",
    "cpf": "U2FsdGVkX1+x9bCCZpHn8ta1RqZMdCKXuFtP/QF0lJA="
  },
  {
    "num_cand": "U2FsdGVkX1+Bhi5mIpinPLRx/4sbjNaVdM1GEWACEx8=",
    "cpf": "U2FsdGVkX1+xQUIsmCjiSsac4KW+s7biPDoP84ssq+k="
  },
  {
    "num_cand": "U2FsdGVkX18MjFsvHOe6Vg98/Ry72aQg/ZnSshefhhg=",
    "cpf": "U2FsdGVkX19bYeupejWy73jXhT3aMaHFVrrGIVp0tLM="
  },
  {
    "num_cand": "U2FsdGVkX1+WfYL+TjjtnJu7tZFPUj/YeXJBrlg5cq0=",
    "cpf": "U2FsdGVkX18ZxI9oY7zV3X+Mca+4ATeRyCJ3KrMOFMY="
  },
  {
    "num_cand": "U2FsdGVkX19MEpOs1DK7xvUkKhIkH7520YG9UNc+LIM=",
    "cpf": "U2FsdGVkX1+9OkMBZfNakLIBVSuor2CT9BMajfXdNUE="
  },
  {
    "num_cand": "U2FsdGVkX1+dRAm4KiF+GZu8rDUvJ37DwkLt837bYuk=",
    "cpf": "U2FsdGVkX18tqJTRqgIZmjGJsMoDUp9WEpDGmaaauQs="
  },
  {
    "num_cand": "U2FsdGVkX1+R0hHezLJg7T7NwL9bYqsrywmCdOnAehU=",
    "cpf": "U2FsdGVkX19yGf69lYcmEUb36VUgRdFZZab0CcV8Uu0="
  },
  {
    "num_cand": "U2FsdGVkX1/c7FDmJCn0n3TkpS/8pLkJBT9YaJ5tFZ8=",
    "cpf": "U2FsdGVkX1+s52hcKjlWImbBlbKunT1JqyAbfZ/tmLs="
  },
  {
    "num_cand": "U2FsdGVkX1/bqwNm040qdOiqL8dSbZe/hUs3u9Ufvic=",
    "cpf": "U2FsdGVkX1/r7s/2YdmTy0/XkJHSRK2FmXgzj8o+W/c="
  },
  {
    "num_cand": "U2FsdGVkX19OWleuATAa2zXeNY/gfd6p1Bwkc2cRySo=",
    "cpf": "U2FsdGVkX1/4C54CQV/OK7yNbkM4xmgnGvLoAwcn9UI="
  },
  {
    "num_cand": "U2FsdGVkX19W4XqdsTdOVWCMqyxweYKAnrlUa3tZNWw=",
    "cpf": "U2FsdGVkX1/elvE0FKDD83fOLeLnPNAASNiCXQWYI68="
  },
  {
    "num_cand": "U2FsdGVkX19ZEFRiZf556RSTw7KKBq64DPJuicYnXZk=",
    "cpf": "U2FsdGVkX199R3y5BDKus3+aI+JZW9Fao8M+k8Xz+TY="
  },
  {
    "num_cand": "U2FsdGVkX1/Iyu2hX8O94X4RrqybtOsZJrW6BeX5ZQo=",
    "cpf": "U2FsdGVkX1/bq4U1rXqKn4aZ4sq76jmkn51SwOewGEA="
  },
  {
    "num_cand": "U2FsdGVkX1+qtSfUWyhVlu3hDGMNCqKL8pgLddIhz1I=",
    "cpf": "U2FsdGVkX1/H/vPKDEqxAmQ8LV/588SneMxcdec4n7U="
  },
  {
    "num_cand": "U2FsdGVkX1/1o5tiSrYFHAkX4k5RyyiiKXAnYYiD3Tk=",
    "cpf": "U2FsdGVkX1+ZO1DFWkyX/ZAL8bXhu8rxL2B+J+VflH8="
  },
  {
    "num_cand": "U2FsdGVkX1/zZVRrbHGAKEu+NlgkiHqRY6KFVVFnzCs=",
    "cpf": "U2FsdGVkX1+dGFJJN64Dsr+DdV5uJRIExkqPU46Zkk8="
  },
  {
    "num_cand": "U2FsdGVkX1/lQKriyZYyeEFKkCR/8tw0Fx2WZkjc1fk=",
    "cpf": "U2FsdGVkX18HbDQq38pPZX+Ac2gVQmCEqfnqYPJmCwk="
  },
  {
    "num_cand": "U2FsdGVkX19cGkT+0p2KdjOFxlC8ILACLRtAKT066IA=",
    "cpf": "U2FsdGVkX1+D8AvV0L7DULfucvUj4KFfnwh9QaOqoE8="
  },
  {
    "num_cand": "U2FsdGVkX18BED6FLR0HXTYEmcrWqHi318AsR2HhPOw=",
    "cpf": "U2FsdGVkX1+Jd3H7I96vHI9yXklW72CK+gfshDlVxpw="
  },
  {
    "num_cand": "U2FsdGVkX1+DSYjwy3/YwITI5LjDYS1J6rVL8TG23v4=",
    "cpf": "U2FsdGVkX1+1nlAHaIk7JFhSEKonaJuVFa0rfp9WZOM="
  },
  {
    "num_cand": "U2FsdGVkX18kvqwarIupTGd26Em8Ihg6h+r2WlrqcdQ=",
    "cpf": "U2FsdGVkX19iAHBUTTSmbOZEbAtVX8asMnGEX3vyhjM="
  },
  {
    "num_cand": "U2FsdGVkX19Q9JYxTWD85KhkBw1iRoCWqxQwdbvokGk=",
    "cpf": "U2FsdGVkX1/s1gNKsCr0XiRBCj23Pae5reR7pmJZxpg="
  },
  {
    "num_cand": "U2FsdGVkX18v7TZpBfPPDBf3VG89AomMXA0uPpoi8h4=",
    "cpf": "U2FsdGVkX1+A0ljmTVWwHtq49ljy1SZ/8vxnXtrqX1I="
  },
  {
    "num_cand": "U2FsdGVkX1/0PmEaUfmUzszWYeQ3Uc1JiJWi2Y5Bjgw=",
    "cpf": "U2FsdGVkX1/t7OpZ9nlIa8BqOioOTXx8PheXmm8e0hk="
  },
  {
    "num_cand": "U2FsdGVkX19vMGuxKoJlXgo3uJRoiBWrQs/l64MX6ec=",
    "cpf": "U2FsdGVkX1+ExqcQwDq8jDo6uAMvH0+Xrtge0kBHucM="
  },
  {
    "num_cand": "U2FsdGVkX181GpZwgBTpVAJxZN0zZ/1CIov804W24CA=",
    "cpf": "U2FsdGVkX1/TShT05Xi6L3X6U6N2mOnTX3oyI4l49A0="
  },
  {
    "num_cand": "U2FsdGVkX1/m5JAT1P6RI8PeqFtQEUSTuNNov8MjuKg=",
    "cpf": "U2FsdGVkX18X1mQlcR9bZGWYVP1jsZXje19ZDMnczbc="
  },
  {
    "num_cand": "U2FsdGVkX18Y/1UL66qUikf/J5RJ0vTGeSCzcRttY9M=",
    "cpf": "U2FsdGVkX19P3gLVSMmmj+WuZvOSMad7LTppX0/Oy2Y="
  },
  {
    "num_cand": "U2FsdGVkX18gkGbL4g+3oMKzYXrhp4CU9el3LjdwdVI=",
    "cpf": "U2FsdGVkX18r21e89z4mCEjtTEmgAq8ZwfB41uE7Evk="
  },
  {
    "num_cand": "U2FsdGVkX1+v8e3awt/n0OdQhUGNsMLHkU/w6ba8fno=",
    "cpf": "U2FsdGVkX18UoSGF9oRDpfg/NfjOpUEpgzavzk20Wr0="
  },
  {
    "num_cand": "U2FsdGVkX1+FY/+CyXPfUAxXjT344fZlL6TAwWQZZ1U=",
    "cpf": "U2FsdGVkX1+Y/XYOblG5p/mzqU6Wcl16ZY2H8EPBhLc="
  },
  {
    "num_cand": "U2FsdGVkX1+RVxz5C9Ig7wPJ+XIRRhKtxPbMsI6JbjA=",
    "cpf": "U2FsdGVkX19aisKwje9zOooTCEnoZ6uQ249LW5FhhB0="
  },
  {
    "num_cand": "U2FsdGVkX18OPJAya41HxY0bFIPXd2/8zy9+gfH92ZU=",
    "cpf": "U2FsdGVkX185H+McB0YVRo6SSh8/3W88uSsoxCeAqeU="
  },
  {
    "num_cand": "U2FsdGVkX1/0YjQEvCedBqS/mTRkoGDb6zNr82anMB0=",
    "cpf": "U2FsdGVkX1+K1st6Sluk6aWmLjdqsi9Pg9R0mowq5R4="
  },
  {
    "num_cand": "U2FsdGVkX1+hpY0hsM7jOnEWfvsUwDxIULDWcbmkovU=",
    "cpf": "U2FsdGVkX1+mlMFo37ugxw2Gosv17fwxBEb66+u/lcA="
  },
  {
    "num_cand": "U2FsdGVkX18gtKHrva4cn9gMyrxWRVBzD/2W+SsYYyg=",
    "cpf": "U2FsdGVkX19pmy2A6Amn7ow6IgNKXlXh/jzBJcc/bNU="
  },
  {
    "num_cand": "U2FsdGVkX1/+tJgYjNxbmofvi92xx3Wz1el0LbNBWgs=",
    "cpf": "U2FsdGVkX1+++NIwTNWEpzKmD/BHXzg+nPZ6PN13f2I="
  },
  {
    "num_cand": "U2FsdGVkX1/r3TuJny29kZTIUY1f1lghya3SgJLl3c4=",
    "cpf": "U2FsdGVkX19MtznxjAgIiRWfcd8PVt2RwA9IJVLelLk="
  },
  {
    "num_cand": "U2FsdGVkX194G8gYMlRvLsmy2blS726tKzpxG3hadyk=",
    "cpf": "U2FsdGVkX1844Xn705/6jebGdLYQH1Wai1JT6yQGcI0="
  },
  {
    "num_cand": "U2FsdGVkX18iDMSK1VHUJHkoltUNgBVjTPcBVPHwMOM=",
    "cpf": "U2FsdGVkX19+5aCLegPYkoNeEZ/MDgFrMBQpei0y0/A="
  },
  {
    "num_cand": "U2FsdGVkX1/zCCp0mTytLBFapA0QA2DOy+Xxg9105Xw=",
    "cpf": "U2FsdGVkX1/+fWWeIA8VLk9qnBi/R3HoKhUoHAQ6ux4="
  },
  {
    "num_cand": "U2FsdGVkX1/rtXP0gDOf7KxXCk6/yuTLjgQGUbd0iU4=",
    "cpf": "U2FsdGVkX1/AdMOKJyske6jykHntzAj1h1x3fIJXgkM="
  },
  {
    "num_cand": "U2FsdGVkX19NR9ocE3aFrttkSD9KEOpKDLFbBGfFSY8=",
    "cpf": "U2FsdGVkX19wCDXf4egji0GSHj/vR6k2V3R/evwsgkI="
  },
  {
    "num_cand": "U2FsdGVkX18uj1OUmm6AecfzRzNCi8TiYeCUFfZhKuQ=",
    "cpf": "U2FsdGVkX18LGUCSyn5ddjKdh/pR6IAuw6Q2DQvj6qU="
  },
  {
    "num_cand": "U2FsdGVkX1/Qt2pcP5Fi74TDZEfR4E1jqvE3rTbiJps=",
    "cpf": "U2FsdGVkX1+z0SdzIm3tlBNOHuRVfoRjNLVDyw+sgIM="
  },
  {
    "num_cand": "U2FsdGVkX18TKOTo+5DLEA5Rg/T9w7wHvhtwdBQxeeU=",
    "cpf": "U2FsdGVkX19hNLyBgI/A2zBvDX6SMqMqsUEd3XgIPis="
  },
  {
    "num_cand": "U2FsdGVkX18MjpPzLQnUeL/vUcdEQdK7fGnBlGlKBU4=",
    "cpf": "U2FsdGVkX18KQK5wKRPBx2lc27yx1dD1ibKmUs1p+4o="
  },
  {
    "num_cand": "U2FsdGVkX1+DlQ4JUIOFz0TltZTXBEZGSj2UH01MOzk=",
    "cpf": "U2FsdGVkX1918xlPHNGitjUGUrcGxtpe4r2JeT9CDzw="
  },
  {
    "num_cand": "U2FsdGVkX1/j6mmiFtwlrDBGkj2Cr66+tjBlfvgVV5I=",
    "cpf": "U2FsdGVkX1+6+kF+/RAGlr/rdDEzksu3rVF3rsERxwE="
  },
  {
    "num_cand": "U2FsdGVkX1+53mOPFdJQb3rEQzhj4RNvS18AifqCp44=",
    "cpf": "U2FsdGVkX18uF/KC5BpJEqdwkPculDJniTBj+W2QVlE="
  },
  {
    "num_cand": "U2FsdGVkX19LTlM0fl0lnXImmfgnophshwBtx3XmqiY=",
    "cpf": "U2FsdGVkX189jy5h8jBmZx0uGSzCGWFNSdOew2OZvBA="
  },
  {
    "num_cand": "U2FsdGVkX1/+24cIwcm7MFLa0xzxdHYS49+3p/HBOI4=",
    "cpf": "U2FsdGVkX19I2zixWfNLciODVxWBde81huFnR5TKmP0="
  },
  {
    "num_cand": "U2FsdGVkX1+Fx+8oc1xfTYODA4W+x96YMQ+p5jd8QSs=",
    "cpf": "U2FsdGVkX1/bpc/cUehANBbWQDcv77I2QZnh0ZS6Qks="
  },
  {
    "num_cand": "U2FsdGVkX19ori7WhaVNLCpjQHi4JGKqzlSrGuWZeFk=",
    "cpf": "U2FsdGVkX1+TYMXOGgpqHr6qpJ2X8uTtvBgD6tpIYXE="
  },
  {
    "num_cand": "U2FsdGVkX19U36oVphoeOkKmoeyjvLlX+GgVvLH0zT8=",
    "cpf": "U2FsdGVkX19tSFp2neGJPg5PjyKIBwHaftbJggjvrgM="
  },
  {
    "num_cand": "U2FsdGVkX18ILyqDt3VANwKibT55HhrP8G4NoII5Sos=",
    "cpf": "U2FsdGVkX19T7Ij2YkpeI7FRg2iqB4xDtd4+LSSbchU="
  },
  {
    "num_cand": "U2FsdGVkX18NHbzGzr5b7I0Ppx7imKw9dLN+pGeVph4=",
    "cpf": "U2FsdGVkX1+e1/v8Xs6p3X8RvBZRGUdMZf0x8kOYPxo="
  },
  {
    "num_cand": "U2FsdGVkX1/FEBxtBrf84eJdX/lbJc3t3ae/4UA07/I=",
    "cpf": "U2FsdGVkX182nc8FqAjGm8LwSPgXU5wNDLWMDTRx8oM="
  },
  {
    "num_cand": "U2FsdGVkX1+I/Aw+zXE5hsK9P+hIGXQ27RNsFM3kG+Y=",
    "cpf": "U2FsdGVkX1+xsjKV9gA2ZJ91BWIxqAHBOZrI8KT6ZqI="
  },
  {
    "num_cand": "U2FsdGVkX19+pQBbYsOFlGsgjfaFMP23+cezRNQjYtc=",
    "cpf": "U2FsdGVkX18WlFMMiDvjTHcetRjwyfZAZCoP3Y95Vd4="
  },
  {
    "num_cand": "U2FsdGVkX1+d22i+JWkUGClW5nEbpnPnF5zAffLYX+M=",
    "cpf": "U2FsdGVkX18/aMGQWvxozfT+zZuZmK97CoiypU81QzA="
  },
  {
    "num_cand": "U2FsdGVkX1+twoVi+QRfxqGkQTdOpX92ZLUlRhT3leA=",
    "cpf": "U2FsdGVkX196YW1deTpGG4rzeJU93SL9BAMEYUUyJdo="
  },
  {
    "num_cand": "U2FsdGVkX1/sRaUParNgnR9CBaQRSI1lvi7aw/0aMvQ=",
    "cpf": "U2FsdGVkX19lJPoltIbIS2dWbj5SACJKVNya+W5ucp0="
  },
  {
    "num_cand": "U2FsdGVkX192A3+fYwVkRJrE4Qb87AxTHn9gsNJrF+0=",
    "cpf": "U2FsdGVkX18eDbErwO2sb8M121uf3fB5KSq+JF8V0Xg="
  },
  {
    "num_cand": "U2FsdGVkX1/NgcOVAdlof8gSfVZ1xUoSKPBH7suCasE=",
    "cpf": "U2FsdGVkX19Xy3qodxJHR2PuEg9TPWQPEIX9rC/WUfg="
  },
  {
    "num_cand": "U2FsdGVkX18jXRnZI5lef9RPkjhaWIM2GFD363tE/UU=",
    "cpf": "U2FsdGVkX1/lEH4EGM3dDFXyyeGw7vToIN0M/MgNTgE="
  },
  {
    "num_cand": "U2FsdGVkX1/ZaL5npu5WsFOQJaEX4tKdPjfeKBNvhEI=",
    "cpf": "U2FsdGVkX1/ZonznAg/Nue4Xx7iVwrLnFBgkZjpguHA="
  },
  {
    "num_cand": "U2FsdGVkX1/yvyUfuhhz1g7eOc2o0VUseEsy9Oyn0Yg=",
    "cpf": "U2FsdGVkX1+mM+r3ewXwHGyuCbn46IT7yaHRMR4X9DA="
  },
  {
    "num_cand": "U2FsdGVkX18Rv5WnPZXIkM75eBXAYl1fy/Bj7jiI+Gk=",
    "cpf": "U2FsdGVkX19XYy9VTPnj0FpJ4fPnbp7MMR3Df1kW9hw="
  },
  {
    "num_cand": "U2FsdGVkX19EYAFKhDYuIkrXzTk4GAs3WPfCTWr6AQs=",
    "cpf": "U2FsdGVkX18GUUEKzLcxGSFifLbdVHei2ax5Rp2ezfw="
  },
  {
    "num_cand": "U2FsdGVkX18uNn22zPuP6izriC25u6ieuApW+9m1sIs=",
    "cpf": "U2FsdGVkX18Txls2wWWDEmGuptUX3ERryCznsKjl4Fc="
  },
  {
    "num_cand": "U2FsdGVkX1/RB9dP4vvRFGpH3JR/Om4dCTHI5U/GKYg=",
    "cpf": "U2FsdGVkX19BWZKux81SAOU8gzPfCpddqwuOIujpLBo="
  },
  {
    "num_cand": "U2FsdGVkX1+fptcf2L+ZL09pfCcl92auXFDAd5N4shU=",
    "cpf": "U2FsdGVkX183+3P5BsuhVGqN16xcRhnrRvLXARcF/Xc="
  },
  {
    "num_cand": "U2FsdGVkX1/lsRnmEuTcVgBzb2Z6QsWa/BduHtW3NkQ=",
    "cpf": "U2FsdGVkX181aGfuY0jcYLEnxXURvcsUrxtScS3laf8="
  },
  {
    "num_cand": "U2FsdGVkX1/0pVEB4bE2bCtzNh1393rD3b7kaXiKA8Y=",
    "cpf": "U2FsdGVkX1/XuDITCTB16sOLAvhlZrjPbegtWZyIq8M="
  },
  {
    "num_cand": "U2FsdGVkX1+r87vGIkR9jO8MM+VEX2gMSR7oz5+jAdo=",
    "cpf": "U2FsdGVkX1/qzFvu3BEZaoHXV2JqrFnNQPlnrtPxozE="
  },
  {
    "num_cand": "U2FsdGVkX1+tBAejoUxc0rCyrXUYkm8/pCPA3Pc/xIo=",
    "cpf": "U2FsdGVkX18UzoY1bwdqLy5z3hQliW+EfpBsndEbqt0="
  },
  {
    "num_cand": "U2FsdGVkX19WuIUM5dRY0+4NVgm5yFuNOI8cdMPHYaI=",
    "cpf": "U2FsdGVkX19GO83sXJkMe/pK/KDk4qAU9Ncp6UE/zrw="
  },
  {
    "num_cand": "U2FsdGVkX1+6vXCH9/6aOEo+3pbMScjfvWE7gWpEDDQ=",
    "cpf": "U2FsdGVkX19EN/EfAQzG3WmCl7pkFau9dquvLxodytw="
  },
  {
    "num_cand": "U2FsdGVkX1+l3qxACEUxMfUcrqHvly2L77FEB1mjnBQ=",
    "cpf": "U2FsdGVkX1+uOixgp137En7dABllGFg/4nFQnce4Wt8="
  },
  {
    "num_cand": "U2FsdGVkX19GlSFEMvY6oNAxcopNRt6bNXVzY3CcYXs=",
    "cpf": "U2FsdGVkX1+4+/n01tutbW5AEydSkGTg58uTegeQnZw="
  },
  {
    "num_cand": "U2FsdGVkX1/VUZ9RjMMWlcFNy8ik2uaqKaiaznF+0gY=",
    "cpf": "U2FsdGVkX1+pEr8rvTRVWmunnqzbFSP+NWbV4ULVPes="
  },
  {
    "num_cand": "U2FsdGVkX18i/E41I7w+yFxgLCwQaYjGWA8PYvn7+nI=",
    "cpf": "U2FsdGVkX1/359kaSCsniKKQAUvMdsDKl2ahJiAJNdc="
  },
  {
    "num_cand": "U2FsdGVkX1+CxesW01TEG+K/gcrtH270+LWJ5zEW3uY=",
    "cpf": "U2FsdGVkX19Wy1qHCJhXZ8I22rD2CVMnl/cnrA/YYO4="
  },
  {
    "num_cand": "U2FsdGVkX1/6Z1tCZ4H9qbRrgsddUjckmXeniW8ElAU=",
    "cpf": "U2FsdGVkX1+FGOBf5GoYB0dGhTSRgC5I8tw/nrqja70="
  },
  {
    "num_cand": "U2FsdGVkX19K/XD4KsKWt+WJrXib+ATaAkijd3BZqPg=",
    "cpf": "U2FsdGVkX1/YrdW8txnoP6aRCYT7VzMFYswIHpYP2xE="
  },
  {
    "num_cand": "U2FsdGVkX19xgr8RRKNIVrj+V8pye31tR+FL3KcfrYQ=",
    "cpf": "U2FsdGVkX1/Z/A+C6w05qHTgO6nMN/7HHq8aOR8y1sU="
  },
  {
    "num_cand": "U2FsdGVkX19njCBSbHXGBxiqT1dk0Oji0snGFW+7Bvc=",
    "cpf": "U2FsdGVkX1+u7QJ/WzWBTvt9LpGy+vncWn+nZPnYn2I="
  },
  {
    "num_cand": "U2FsdGVkX1/ajhLlcVmi435xkbHirORZj6cWRiGiND4=",
    "cpf": "U2FsdGVkX1+ADaMsc2zvb4FK+zduad7NoEkoM7NGvyE="
  },
  {
    "num_cand": "U2FsdGVkX1+1MpHxa/28vLIGWwp/wTbMShMjRx8v3W8=",
    "cpf": "U2FsdGVkX1/D+MI7du6TH+U/gg5m1ko1/eDr1IHg37k="
  },
  {
    "num_cand": "U2FsdGVkX1+4Y/G2XjW2PV/s7nMxqkgP5ueHed8xEhU=",
    "cpf": "U2FsdGVkX1+5gb2xYmveJeLQz1xnkVy6fjiqGTu08zA="
  },
  {
    "num_cand": "U2FsdGVkX189f6UlUmy/fTQVxWb4XA6uN2ZJBYrqwf4=",
    "cpf": "U2FsdGVkX1/V/olE/xfQC9nrSrw5zCy4cmHxrqltxGY="
  },
  {
    "num_cand": "U2FsdGVkX1/XEemUMLwaFX0YEbUNaofmB7S7weBT0xI=",
    "cpf": "U2FsdGVkX1/IjV3/9iY8u7H7OljUj6x1ALbGQGIuJDw="
  },
  {
    "num_cand": "U2FsdGVkX1+DVCdWIlr+OFwJ4S7igFSi2DzKuBn3yzs=",
    "cpf": "U2FsdGVkX1+BhCVhfLFmFo4KWWxYIoN7reRm6xlCrmE="
  },
  {
    "num_cand": "U2FsdGVkX19LWoBTtpVTalvwtbjL1UE6WxoEU91+QWk=",
    "cpf": "U2FsdGVkX19ak3b5LNJ/xX3ZmJkWnCo3R6fxbPyEfYc="
  },
  {
    "num_cand": "U2FsdGVkX1+vndFLs6zsHWYexHdVnJ2ubLZtyLDBLKg=",
    "cpf": "U2FsdGVkX1+mDEaO4sEVs/jIgilzaB4+rAI0Be8D13c="
  },
  {
    "num_cand": "U2FsdGVkX18IlnOekYg1DCpVAb4v4iFM9ym8oI7YKsQ=",
    "cpf": "U2FsdGVkX19W08TkApLpP/GTT8J0thxpctv9j0GIMEk="
  },
  {
    "num_cand": "U2FsdGVkX18jYX5QVwoEIC5Bmm/288lev4Dv+X/UseU=",
    "cpf": "U2FsdGVkX18Garc92+CSTCnSraoZuVFbP9TxamMSG1U="
  },
  {
    "num_cand": "U2FsdGVkX18W/3qVxKjyT4Lt6eAp3CexHqoWkSQPhV4=",
    "cpf": "U2FsdGVkX18H/PYX+6hr0uNjDJQLPYchnQ6N9TR/QXY="
  },
  {
    "num_cand": "U2FsdGVkX18wWJhbf1Rd9Jmwg18IfIYtijaL6x+HZ/U=",
    "cpf": "U2FsdGVkX1/MFzHlIciV0VbKSH6AroXCKKh6LiAE1EY="
  },
  {
    "num_cand": "U2FsdGVkX19MOT+3VS/DsBJOMJgp/QZllSrpI9EdkO0=",
    "cpf": "U2FsdGVkX1/nS+o4xy+kSaFr+MpV56oXlJTFYmk/DmE="
  },
  {
    "num_cand": "U2FsdGVkX1/xBovXPZyOY9eV85aeCoRW8jbe1Eu11lo=",
    "cpf": "U2FsdGVkX18wZDioLzibX6hkM4lfjD4oiZxctUWa9Yk="
  },
  {
    "num_cand": "U2FsdGVkX18pFRweTU1RIiU1uOkvcvh1ESO6YdoMNpg=",
    "cpf": "U2FsdGVkX19Ky0uEriDKWFkDFhsYi8I5ply7tmAkzGA="
  },
  {
    "num_cand": "U2FsdGVkX1+TdK9oODtF30iJNQeXODd/O/bFiA06VWc=",
    "cpf": "U2FsdGVkX19DGXlsH1dxXsl0KA5lq/FuuHUvX17ooOQ="
  },
  {
    "num_cand": "U2FsdGVkX1/xr+lhooq4zi7aPLkdcdugeL9MB3Xp1+k=",
    "cpf": "U2FsdGVkX1+JMkaSyCl3d3Pwal8hZudkXxZYWAMtJLE="
  },
  {
    "num_cand": "U2FsdGVkX1/AV+dAurdOTJokiOcRD5UOQ19EjcVSljM=",
    "cpf": "U2FsdGVkX1/8jTz/yYJX0XojYHdRg/FUR8XiQtMq3cY="
  },
  {
    "num_cand": "U2FsdGVkX19AAfAAZw2F/c5Bd/k0+e7RpqNefRp+lw8=",
    "cpf": "U2FsdGVkX1+XeP6QLMFnkdyAWvUIm3fFZ4I5acwkPgY="
  },
  {
    "num_cand": "U2FsdGVkX1+VU4psA/zeVrb8rq+dv7OUYbRmtQg3aOw=",
    "cpf": "U2FsdGVkX1/pqeDyBc5ebld1QkXUQOM3psCyq2ekueU="
  },
  {
    "num_cand": "U2FsdGVkX1/KBZX4D2tDhjupPJjIAB9uJgqSTn6KKj8=",
    "cpf": "U2FsdGVkX19tARuLWs5zzLCiH48mGloUbWVR762KAEw="
  },
  {
    "num_cand": "U2FsdGVkX1/If6yiPiSqejAE//kdVG9bq9hsR8lj7i0=",
    "cpf": "U2FsdGVkX18KZu1iNCahEacYYkhOArvICpnSH2bn8OU="
  },
  {
    "num_cand": "U2FsdGVkX1/uZ7mP5D99qrfysEZz4F6DVH9pJ/YObN4=",
    "cpf": "U2FsdGVkX1+22dKNUCr5K+fplA3b3ytPgK0zWRYDKxg="
  },
  {
    "num_cand": "U2FsdGVkX19/bofikoOZgh/IyaKqQUP5oiO5o0Zp0Mw=",
    "cpf": "U2FsdGVkX1+eP1NvfbXeqvHtPQGZ8tspWIf0m6ybU8k="
  },
  {
    "num_cand": "U2FsdGVkX1/UUCnkjWo4KNC2QwIqXJ9n1JdmruVWo24=",
    "cpf": "U2FsdGVkX1/E7CztVJM0WXn7TzCdhjbFMfgm8F2C0fM="
  },
  {
    "num_cand": "U2FsdGVkX1/77B47G3gR1OofOXf6afIYmSLWX6fYc+s=",
    "cpf": "U2FsdGVkX1+d+6anyvoCEHJmpcnrEGtowWMILSRMzMg="
  },
  {
    "num_cand": "U2FsdGVkX1+V1yBT3BT2Q8oOtKdYD7JyPxU/UduSosM=",
    "cpf": "U2FsdGVkX1+qqNHyWs7E81C71RdTm/HgVJ2+YNpnRr4="
  },
  {
    "num_cand": "U2FsdGVkX1/bstk2V17IV1KVyIg3ZHgnmBE5fFt9+4U=",
    "cpf": "U2FsdGVkX1/ungIhLCe/rgWEIRNq8Z8kpWrHBIlcq0Y="
  },
  {
    "num_cand": "U2FsdGVkX18JYnfkGAPgEww6lFy3h1JMecCH3X1FuM4=",
    "cpf": "U2FsdGVkX1/1/2o+ZWlIVSfgdB/BUW/j09bBLcZKfBE="
  },
  {
    "num_cand": "U2FsdGVkX1/n9J+IbCwa5fxtcq62Fv14SUpQBD2Zb60=",
    "cpf": "U2FsdGVkX19aq0QPV6WQmmY2Gy0aXr4eLnNk7eGAUrw="
  },
  {
    "num_cand": "U2FsdGVkX1+pFGK0NwN7GcWbHQW1mhpM+wPX2MVGOUs=",
    "cpf": "U2FsdGVkX1+kV85yPISUUDYUFmc3EqgufKPrF+LwDWA="
  },
  {
    "num_cand": "U2FsdGVkX19Nnz7Ord8XztakZtTXpKCuGQtR56W7mjA=",
    "cpf": "U2FsdGVkX1/VhXltNimtaXu9fY7cpA6AcgyRIUjGfEU="
  },
  {
    "num_cand": "U2FsdGVkX19BPxVX1HT15cOUrfqKrmQnFHuE/2yLnqY=",
    "cpf": "U2FsdGVkX1/ios+O4QZSTCxOjOPeWKpNoFQgBSbT2Hg="
  },
  {
    "num_cand": "U2FsdGVkX18hz8T8XlOwZq5L9qbpXktVyasKQuKz9jI=",
    "cpf": "U2FsdGVkX1+Ty87VZA9n6MTDADhgiELj7Zdo/fb9YkQ="
  },
  {
    "num_cand": "U2FsdGVkX19D7kNgtDT0sjIDsr8M0JCg7xEx9ZZQsgs=",
    "cpf": "U2FsdGVkX1/rLD2BtwcJ7doQPcRJjgwQyDmSN4pcJYA="
  },
  {
    "num_cand": "U2FsdGVkX19zmScjpFy5W2dZI6xFeeHfqGE+Jkvmzig=",
    "cpf": "U2FsdGVkX1+ZkWYQ88E70+5/+yIkESY8GaAnVA6aiYU="
  },
  {
    "num_cand": "U2FsdGVkX1+lb43/lmqU1p9NeE5lO2tklbKnk3Wmt+Y=",
    "cpf": "U2FsdGVkX19YoooNir3tJJOETvDPZRELbcBVaJ10Q7E="
  },
  {
    "num_cand": "U2FsdGVkX186zbmAxhB4GGBxKZ0ucaaikhNrgWQbvLk=",
    "cpf": "U2FsdGVkX1+aha1Qs0X1udfMArdyZcXeghzIVis2Okc="
  },
  {
    "num_cand": "U2FsdGVkX18FZOFyfqx+7UgQH1L7+SsALKQ0XfNMZG0=",
    "cpf": "U2FsdGVkX1+LXPd+MlJ5oTVRBIHTuQ3pJTArGQmsdrY="
  },
  {
    "num_cand": "U2FsdGVkX1/pgXR54SiuFuuywul1+sIgBoRgIp0sGME=",
    "cpf": "U2FsdGVkX1+GE9otmpPjMmoRFrmAZFjDN3UkBPaEz24="
  },
  {
    "num_cand": "U2FsdGVkX1+PPFHxbYeZootlwXvn8GfExRKYgAZRDOU=",
    "cpf": "U2FsdGVkX1/dPa/IOlK6VKnDf2a/WOBu076a9m5eLQQ="
  },
  {
    "num_cand": "U2FsdGVkX1/IIOIVHmE1QO+WKSR7APrzuvG95tfxWP8=",
    "cpf": "U2FsdGVkX1+58XkcDx5VOaBLFlzYS1IYqHY62A3nU9s="
  },
  {
    "num_cand": "U2FsdGVkX1+lY0pQ+QTriox8cuy+eJHz1vMNGiDUMrY=",
    "cpf": "U2FsdGVkX18/MGj0sc2lAEBqmnn2sge0wYyoLxOErYs="
  },
  {
    "num_cand": "U2FsdGVkX1/fwF53Vn/qJ6UUvCiZC3p4Hy5r08/JaqM=",
    "cpf": "U2FsdGVkX1/43aHvJm8iuPG7LWE+mI94z27k/19tJCg="
  },
  {
    "num_cand": "U2FsdGVkX1+EgcL8utJ2dOAVI6gncl/uEvYQ6Vda35Q=",
    "cpf": "U2FsdGVkX1+zAzF94lC95pYqRPDdkA1DOWebgI6gXaM="
  },
  {
    "num_cand": "U2FsdGVkX1+SF53UXsDi5xoHTAskO+Af36b/L+pW47k=",
    "cpf": "U2FsdGVkX1/b2uEZbymsfHZS9a9Tp48cLgdW63yGyxg="
  },
  {
    "num_cand": "U2FsdGVkX18L7bLXmNN6ESj8VJhz5e100Dy/GaLZ15A=",
    "cpf": "U2FsdGVkX1+1dstYtzFYsSs8KIGHJgwdLA3MKmDkPK0="
  },
  {
    "num_cand": "U2FsdGVkX19o3Z9Iqkr3C3KlAtf/4i3AC6I0ymxtZus=",
    "cpf": "U2FsdGVkX19AO2TIGCvtWlJvtxDwcYbBRpk7MifhKkg="
  },
  {
    "num_cand": "U2FsdGVkX1+y4OuP5P3O40q6kF9Fg7SMbyTblIHwB9g=",
    "cpf": "U2FsdGVkX18Mc4Dm9c4sfkr3+X5sy189qXQAy4KpvqU="
  },
  {
    "num_cand": "U2FsdGVkX1/DLq1EhhK8c4h7EwTgXVUkQHYHyH1cY1E=",
    "cpf": "U2FsdGVkX1+ZvjkjcAVEdyMh3DDvhyFMgwajk1iPCG0="
  },
  {
    "num_cand": "U2FsdGVkX1+B52HhkvqIWGpqZIs3GJFQ66g63otpATk=",
    "cpf": "U2FsdGVkX18yB2cDOni02nIbajGkW9/nAvNVNQENzmo="
  },
  {
    "num_cand": "U2FsdGVkX1+P5U2R0iYUhKZC5AInY8dv10+OEP3ktrw=",
    "cpf": "U2FsdGVkX1+WIfFj/Ixki5hk7xUcIMPliWg+fGlTZXo="
  },
  {
    "num_cand": "U2FsdGVkX18bJz3vza1OF17mv6umPiopx2d7CmxnahM=",
    "cpf": "U2FsdGVkX18jcwCDzc/tEDx+JqjxyRr6i+wJkGr7To0="
  },
  {
    "num_cand": "U2FsdGVkX19+Em/k5qlxlNpWN+bywzJbb8GN6tIyY8U=",
    "cpf": "U2FsdGVkX19eDXR7iONpCiJ3PGVOrnOoaPNRmq1QS4Q="
  },
  {
    "num_cand": "U2FsdGVkX18WEx5MSzMiI45bY3oTC9zhhJls4ChXPwY=",
    "cpf": "U2FsdGVkX1/jpa6DZHg28TeXaWixhCJxH8MtwVSLnFI="
  },
  {
    "num_cand": "U2FsdGVkX1/rJ6fyx+pAAQj2AHNqutLNLigRZM+r4hM=",
    "cpf": "U2FsdGVkX19u2FUiZijnpO9wrkhZHCMx+gSAcxFchjU="
  },
  {
    "num_cand": "U2FsdGVkX19MpQ+YfOV5vG6DX5KvEc8kYaSHHhnC5zQ=",
    "cpf": "U2FsdGVkX1+Czn9AB9tBlkHcyE6XZD7f4p4i4guCbis="
  },
  {
    "num_cand": "U2FsdGVkX18v0JXMgFwE+G05rUqicxYR5jIvtuysWgc=",
    "cpf": "U2FsdGVkX19jsxHnddoryIsGhfI77L6nA4TvoqqrTyg="
  },
  {
    "num_cand": "U2FsdGVkX1+o/IHO09ttGBMepBRJ8Il+YrxiTFfkx1w=",
    "cpf": "U2FsdGVkX1/Xbz9a/MLIvkzM1nbboSeQvbEMOBxCti8="
  },
  {
    "num_cand": "U2FsdGVkX1/wUWHtTDJgaTLUsYIg8Dg6ax+l7fZsEDE=",
    "cpf": "U2FsdGVkX19l1PhFyWvfjFaazwfEOIRRqyZfq5V5n44="
  },
  {
    "num_cand": "U2FsdGVkX1/CJaaJ7pB/dDX2RZNmPkWLmZ1wcf4+YsU=",
    "cpf": "U2FsdGVkX19ewfy9rvO6D7+0wykXI1oaKLbcVxIKN5c="
  },
  {
    "num_cand": "U2FsdGVkX1/nu29DiqJvZN39mER+MnUqKEUnFki2KmU=",
    "cpf": "U2FsdGVkX1/NuUq8Pnh1FW0TENZgT9Ns5Yjl181/DuQ="
  },
  {
    "num_cand": "U2FsdGVkX186Xq+BbhoBaQPaOYo/E7xoJOJ8Lip5RmI=",
    "cpf": "U2FsdGVkX1/aQDlvrfrdUHmVO/ZvcOOc4zIkP91xzMs="
  },
  {
    "num_cand": "U2FsdGVkX1+pWjW3Y8u/8P7yq6z7RIv8JKb3tqC02IA=",
    "cpf": "U2FsdGVkX18wLqkox9Sy3yaWAKByTovTwKWxgFqFCs0="
  },
  {
    "num_cand": "U2FsdGVkX1/a23Rj9RwWwKNhBKX3zhaodo2fGb7bfqM=",
    "cpf": "U2FsdGVkX18LkS+eh/diRxGoMseKWndISSlcAuC6YPA="
  },
  {
    "num_cand": "U2FsdGVkX191URr7Ct4J72hzAi177SvvY6MOr6/SaP0=",
    "cpf": "U2FsdGVkX190Jj1htdRU8c6BuL5LQfEhbFEKJhXGE/I="
  },
  {
    "num_cand": "U2FsdGVkX1/QUX7BJBYIi/RTO6dbIMJWApHeYsd0Wo4=",
    "cpf": "U2FsdGVkX19T2R44Sl0H1OLFm/iN3N6E4qgvgNH2x4I="
  },
  {
    "num_cand": "U2FsdGVkX19sanl7sKzL7GmaQDWYK+RyhrxvVXNue4I=",
    "cpf": "U2FsdGVkX19pwKq3CSYn9Qa5h2imFvxXfp9tMqbWBdY="
  },
  {
    "num_cand": "U2FsdGVkX1+Psz6rDyxmsPzJAUO/RMbop4nvc2LkT98=",
    "cpf": "U2FsdGVkX18ErMhjwU/0oC9RFlUvKfJGUCVjHt397JI="
  },
  {
    "num_cand": "U2FsdGVkX1+vbovmQEqnI8Wr3qPe9UhfOQfOhwH9I9I=",
    "cpf": "U2FsdGVkX19MOSnat2v8XgMMfqnPi1i398JAFh3prME="
  },
  {
    "num_cand": "U2FsdGVkX18IiSg6DOpDWZs52QS2+232t16gdiKht9o=",
    "cpf": "U2FsdGVkX1/N6oY8GskuUibdf3xorYwu2jQ0P3tBCtc="
  },
  {
    "num_cand": "U2FsdGVkX19U9nc4oFNEp/kcEk0ePjT5S965k0Bx+SE=",
    "cpf": "U2FsdGVkX1/JNoZfTbM4ETw4OAfXsJE5diJrlebVJ7A="
  },
  {
    "num_cand": "U2FsdGVkX1+gY41/Vb3qB28eEhhpAcD7+0EUkyU6ezc=",
    "cpf": "U2FsdGVkX1/rhmyA3QJrbZaiwIzlvr1cEc+EhMtFBpo="
  },
  {
    "num_cand": "U2FsdGVkX188a9lkLYtrtA1KowlBhiTb+n0wws3/37c=",
    "cpf": "U2FsdGVkX195f7d8uaBuSN56s9hLJygd9ABdI8Kn4wg="
  },
  {
    "num_cand": "U2FsdGVkX19eSJKgIeoXKouv51mqRWb9Ay0TMAxXbRE=",
    "cpf": "U2FsdGVkX1+gYiAgz8Ak4mLL3GwrF5X2zTdc1RvojJQ="
  },
  {
    "num_cand": "U2FsdGVkX1+o/HgtfBaJ0ICqmcix4rD4PbuWx3ImHgM=",
    "cpf": "U2FsdGVkX19zZrn7THbpwR+psxgJ9XJbeWfmt02zLJo="
  },
  {
    "num_cand": "U2FsdGVkX1/p2+jxWFljoaxUMgIjgV4EgH4YISP/nCU=",
    "cpf": "U2FsdGVkX1/MXXrN9L/2RY8XxinSQ8X356ZM7qXxWeI="
  },
  {
    "num_cand": "U2FsdGVkX19MQELikDYwt2TpcigyCSI+nprKSaQpnBw=",
    "cpf": "U2FsdGVkX1+VIQWaWXfHL0EWJ3gv6ufV2x2VK8ChnYg="
  },
  {
    "num_cand": "U2FsdGVkX1/GwX1fc/ulzbPdXfoNybtG5tCfA3rFoRY=",
    "cpf": "U2FsdGVkX1/sMFcIkOnlUYCT8Sy+gRNmAZ38BHE0sB8="
  },
  {
    "num_cand": "U2FsdGVkX1/eCTQgdsDWdWSV7wGGyCkAul+CMUHmZXo=",
    "cpf": "U2FsdGVkX19dRfgbJuzHa6wwVj/BWvBXxBc5hqhGggI="
  },
  {
    "num_cand": "U2FsdGVkX1/Ieiz9I7RDaxdMOCPBn2F3yF9z1s4BtWw=",
    "cpf": "U2FsdGVkX18VomeW3z8QohthikeEjd+Xi4ZnkvVV+3w="
  },
  {
    "num_cand": "U2FsdGVkX18bzO4eWdssZ4ZoacPtxiVXemOeJJpBzFk=",
    "cpf": "U2FsdGVkX1/zGXzEPEuIm998oViAwQuMRly8JqI6W14="
  },
  {
    "num_cand": "U2FsdGVkX1/1JGFNaQgTxELBhmYPS05XuytMqr2rrsY=",
    "cpf": "U2FsdGVkX1+St18GReer/hk2WssOjQU3wngdN0FvK4E="
  },
  {
    "num_cand": "U2FsdGVkX18MUbV6mExhhWwx8LOeItM3trWVedhnBXQ=",
    "cpf": "U2FsdGVkX190PSB6UXhu7V05H4HkthsVanhzl3rzDG8="
  },
  {
    "num_cand": "U2FsdGVkX19/TQu6eX6gL4msgSISPEaKa4/Vw7Xphf0=",
    "cpf": "U2FsdGVkX184G4EjsTb8IrLmNzBp8LSUl0BndwsdwXE="
  },
  {
    "num_cand": "U2FsdGVkX18/dI1B9/KNVyqbvh+/jN9xrE7Gu+n0j/g=",
    "cpf": "U2FsdGVkX1+II1ALFn9GSazlLga3qbtzmTnpyfPrWII="
  },
  {
    "num_cand": "U2FsdGVkX1+j4sq03lktePNAUw/c174ZF+j3JoB/WTk=",
    "cpf": "U2FsdGVkX1+6j3ny3KtayjJkUE2ebCT+etu3jqx0HDA="
  },
  {
    "num_cand": "U2FsdGVkX1+KRg0IrRDWHaA9ZQDVjJ14pGTh38Am9dQ=",
    "cpf": "U2FsdGVkX18zkvN1mQO/XwFpxy5gGV9pEAuAn68nQfE="
  },
  {
    "num_cand": "U2FsdGVkX19NFvu5AWyx7flahRpqky06MTinZi7jZiA=",
    "cpf": "U2FsdGVkX188v+qwi2oVRmbj3stuAxzzwcKiN9tiqOs="
  },
  {
    "num_cand": "U2FsdGVkX1+fsaKM0BTIc5GUNro3lhl1dEj8ANYzky4=",
    "cpf": "U2FsdGVkX1+3gPe19+iD05aV9axy3KpVUAfuD8QFBys="
  },
  {
    "num_cand": "U2FsdGVkX1+zuUfPpi/cg7jsdwFKCFyXt1qN6E9R09Y=",
    "cpf": "U2FsdGVkX1+SiAVW1u6vA0oKsur3a7XQ7Phj9s3zkgs="
  },
  {
    "num_cand": "U2FsdGVkX1/ig8i7DMmS3iNphjtmchIK2o+sARajngc=",
    "cpf": "U2FsdGVkX18H/CcS54JustGFKNE+IHnKv82oXwQRQjg="
  },
  {
    "num_cand": "U2FsdGVkX18YSBPxno9eXheNX3LntxNUBeDtS7H+/xE=",
    "cpf": "U2FsdGVkX1+J7MDw2JAoxrFmt5wcntH5g3uTSmhPXG8="
  },
  {
    "num_cand": "U2FsdGVkX18YE6EgwQUDEU1jgje3G32wQb5v1tXYd68=",
    "cpf": "U2FsdGVkX1/eR2AYABbaNnpjBLQ/bkYXDpHiZB552EM="
  },
  {
    "num_cand": "U2FsdGVkX19stpBBXTOBwI+Ph9I9nXUG6uDrIVyP11s=",
    "cpf": "U2FsdGVkX1947WVSo4czjN99Y74gp9bqWEWPOz6xIXE="
  },
  {
    "num_cand": "U2FsdGVkX1+6lFFYvwLyxxe+wB4MevoiZP3US/39lQ8=",
    "cpf": "U2FsdGVkX18KOjfPDhrN9C0+3I3U9Yl8BCJU+cOwy5k="
  },
  {
    "num_cand": "U2FsdGVkX18YzuUR7GtPYORGM0Qyp4aL4khpfoiGkpc=",
    "cpf": "U2FsdGVkX18oiVjIQLqYFtmvSLiI8ZqQo5bYV96TsmY="
  },
  {
    "num_cand": "U2FsdGVkX1/sMyxt2ZC94VRHC6FgRI+bMADCEK43ZHo=",
    "cpf": "U2FsdGVkX19CvRJ+uk7WK31cnVE26HzI151zmdQheQo="
  },
  {
    "num_cand": "U2FsdGVkX19O6aEg/TYkYCUE9o9L4OSbzOatNaKy248=",
    "cpf": "U2FsdGVkX196my1LuUCntJmzW4xHyV/ld2IFrTrEJB8="
  },
  {
    "num_cand": "U2FsdGVkX1+HIAtQPMMdPpnurOv54m86MJGMfw1yLLI=",
    "cpf": "U2FsdGVkX19t/X8wfjZ02jg4cde1ZaYq7a1Eei5RYQs="
  },
  {
    "num_cand": "U2FsdGVkX1+OYXiUpTLJ3WeZLIbNboAFh4+vmp9Y+YI=",
    "cpf": "U2FsdGVkX19nDGr+fH22nQiOg0htN58UZsN/boeYom8="
  },
  {
    "num_cand": "U2FsdGVkX1/hPmIWIc6ObZtXj8ZBf1jXV9xRHQz3G2c=",
    "cpf": "U2FsdGVkX185cCFwNO4sELpJrHikMw2mBQszJO2/aBo="
  },
  {
    "num_cand": "U2FsdGVkX18BXuQlRfmBmNSPr0tLguzTniQRU2DKK+c=",
    "cpf": "U2FsdGVkX1+twwdGkcww0bS9UDUtuDltpp+E7dKyCrk="
  },
  {
    "num_cand": "U2FsdGVkX1+18x9Fyn+fGQ5CurpQPyE+e/27BRfaJ40=",
    "cpf": "U2FsdGVkX1+VYE4+8O9jLGyUCTWvbec81yhV+O76+xw="
  },
  {
    "num_cand": "U2FsdGVkX18kXxLxUsDzBWtr+XKMHQrKKTKtvgwfAv8=",
    "cpf": "U2FsdGVkX1+1B1uJbqIchRncY/KRIJh6SPMolSTIu4s="
  },
  {
    "num_cand": "U2FsdGVkX19H3K9wgr4gwEIejURp/pvkAW/CQBmRnjw=",
    "cpf": "U2FsdGVkX1/J5PBSLvn5nbfZYB1ckGQVa765ThgI1H0="
  },
  {
    "num_cand": "U2FsdGVkX1/uWPQqLckObGUIPin9vvjJ06SdhILURq4=",
    "cpf": "U2FsdGVkX19AXpZC6tGHIwqnGJ+s1s7bY5a235+jKB0="
  },
  {
    "num_cand": "U2FsdGVkX1+H92W3wctbJlf/nR7gRwq8D3FNxsiNNWs=",
    "cpf": "U2FsdGVkX1+4tY02I9udT4oSYUMVnH0yhfr1n9FnS6E="
  },
  {
    "num_cand": "U2FsdGVkX1+CGulxbLv4W0lLgLvBUAR4SjisjFi1WWY=",
    "cpf": "U2FsdGVkX18elQGn3jHw9H1eK48PNs3iLJ0dQ234AxU="
  },
  {
    "num_cand": "U2FsdGVkX1+9tDb8CeswLgOifaFVeZYKHFTJlqyVJdo=",
    "cpf": "U2FsdGVkX1/GC2Rb+zTd1+hFrOO98A4uPG4q/VvW1nY="
  },
  {
    "num_cand": "U2FsdGVkX19XEzC5aAYY2pQiWy6Y8rgjtQv6m9+Jhgc=",
    "cpf": "U2FsdGVkX18L4Z0VYcoY0V/mwCoTLps/e3X0wNk8OhU="
  },
  {
    "num_cand": "U2FsdGVkX1+8c6maR2NVTA5WbbDy+a5utxgxVrGOd7o=",
    "cpf": "U2FsdGVkX19523uzfSlzrZ8obsVkE4BS0vi1qm/InEg="
  },
  {
    "num_cand": "U2FsdGVkX1+my+KSIgWQoT+LGZ5C+S+hX0nCGS97OKM=",
    "cpf": "U2FsdGVkX1/bqDu49304269uoRV23hrwnf2jRrcWhlE="
  },
  {
    "num_cand": "U2FsdGVkX1/ODQyGXu0p5p2iNfgj8K6OCeJFFMXttRo=",
    "cpf": "U2FsdGVkX1+PxXgG1xsfsYNsIoHNfD/y7yL4PItORl8="
  },
  {
    "num_cand": "U2FsdGVkX19gfhLXGF5oL0FMV6pgdeVG22pYRudme2o=",
    "cpf": "U2FsdGVkX1+/+oOXZmLoCJKoKtSTQ7JV6coUaOo9uLU="
  },
  {
    "num_cand": "U2FsdGVkX1/lRmbsV8vf06f4c3F7lZKJVpJ+lIyOAa8=",
    "cpf": "U2FsdGVkX199e1uwXcqEpu1/ZiJBP/zAik4kSlACbqQ="
  },
  {
    "num_cand": "U2FsdGVkX18Z6Cype7zXEGBb8SHJ3oBbMCc6wS8Z7gQ=",
    "cpf": "U2FsdGVkX1+IqOUE4dgPoEkFJtEOLB+8etmvCZQJ0ZQ="
  },
  {
    "num_cand": "U2FsdGVkX19RqoayybPvXFlUtFUQ0OKd+pj8OQkB4u4=",
    "cpf": "U2FsdGVkX1+unYB2tR3E8QGIAGPwXWofgHzFSrOMTdA="
  },
  {
    "num_cand": "U2FsdGVkX1+RdHEcCl5eiVqfvMoJgh7ER2DfMWTqF7c=",
    "cpf": "U2FsdGVkX18CjV9GFWlhvMkybavxiy1VF+Se9C92AWA="
  },
  {
    "num_cand": "U2FsdGVkX18tySDGJP3ov1UCVLgecWukzLwlg5p7PaY=",
    "cpf": "U2FsdGVkX1/vNrB/bxL5R2LXFtFEsi+qhzhO+DU8W6Q="
  },
  {
    "num_cand": "U2FsdGVkX1+sEJKKLDmofm72h7L1Xsiic5Ih7mjbWAs=",
    "cpf": "U2FsdGVkX19tP46MOfyTIdmcSnJuEn3kQ7GSwf9owow="
  },
  {
    "num_cand": "U2FsdGVkX1/eypaOcHpvHC5a4zkxuiwwzDjXNF5MoLM=",
    "cpf": "U2FsdGVkX19kzrENQOjqH1avW+nb/gr+BX0r+utfIyQ="
  },
  {
    "num_cand": "U2FsdGVkX1/6fGL3isN8482OvF7UV7Qunm2tiWzZmv0=",
    "cpf": "U2FsdGVkX181cPXfUlmAUWwI9uHSfknlNLGNEBBaM9w="
  },
  {
    "num_cand": "U2FsdGVkX19STv+aRf07ctPO4yfwNRXSmbx5LdIx4z4=",
    "cpf": "U2FsdGVkX1+xEU0eKy+NI0odHQvnKSZ7nFisu5JV90M="
  },
  {
    "num_cand": "U2FsdGVkX1/OrzQo2692pIB7HfX2xG8I5cjhFwQO9y8=",
    "cpf": "U2FsdGVkX19a4M5W57ojIF/YMqhO/L5OmCN/OqvnI6U="
  },
  {
    "num_cand": "U2FsdGVkX1+00YcpL1z5DQi+zq/FeNbSQm8Ol65/Nq0=",
    "cpf": "U2FsdGVkX1/peXC2fQtYRPXr9HY1d8Y2avWCjjOuMpY="
  },
  {
    "num_cand": "U2FsdGVkX1/uJFq2Lg5bsWGCz9M7Fco6qPGsby4bAyk=",
    "cpf": "U2FsdGVkX1/O2Iu9nyYqKDLMbC7A/tBpgcMZjdaIdX4="
  },
  {
    "num_cand": "U2FsdGVkX1+zmdzrOPWYsCJvUe+sCf9t7+7jIFBej10=",
    "cpf": "U2FsdGVkX18RJSyJwhZJyPTFTKRUp+8vQI1KRu++oXQ="
  },
  {
    "num_cand": "U2FsdGVkX18WW3uXu5zPz4e80JlPU5ydjvvUIywUMrM=",
    "cpf": "U2FsdGVkX1+cSBbH4bBlpgaLvbxByw+yorAyrmcEn6g="
  },
  {
    "num_cand": "U2FsdGVkX1/WY+SkCQHiHXG5p7hcW+QOA57u2VGyZFc=",
    "cpf": "U2FsdGVkX19loj7XnaZ55PYkGAEQYoG9dtChoosryCQ="
  },
  {
    "num_cand": "U2FsdGVkX1/0xkaMmHlcxsrFYB9E4n7qq7tIQR6U4Tk=",
    "cpf": "U2FsdGVkX1/s9iwqjCekqEe/z9TuZEBT0Z+aTFFxG/w="
  },
  {
    "num_cand": "U2FsdGVkX1+0MlAfc++lhkL9MjlJotz7Go8Us6A1II4=",
    "cpf": "U2FsdGVkX18uGthh5U3mP22SuJnJgjWGMy+JZjA2AIE="
  },
  {
    "num_cand": "U2FsdGVkX19C3lQTCHjSIXnULBKAWwPaVRE0Z83zZAE=",
    "cpf": "U2FsdGVkX19USQlZuSzY+IvPE3zZNCEfXteQ0ZZUE4o="
  },
  {
    "num_cand": "U2FsdGVkX1+vENntK4xGaM54zyORtriCfiX1y7mcRHo=",
    "cpf": "U2FsdGVkX18SsvdxypLMlZP5N2ZIBcgXFX5UTjTn3vA="
  },
  {
    "num_cand": "U2FsdGVkX1/ACqcjXlbgkH6LYsCqXCL97Vcqy66AH/Y=",
    "cpf": "U2FsdGVkX1+g5e/c02JAnecfgAsI+cvBNj05P8u4vN4="
  },
  {
    "num_cand": "U2FsdGVkX19bcJCL9ARCwnRRiiCLlSih9Rh7CEnBrho=",
    "cpf": "U2FsdGVkX1+IFAVXGbm6d6NMjgUhefnysLb8LnI2CPk="
  },
  {
    "num_cand": "U2FsdGVkX18grspvz40ltttCfGQ3Vhn967pJUb4vl9M=",
    "cpf": "U2FsdGVkX1+Y2JEPJqxfwuqlbtukl/0DWrOXBTQcLyM="
  },
  {
    "num_cand": "U2FsdGVkX1+cw2eaPT3kkSYBPO4r1EiL22ipWn6MzGI=",
    "cpf": "U2FsdGVkX1/TURBwSn6OAyZ/kn/RYuLkGPKFMXsfdL4="
  },
  {
    "num_cand": "U2FsdGVkX18b36eEds9qckTEyTmJGCM1K1usgla6Adk=",
    "cpf": "U2FsdGVkX1/FvRgNIuAwR/SnNVBt4wlKcRTyfp5KyqI="
  },
  {
    "num_cand": "U2FsdGVkX1/k0pUvKY0EJA9ug+9dh7f23vImQ1cfdLo=",
    "cpf": "U2FsdGVkX18EAoJyKZtZUoVFRJBG7WIBg+s+/NE03II="
  },
  {
    "num_cand": "U2FsdGVkX18qDjimyGTfOfgCvPon9WoPJrYS63VcDEI=",
    "cpf": "U2FsdGVkX18jszl0/KPHj+pnKfcex5FR2YpWbR8WYFQ="
  },
  {
    "num_cand": "U2FsdGVkX1/HDw35T+hqZfOwFrq2V6gJXr4RLQs7k4s=",
    "cpf": "U2FsdGVkX1/esPT72aPD42R+Dg9GqKNvDG+VkJMdlIM="
  },
  {
    "num_cand": "U2FsdGVkX1/yFpgx41ff+cKbX4y9xaP14oOg+GZoEro=",
    "cpf": "U2FsdGVkX18Oz/KeZzZnqd7XwKvYbmuiwz6jRIQqSuA="
  },
  {
    "num_cand": "U2FsdGVkX18/JMP5lTY2pjqgVwH1UB13hSvItDm3X+Y=",
    "cpf": "U2FsdGVkX1+rH6ngMsiKHqP6qwuaxQ191thl8za9bgc="
  },
  {
    "num_cand": "U2FsdGVkX1/UCAN0V0YRpGZ4ogUeq+PffuQT9+2Q97w=",
    "cpf": "U2FsdGVkX1/iKixatnXiVbxksCTIOqOGGax/VLIZefg="
  },
  {
    "num_cand": "U2FsdGVkX18jWMd+8Gq92dn17lB1PppIwkgvH42rdcs=",
    "cpf": "U2FsdGVkX1/MfTeh4fdR/vSr9Pr01BnRqgUoX160Y2k="
  },
  {
    "num_cand": "U2FsdGVkX1/aBBWYmFGo+kMha64qsh1u67kQPXzYdeE=",
    "cpf": "U2FsdGVkX1/OVR6sKi2KQ/Izyo7yFn02zLlXvJCSZQQ="
  },
  {
    "num_cand": "U2FsdGVkX1/tFfjsVHXOpv0ZmG9AM0HoyHBjk/JDhqg=",
    "cpf": "U2FsdGVkX19N5JyzfI9Vbw8yA9xS+Z0GKvuMc30gQVo="
  },
  {
    "num_cand": "U2FsdGVkX19frggRXSaiEXmzyihV/TYz9Ofxfg3RK+g=",
    "cpf": "U2FsdGVkX1+ez7rAISGoKahsrfnGOM5mGRp6nfkLDX0="
  },
  {
    "num_cand": "U2FsdGVkX19C/3JlHcrfN7NVnJu/84qMS6As2jy6mQI=",
    "cpf": "U2FsdGVkX19xmzfDcRf8cBZipB5IiK/LiH4XmJj8eAQ="
  },
  {
    "num_cand": "U2FsdGVkX19HQg/9E/3qoeKdkDtJg/RjmXsuYHqwtV8=",
    "cpf": "U2FsdGVkX184yLk+/6oZuK/gr7ScgkRn2vyjAWeiy5Q="
  },
  {
    "num_cand": "U2FsdGVkX19QfrOBe1FjySrcE5kWrJ/ofdISALI5P6Y=",
    "cpf": "U2FsdGVkX1/IYe4GZgvAIDk0TQs8eJLS/SrvtlJ62lE="
  },
  {
    "num_cand": "U2FsdGVkX19/vFfJeEodgHFnyS52JzRvXrKwtkjmWHM=",
    "cpf": "U2FsdGVkX1/42RRayBuU0BJF0X+PzOHZMzN/pMtbBjA="
  },
  {
    "num_cand": "U2FsdGVkX19nXSrca/2hZUT54BMSyk6qMtNoshyhvKo=",
    "cpf": "U2FsdGVkX197mexXrRh08g1WSZk48OVpPIGnOpnwdYc="
  },
  {
    "num_cand": "U2FsdGVkX1946sBIOLsgFatwg1yL8Hny00TyFrvY4Gk=",
    "cpf": "U2FsdGVkX18Fe0OjDq3xWWL/qUKcDdaigJFrACRTQgI="
  },
  {
    "num_cand": "U2FsdGVkX18zFhI6e0vOb6W/vPWGAsucbTnt2hAZSXw=",
    "cpf": "U2FsdGVkX1+xH4vw3OtCHHV5actlFlEJYoxh0jIM7UQ="
  },
  {
    "num_cand": "U2FsdGVkX184/zOFsU+RGCVMkq+lLMxluZsJWMilXDs=",
    "cpf": "U2FsdGVkX1/j70wdwljbuc9mgjQWxTCMcRjRchwxRUo="
  },
  {
    "num_cand": "U2FsdGVkX1+Ii9P0+6gn4kmarD5MIkAksz0dc4lQ8mM=",
    "cpf": "U2FsdGVkX1/tSmP0cclqzOKniA026GgctaHhn2q3/HY="
  },
  {
    "num_cand": "U2FsdGVkX1+Tfv5bDriWjpAXcS3MNMS4D+NZTuVGSD0=",
    "cpf": "U2FsdGVkX1/NVGmf5oLQzLYGeNIp6BV7HKIlmoOmi1U="
  },
  {
    "num_cand": "U2FsdGVkX18w0ojzOKEWFBdIJdzGBGq/KT1H1pmTk6Q=",
    "cpf": "U2FsdGVkX18TEpePOjIYeGsIRiIbAbgE8w+31TG1wlE="
  },
  {
    "num_cand": "U2FsdGVkX18vP4gh2llBhDTbHOc6jr+jG2HrimGmVLo=",
    "cpf": "U2FsdGVkX1961knaiHftE8aWV1WiNouk5XrrPpI2f2g="
  },
  {
    "num_cand": "U2FsdGVkX19jChs163WoDkwWDhz8lbEJjztc0sIPEQ4=",
    "cpf": "U2FsdGVkX1/sTrLK3maw2nrZ/HoTh97nx8EanbrhyeI="
  },
  {
    "num_cand": "U2FsdGVkX19J7hJH+PwPKvRgQrkzzjPAr0AydgwwXZ4=",
    "cpf": "U2FsdGVkX19pMwL4CjQTLn+42bDS8m5tML1CPYBnCNU="
  },
  {
    "num_cand": "U2FsdGVkX19mfraP3VxOVE6BjN7N+ZNitDNmOFdmhAw=",
    "cpf": "U2FsdGVkX1/FBmhC3+N22d986YHoWivcJ1FOqxc9NDY="
  },
  {
    "num_cand": "U2FsdGVkX18kM6ys7KUpkWebK0RewbOOzpVQwHSqXb0=",
    "cpf": "U2FsdGVkX19W4DGvda5YM7IwAeiQhG0WUyDIqz8v9XY="
  },
  {
    "num_cand": "U2FsdGVkX19kZeu6fzKXjKazsONfakp2thyxCy+C/Ck=",
    "cpf": "U2FsdGVkX1+5ID4mH3EduVzNZSqwelyJmMW2J3P599w="
  },
  {
    "num_cand": "U2FsdGVkX1+Ttp3L2Xk65azUiXzPB48/+T/qHAqNq1I=",
    "cpf": "U2FsdGVkX1/Ql4ItjhvGyaVdbM1GrHeX5jn68QmsCj8="
  },
  {
    "num_cand": "U2FsdGVkX18eVXQyEKxD2Avl7JjVCFbIPOhoY9u3hDw=",
    "cpf": "U2FsdGVkX19Vock5JqTPz4NUl6jatIPRT5yRZedjNr0="
  },
  {
    "num_cand": "U2FsdGVkX193VihR0wqeKtylWTiF/V7P0pKmUS8fB+w=",
    "cpf": "U2FsdGVkX1804nbcKxkMrDlHbtcrpotq38Hb3sjegZk="
  },
  {
    "num_cand": "U2FsdGVkX19S+qzBDCBiU1lfS8kySK3VQAzSG5DdM/E=",
    "cpf": "U2FsdGVkX1+NOGZbkrp/igVwZgjdO+fiVBLyo7+oH5Q="
  },
  {
    "num_cand": "U2FsdGVkX1++NhbwdC/JS9+YSLPLxxRhpYIObGMaBM8=",
    "cpf": "U2FsdGVkX1+QSsL7A/va9slXl5WAYrJuJMckqIM9MYE="
  },
  {
    "num_cand": "U2FsdGVkX1/+JHJdNF0PYStJUls+tswc7armhNJc4BQ=",
    "cpf": "U2FsdGVkX1+cRo0netayssCSKa215LMihYcssIxD5KQ="
  },
  {
    "num_cand": "U2FsdGVkX1/f8R2/PhmKGKeXijAUTInUGIdm6P3eTjQ=",
    "cpf": "U2FsdGVkX1+nKWKIdB1CVxjCbint/0ulQO6J2QRDG/g="
  },
  {
    "num_cand": "U2FsdGVkX18ODYGoDPbjDgZdIUyinN5u3Fs7I9k5gro=",
    "cpf": "U2FsdGVkX1/hU5EZEbWKq44dCaO6Gpq+d4vrL/5UaXo="
  },
  {
    "num_cand": "U2FsdGVkX19u9/IEA6ojPeeIxFntSH0y73Bx80QRHac=",
    "cpf": "U2FsdGVkX18uCMXgSYkzqciaD8YzLsIQWiMANpNsT4k="
  },
  {
    "num_cand": "U2FsdGVkX19ueFiOkPxG5YcfsA4uEFnQo2IR0dk0oMM=",
    "cpf": "U2FsdGVkX1/DFTNSFvdIG5N7Fp+F9E75kXiCJAKIgPc="
  },
  {
    "num_cand": "U2FsdGVkX19nhkGwP2fdj71/o97JGltQPCzEULmLN50=",
    "cpf": "U2FsdGVkX19Shr9T2o7GaA0EGHqeWrnALGk3CCHIAxk="
  },
  {
    "num_cand": "U2FsdGVkX19ltz33EGnAqnL3sz6pzBb7eh+/afK6GOs=",
    "cpf": "U2FsdGVkX19vz5Har3QRlnAtryc1MXN9pM3JJUGMZuY="
  },
  {
    "num_cand": "U2FsdGVkX1/O0gVZTyfMsIfEGykvGqGhZQiNrzNCUlw=",
    "cpf": "U2FsdGVkX1/aArEKOcwW2fxHsFLyJm/IoFbqeACGV38="
  },
  {
    "num_cand": "U2FsdGVkX194xd+j7kcvtCWkX1qJCA0vDF520lceVQI=",
    "cpf": "U2FsdGVkX19bMTwkL31yBx/Ivz1p3MeK1UVPGKDeIzA="
  },
  {
    "num_cand": "U2FsdGVkX1+AH/0HlquRq55Wf44eCZjlLXMS4oUDs3E=",
    "cpf": "U2FsdGVkX1/O1pBGYWIawx/2CSDyhKRa5XC190sy+SQ="
  },
  {
    "num_cand": "U2FsdGVkX18vPfO7l6GH3NRhc10pWMSn7kYo9/11WnE=",
    "cpf": "U2FsdGVkX1+apMi5WSIfTKbwMfQikvzDyV52LIhRKvQ="
  },
  {
    "num_cand": "U2FsdGVkX1/FQF6JrWCOQ0JYUMhJB0LlY8qjEoYE3IY=",
    "cpf": "U2FsdGVkX1901HdJP31zFenh0/oT+qefTYCt3LIIqXk="
  },
  {
    "num_cand": "U2FsdGVkX18qq1fURGHfF1mv+VOHgzUx1moJV0bpZIA=",
    "cpf": "U2FsdGVkX1+b0n/ivYZAfi8C4q2Ty1kctcWu+0YqV1Y="
  },
  {
    "num_cand": "U2FsdGVkX1+XBvVuJUYNVtEI8ieXDj8Se/yr7vKd//o=",
    "cpf": "U2FsdGVkX18n2ttWGq5Z03dPGsPoDWN0jpp24c7HvxM="
  },
  {
    "num_cand": "U2FsdGVkX1/khShXbKYazvTwM0x2Vw8Hozxlw36F5gY=",
    "cpf": "U2FsdGVkX19xEbBRR3r/d6vJidC4D5dOrJgD+LaXjrE="
  },
  {
    "num_cand": "U2FsdGVkX1+Td1u1/S+6KZkrVI0hp8qeM7dD84A3L5M=",
    "cpf": "U2FsdGVkX1/5QbHrUEI0AkZTzswZpzFjrxvtp32RXXk="
  },
  {
    "num_cand": "U2FsdGVkX1+6xScthnmcOpr03J0hCf7x35J9GrLDMvw=",
    "cpf": "U2FsdGVkX1+m7/OKot5BX0415fOODM8Qobh93ArHu+s="
  },
  {
    "num_cand": "U2FsdGVkX191qOcHKjXQZQ4hASB9e/MRkSD/0JgXvtc=",
    "cpf": "U2FsdGVkX1/qf06pR5FyCo6MCTyIVwyb2CIc5kflMHo="
  },
  {
    "num_cand": "U2FsdGVkX1+MOcOXMJuGlcga7shYYB2y0NrojXXe2TE=",
    "cpf": "U2FsdGVkX18wWgpxy6T9Gepb+dhEf7IZ1kd5udkYuUE="
  },
  {
    "num_cand": "U2FsdGVkX1/XRjIzznEyr7+FjTbB9pFvZl72qR83N84=",
    "cpf": "U2FsdGVkX188T9++kZqdd8jWCIoc1g8ai5P42L+QTMc="
  },
  {
    "num_cand": "U2FsdGVkX19FsDFVjnqVRU8oUMUxpa5grjx+RUQWu6c=",
    "cpf": "U2FsdGVkX1+wSmlf8ewXOIQubiqqbvmULi1khpUsC50="
  },
  {
    "num_cand": "U2FsdGVkX1/RqSYo7QSHVRvlbH/xnbBuYZMD0bi9a28=",
    "cpf": "U2FsdGVkX1/+SANsyEKmcmY9l4kxSnf2kq/mvcHTej0="
  },
  {
    "num_cand": "U2FsdGVkX18ytl/gnRp127dk/QtChcI4+tQtzhT54Z0=",
    "cpf": "U2FsdGVkX1/JyrmT0zhH6EoiOipoEWwxWnxxYCkvB2A="
  },
  {
    "num_cand": "U2FsdGVkX19acVN0c3AVf6HNU8tb2LlkuxjGSElofnA=",
    "cpf": "U2FsdGVkX19pmee9tiDZta4aYhpA4hO2nCVTuD1EDvc="
  },
  {
    "num_cand": "U2FsdGVkX196e6F4AHkAoFX8IcnfKJWxQo0zxKvAmNI=",
    "cpf": "U2FsdGVkX1/Nv64N0ZuZLe+CX4YQgxVKakCrrTkkZKM="
  },
  {
    "num_cand": "U2FsdGVkX18FFQTJEU6lq+3Ah5nJkAErG+RqzC35jx4=",
    "cpf": "U2FsdGVkX1+zbxz6YPqT2zwCuGCaZb2VqdeTrijNYiw="
  },
  {
    "num_cand": "U2FsdGVkX19mt+l9va+X6H7oBuy4I9/xBRUw1EtK0+o=",
    "cpf": "U2FsdGVkX18HcZcH4r/1TfBV2BUIu6O6srKH71mP5v8="
  },
  {
    "num_cand": "U2FsdGVkX19r++0TLMelrz/mCRF9kv6AFDuxqXEVCWg=",
    "cpf": "U2FsdGVkX1913h8SwdCo0DInfWPARawq3OlfTAbvm0c="
  },
  {
    "num_cand": "U2FsdGVkX19hNC10qkVF803SRr/YAkJjKCvsCvo8J3Q=",
    "cpf": "U2FsdGVkX19e879Rgj6LEH2e7OKYNt/iCcLXIh1T8CQ="
  },
  {
    "num_cand": "U2FsdGVkX19PXdOYYKCGbtaV4im02RW7VckeKRi30sw=",
    "cpf": "U2FsdGVkX19G3OrS0CNQh51Oj554uPJ3kn0SKyTG5mc="
  },
  {
    "num_cand": "U2FsdGVkX1/jvmNokbRBd1GqeidZs0mOatt5vO/4kRs=",
    "cpf": "U2FsdGVkX1+vam4Dh72eiRBT9B5tmL6u3MDwayWKtU4="
  },
  {
    "num_cand": "U2FsdGVkX1/vuEFi1T4HGRJbAeKER4XimDzfggGNhMM=",
    "cpf": "U2FsdGVkX18mOiWE8rIAUbrcry+vxJ10HhedLN5OEOg="
  },
  {
    "num_cand": "U2FsdGVkX18b/7CUiMdLQrpS5XMvmh6x4BpQxpPl22M=",
    "cpf": "U2FsdGVkX19qAofo6+d7p8iv6h64D1aEgfRcIw8D1XY="
  },
  {
    "num_cand": "U2FsdGVkX1+Wsf+WAj99zXhNijuRS426uGb+8UJagdQ=",
    "cpf": "U2FsdGVkX1+yc+bX+XPUVIB3LKQWf3zcxd0QWJBssYg="
  },
  {
    "num_cand": "U2FsdGVkX19TxYD8r1hn9ponDzuhJyt3TEDrbT8IwcI=",
    "cpf": "U2FsdGVkX1/BIHjv0+mtTYsB35Qx5Fe0K6fa1Qsh0+Y="
  },
  {
    "num_cand": "U2FsdGVkX18r/ysdi+gFDIBscSU1SokerpYLeqpz/6A=",
    "cpf": "U2FsdGVkX19BW6chIUZBEwjeErOFlAscV2/+MFgG3TQ="
  },
  {
    "num_cand": "U2FsdGVkX187tsz5MaeHWVmlKbsTuEUh0mD58zO+inY=",
    "cpf": "U2FsdGVkX18jpMYGCuUyxv+h7JCf+N53+qFNXkxGupc="
  },
  {
    "num_cand": "U2FsdGVkX1+xPgyZn1k5MDj3uvWm3LwYqVUG3cipNqA=",
    "cpf": "U2FsdGVkX1/61B/OUGGjGVrU0NMvx3K3f3alh0KB3SQ="
  },
  {
    "num_cand": "U2FsdGVkX187LJoct+lpj8uGMdjwNWhOXvOAbc36aQQ=",
    "cpf": "U2FsdGVkX1+J+xzKaWmcO0caAnSJDHCpqA/V7YE3hlI="
  },
  {
    "num_cand": "U2FsdGVkX197RuqR3WFULNGF9x2Cz5E4jEOZd5faQEI=",
    "cpf": "U2FsdGVkX18yf2Eaoz19lZkXhBjCBSTtNttMFaZtoLQ="
  },
  {
    "num_cand": "U2FsdGVkX1+8mlxn2YS/sHTMIxLpW6XBsnAqpkXkySI=",
    "cpf": "U2FsdGVkX1+TBaOdp2RFCx0rVB2vA7SgYmPY1/WHm+I="
  },
  {
    "num_cand": "U2FsdGVkX18MMyWmnS1sts2SmkTOfW1te7FeGIMNCf4=",
    "cpf": "U2FsdGVkX18p5gClA1qwKjYXsZOoW1sMhzedmvsbaxw="
  },
  {
    "num_cand": "U2FsdGVkX1+3CBMYitgXy39c2/cDm38+SgaZuXyN8BY=",
    "cpf": "U2FsdGVkX1+1M+KcKHRt/q04waFIKVfocpGiJKBNMbk="
  },
  {
    "num_cand": "U2FsdGVkX19n7FR6XQ33mqkY57hpgSV2vN9kMdfTHEg=",
    "cpf": "U2FsdGVkX18ihvKNSXq+fwiZ8H6FyVZgDHOj6jm+4iA="
  },
  {
    "num_cand": "U2FsdGVkX1/P0dDrQPmgKEXR8HQwDey3O5vxPMA3omI=",
    "cpf": "U2FsdGVkX19fTSLtyneQFPcoYl3ESIVZziM40gnkXuc="
  },
  {
    "num_cand": "U2FsdGVkX18uFvQ/mhbKUD+y+oB8AJwYp7xtKK+AlCg=",
    "cpf": "U2FsdGVkX1+KqBqV5s/VFXekwQK9NRo3aOwBSj/iPIw="
  },
  {
    "num_cand": "U2FsdGVkX1+oNmqVowEHRl4To8Y2ze5efdkQKR9qIYs=",
    "cpf": "U2FsdGVkX1+5J9GWCLzLBHqD1sbX0WwIsVANvJkNGiw="
  },
  {
    "num_cand": "U2FsdGVkX1/MrJZR/QEgp9WPVMoFpoSlMd/1DjwsF98=",
    "cpf": "U2FsdGVkX18cRhZJCUVWj3/oXLrhGyXVmZfezGPa3f0="
  },
  {
    "num_cand": "U2FsdGVkX1/8SSpmeiJPeIJAf+Pshtrc61zlPnRgisc=",
    "cpf": "U2FsdGVkX18rwIx5KDdDNU8m5M+0fCXRItbkYvJ6AB8="
  },
  {
    "num_cand": "U2FsdGVkX1/Y1LxvJZhtGadFjrE81TRAoqUXqxPci+Y=",
    "cpf": "U2FsdGVkX192RL16FJRPRa30O3lj8F3cfaXS+A4LIGU="
  },
  {
    "num_cand": "U2FsdGVkX18uM0hemrtIoDojhPS5wriazlhT0VMpB0w=",
    "cpf": "U2FsdGVkX18HFDZ5soCVyf55S0s6J6Fyfe9nt1VOrZU="
  },
  {
    "num_cand": "U2FsdGVkX19q99qkoID7LDvGJ3vC60cvuwIeXHZjSEE=",
    "cpf": "U2FsdGVkX197mL9FMI+FT83O+nWQ8djSudD7oFYp/f8="
  },
  {
    "num_cand": "U2FsdGVkX1/VphxcUie7YMthOizeArhuYNdQHi55UlE=",
    "cpf": "U2FsdGVkX18pwWayQrndMnoTS1fkcB4hJALPkPWR/hw="
  },
  {
    "num_cand": "U2FsdGVkX1+VhUCOYKNPxsWBlxa+e3spazfju+NU8QU=",
    "cpf": "U2FsdGVkX198MQWRUsyi7P/XWEKGIAYD66NSa5QLKh8="
  },
  {
    "num_cand": "U2FsdGVkX19Bj9DUQbCt3qkjN1VDJeLeDhA8ntMWSYg=",
    "cpf": "U2FsdGVkX1/ZZwURK5dr0lCoJyqJT40hyG5JnrRgd1k="
  },
  {
    "num_cand": "U2FsdGVkX1+O/MabQ9E7B+UKzgVAXVeNua7tnjhn930=",
    "cpf": "U2FsdGVkX1/KRyirlY32lxixm0g0a7s+53JQtC8YABU="
  },
  {
    "num_cand": "U2FsdGVkX19k0Iqgso9vl9ME2/z0KQ+cOtlv2HcepWE=",
    "cpf": "U2FsdGVkX19wXDlIqQJLVZBVD94Lbue++YIUKUaMkyU="
  },
  {
    "num_cand": "U2FsdGVkX18o5vELmJWPUBS1OgxksvfkrT1RtHdlB/c=",
    "cpf": "U2FsdGVkX1+ZuLDUViog1gukWC5HhIxIYASbfn09crg="
  },
  {
    "num_cand": "U2FsdGVkX18imOH8QdXBowcXNBT+j/ByXv0r35GgY14=",
    "cpf": "U2FsdGVkX18kh2Lvcb+MOLTRORu/WLyaJLSEOxRxyFk="
  },
  {
    "num_cand": "U2FsdGVkX1+xtrFZpYOAi8SBkHoFU4MlHLOBQeyf2f8=",
    "cpf": "U2FsdGVkX19G7HM7DCf6a/QkScvYrWeIR8XILfXyt+A="
  },
  {
    "num_cand": "U2FsdGVkX194oa5tcKu0m6GP/CGrDJXiumcTfjonjRI=",
    "cpf": "U2FsdGVkX18YVtn2V+XPF21i56Vke7MGfYWX4ocQ6n4="
  },
  {
    "num_cand": "U2FsdGVkX1+ic6FRJIkD4jMV0aXlfluDrwSpBKCPzNE=",
    "cpf": "U2FsdGVkX18KaHkSpyFI+x25H7r0j97rnze/W21erRo="
  },
  {
    "num_cand": "U2FsdGVkX1/mJwQitN1NMc/w9q6O7ertWo9PdwMmMXo=",
    "cpf": "U2FsdGVkX18ZrUh831x7V6RrHBi9dajHtEBgTCsOOPI="
  },
  {
    "num_cand": "U2FsdGVkX19dkFLnW6GYhGKkI9LiOvKvb5/LDgN55fo=",
    "cpf": "U2FsdGVkX1+TRndMiKLByqeR8LLyrgM9gWqSuko9r54="
  },
  {
    "num_cand": "U2FsdGVkX1+c6/CNBcOb590/AOK0IzyciD6TUA6imWU=",
    "cpf": "U2FsdGVkX19tfBn8IDjIfk8SFN4vUdbDdi5KOwucjFA="
  },
  {
    "num_cand": "U2FsdGVkX19HvxFC1v6va84BU3yTD1MTlaYu0yvFcfQ=",
    "cpf": "U2FsdGVkX1//9qQHKM8VXQwlf/cmIaau9pdK6WKYqLQ="
  },
  {
    "num_cand": "U2FsdGVkX1/v14vqgsfmrU2K2ajCDRghm8N8LPIvXGM=",
    "cpf": "U2FsdGVkX1/+erRFqoLFQJzknCtNBq9c5E/qm6ysg0A="
  },
  {
    "num_cand": "U2FsdGVkX1/UgpB6wdLdWNTt+NNJvNJfTC4lqs+blHA=",
    "cpf": "U2FsdGVkX18C+QJe7gTTlOVSMBlUVA/2Wpaomfr6LR8="
  },
  {
    "num_cand": "U2FsdGVkX1+iZQnLWmTkXivKoFhlwP/DGRGr9bA1Crs=",
    "cpf": "U2FsdGVkX18uqKy9tuh2q6XqJIgcZ+M3FX0kWA8jLKE="
  },
  {
    "num_cand": "U2FsdGVkX18Mv2XIK5uQeWpzYNwYEd+sU/hcW8a/vuY=",
    "cpf": "U2FsdGVkX1+CSKXdUsXIIH1VRixShrHcR23ONuQzMfM="
  },
  {
    "num_cand": "U2FsdGVkX1+/Y6CXS9HNV8jIThPXkt0q8Bq5jSZOdho=",
    "cpf": "U2FsdGVkX1/Jq4z911lE6BodzMQyfAQV3vKIr9BLALc="
  },
  {
    "num_cand": "U2FsdGVkX1/mDVc1AlYTe/FZMTJUbFrYBCBcZDD1dEg=",
    "cpf": "U2FsdGVkX181LGsVsNvdyx/UKK0stIunzVNPBPTHYck="
  },
  {
    "num_cand": "U2FsdGVkX19C8/MtrkVOxXldhYr/MBILPRo4G0bdW+4=",
    "cpf": "U2FsdGVkX1/9slkTvZylGsIWiDV6fkKoQXZ9OOcbIYc="
  },
  {
    "num_cand": "U2FsdGVkX1+VB+m34cbHMtF8ArQeKhmrD/qja59kkvY=",
    "cpf": "U2FsdGVkX1/BJmT+RElG8hvp+2HLt3bQuphSaG5o/QY="
  },
  {
    "num_cand": "U2FsdGVkX18NUsIO/TwgjIAWYMgzvywEV+IRe1vnusQ=",
    "cpf": "U2FsdGVkX1+SHvUHd+WCh1JDfKKnKQjtzFZ/2XV9Oto="
  },
  {
    "num_cand": "U2FsdGVkX19BcNdMYn0jxgf5HdbG2+jX4XRBw+Zq1sY=",
    "cpf": "U2FsdGVkX19gV9Eq+f1DD4GHzC3jEaaVZye06bRtpFQ="
  },
  {
    "num_cand": "U2FsdGVkX18zyJ6GAfek5/OhBL3dM+MqU9xryMI96Ps=",
    "cpf": "U2FsdGVkX18jFFL1nuyP4wLCKenAJquqt8Ym1oD9B9s="
  },
  {
    "num_cand": "U2FsdGVkX1/7CjevTUEzJk36ruttN8d0vrNq0CJ9+0M=",
    "cpf": "U2FsdGVkX1+FpYM0AC5uP5zkLKdQ/DNL4C5uqv1JISE="
  },
  {
    "num_cand": "U2FsdGVkX1/dSCYTxG1d7DG5dKjqLo6qE86dsGs5HDo=",
    "cpf": "U2FsdGVkX181WPtzh72pLgiFamNwWt+eYjhV9tjYE54="
  },
  {
    "num_cand": "U2FsdGVkX18zgASo1iroB96jypcJjK2Vxvcvdj64XwI=",
    "cpf": "U2FsdGVkX197VKov5IlduBDM/JFqRzZRgz8kcoLqBoU="
  },
  {
    "num_cand": "U2FsdGVkX18DyXvzs3o7LtHbQWUdT/07piTkNKz01fE=",
    "cpf": "U2FsdGVkX19Hy/+Uy+MkAr8wdqTSRQFj+ilyxtYK9Pw="
  },
  {
    "num_cand": "U2FsdGVkX1/pgtXTWE0D/DECd04QXjFaiJINjPfIg0M=",
    "cpf": "U2FsdGVkX183TpcuP+sMA1sOyB/KFsH1j9QJHf3rolU="
  },
  {
    "num_cand": "U2FsdGVkX19ardj25QhXwPsaNt/jcprJBSvZiUHQs9Q=",
    "cpf": "U2FsdGVkX198HmT7jxVbciP0EP4g5ZSKlxG7Ri7jCqI="
  },
  {
    "num_cand": "U2FsdGVkX1/MTmD1cHlqKEomp8+rphIBiI7bwklRPDE=",
    "cpf": "U2FsdGVkX1+I7kflvu/d4lVgZM0LQNYENnS/RHJUi8g="
  },
  {
    "num_cand": "U2FsdGVkX1+z9qMzlXewrYyq9N2rloTMz7u++WBQbIM=",
    "cpf": "U2FsdGVkX18ulbZWmQgBs8cW0EwncpO/JGIiunXCl3o="
  },
  {
    "num_cand": "U2FsdGVkX1/qjA3lQJYOQYOz5KcwKZFO/+Je474hHqY=",
    "cpf": "U2FsdGVkX19e2sSnld4xCTdIvMCgOOlRW6qX02rZncM="
  },
  {
    "num_cand": "U2FsdGVkX1+bPn+CWJpemyoy5nJR/OC0L7auf/xe0ME=",
    "cpf": "U2FsdGVkX19shfT73sHXoQjgNPWv9mTHag6dXIcSqUQ="
  },
  {
    "num_cand": "U2FsdGVkX18jn975ECkRgMygrvKKdLlNN2MbXNYCg3U=",
    "cpf": "U2FsdGVkX1/mBWjb/asZlifWok8dk+Vy5mcKNKh0i+I="
  },
  {
    "num_cand": "U2FsdGVkX1+bz9G7PhVGjSsS1ldsSxa354+SGTdq1jE=",
    "cpf": "U2FsdGVkX18UEStCuEpqQnQO2j0H/YlN6U7t+t1GCmw="
  },
  {
    "num_cand": "U2FsdGVkX19Ic1H6F78HmBaSLsIjP6vRpoCUbjdnAh4=",
    "cpf": "U2FsdGVkX1/oFQII1P0BEE8MbvPew6CzWnucDoVZMEE="
  },
  {
    "num_cand": "U2FsdGVkX1/JMVbio1t3XzwbKuuQBiecP7KjUS35f00=",
    "cpf": "U2FsdGVkX1/iUpyWB2xp80kHE0KFo5DPBo8pyqd8Db4="
  },
  {
    "num_cand": "U2FsdGVkX1+J/CndIPa25aobl7Hj7uvwImwUOhfpd70=",
    "cpf": "U2FsdGVkX197sNhuIY0oZvUlki8oqmJF/tQXXJslwIA="
  },
  {
    "num_cand": "U2FsdGVkX1+MtXdh1+/cpV7sS4XI0N/yTKq95GwrWxc=",
    "cpf": "U2FsdGVkX1+iYZRt/pxI/Jdvlye8CO8BBznTJtdeqYM="
  },
  {
    "num_cand": "U2FsdGVkX1/1rN/SZCd5BINM15RmDvFmi9b+dlMwwlg=",
    "cpf": "U2FsdGVkX18O30CcfaxpUKivLlwzJb+Mu+OZDjpeTuI="
  },
  {
    "num_cand": "U2FsdGVkX1/hrlfop6vRLxdKdigZl2KSzughdReO8Eg=",
    "cpf": "U2FsdGVkX188TnFK0fx+u36HJgkrMYKkvvLJPS1gst4="
  },
  {
    "num_cand": "U2FsdGVkX19JoqTnS0uyURPqXKWWIpoh0YBtnNMSeP0=",
    "cpf": "U2FsdGVkX18nh5MthUEaVNguN6CNRvXzhOWOxbpTLTU="
  },
  {
    "num_cand": "U2FsdGVkX1/ZIc0EXDSkzA2nCVR1xdy5ZovSBaMu0cA=",
    "cpf": "U2FsdGVkX19P5cF3fsVmNKQ6HUFoTysKoSsCuDh9A/s="
  },
  {
    "num_cand": "U2FsdGVkX1/LZqyTZ+qyvs2KYMK0Yqg3IPJtnt0Vbas=",
    "cpf": "U2FsdGVkX197qo77oNOepdfCsB/FUiXPUkZ/XIXRpAk="
  },
  {
    "num_cand": "U2FsdGVkX1/MwHsBkKYpqh0oHEykSJiTnd25AtFA654=",
    "cpf": "U2FsdGVkX1+WCB7zA7BuqQJMnFOgca/5q97HfPxLicw="
  },
  {
    "num_cand": "U2FsdGVkX1+7nLTXVjsD5eMuwRtCEXOkSNjEoovfAOw=",
    "cpf": "U2FsdGVkX180zUkHmxwwOB65Zeh4TdCP/DVt47oPWXI="
  },
  {
    "num_cand": "U2FsdGVkX195wtUx51IvRJ/h0BxenOKYAhmEgKKA+AA=",
    "cpf": "U2FsdGVkX18aKWrVf7OaPVqrwDat7TVTb514wnD970k="
  },
  {
    "num_cand": "U2FsdGVkX19yI9tQ6uNn12e4q3L6Lqgh7qVhyv1b5EQ=",
    "cpf": "U2FsdGVkX1/IKo48wG97zPVA+3Ybo0V++V9R9HawhB0="
  },
  {
    "num_cand": "U2FsdGVkX180uLKiHgzTvtpOXOO6ySvu+5gA2yHKVHE=",
    "cpf": "U2FsdGVkX18t84Q5SeNVM3U3sMMTzwAtxkiLHmGUxxQ="
  },
  {
    "num_cand": "U2FsdGVkX197MU1Y8DdwbpAtzmeUtZOgHQb7qtMcp1Y=",
    "cpf": "U2FsdGVkX18Fasi0SY53mZE7F7J1noztkmR+d/gPjxg="
  },
  {
    "num_cand": "U2FsdGVkX1+1npNrkk8T8m8ACTXxyEZ0tpIGOo5VUF0=",
    "cpf": "U2FsdGVkX18NNn8iyHMn3KmiDCLG2Fe4trDNED/s1UI="
  },
  {
    "num_cand": "U2FsdGVkX18rLjau7Q0Utk30ELugNJ5Ur2f4KwBqo4c=",
    "cpf": "U2FsdGVkX1+wLjGcBs9yqocsai2QqIiJXP/v1HqnSgo="
  },
  {
    "num_cand": "U2FsdGVkX1+6PX0361M0U2JN4/Sf1RUbkQUQ08aMIBc=",
    "cpf": "U2FsdGVkX1++l8T4p2o7hCl9pbsqjrwC4gwZdBsMCzc="
  },
  {
    "num_cand": "U2FsdGVkX182nBx6a2K0gZdUJ4oefka+LtKdoSC/VNI=",
    "cpf": "U2FsdGVkX1+0acZUw6ecp/nbmQ/mHhUANQJWnRcxbbA="
  },
  {
    "num_cand": "U2FsdGVkX18/IFU1OpMVl3rJMJcBMct0Be6v59SUMWc=",
    "cpf": "U2FsdGVkX1/+uXMzxt51uX/mtcij3xfFBilERqc4h1o="
  },
  {
    "num_cand": "U2FsdGVkX1+BS9HIESy2kg/vJ4lazIJ8OYOAqSv1CGU=",
    "cpf": "U2FsdGVkX1/QazjNz84Tr8h9vuP2tsXLJZQLFvLdCdE="
  },
  {
    "num_cand": "U2FsdGVkX19LBaDif95uoKQn/CgxjFrj3uI92OfRg1s=",
    "cpf": "U2FsdGVkX1/EpoddTcLeTGRrSkyKxU4VfHMJa9U+lCE="
  },
  {
    "num_cand": "U2FsdGVkX19CV0m3GcSaQdASWx9jykZyps/nuOtkTwk=",
    "cpf": "U2FsdGVkX18A/JB9taoBx29TlMJ+t30//E8ZFuSTSPw="
  },
  {
    "num_cand": "U2FsdGVkX19E2Zj2WUNzyghD39Rk8REBljZKXFyFb0w=",
    "cpf": "U2FsdGVkX19medNCQdTMOWAnOsJ5udo7CBAGo2hkgmk="
  },
  {
    "num_cand": "U2FsdGVkX1895bErYuJGmgz1kbTYYDMU4mZP6O5BONc=",
    "cpf": "U2FsdGVkX19OmFD74N42DFslbs+5KLzww4yEh1MwIIY="
  },
  {
    "num_cand": "U2FsdGVkX18BLc42vo09KNLUP+aA22+9RbRvgP6qtFg=",
    "cpf": "U2FsdGVkX18iMLd8phuIWC/wYeKO0JdpIH7mlPZBKi4="
  },
  {
    "num_cand": "U2FsdGVkX19V42JMrAp0q3rfvnbJiosFmJ06QFYzPaQ=",
    "cpf": "U2FsdGVkX18nm4XbklrjKoZim+8Y7qhMd2sDIJLZ92M="
  },
  {
    "num_cand": "U2FsdGVkX1/TkiPGqoU/vhq/035aG4dK7qUvUuwbqrM=",
    "cpf": "U2FsdGVkX18IeILu8+acK3cmkY6fifeo+gPEe5A5SRw="
  },
  {
    "num_cand": "U2FsdGVkX1/hYCamzd8kyIz1a8pqFsUuYuFwJNpPxAI=",
    "cpf": "U2FsdGVkX18oUsd+bnz4NvWJ3ho9erE6QSQX00JS2jk="
  },
  {
    "num_cand": "U2FsdGVkX1+3y9HJ3AnT711dJYGlet0qqUGffYRVg8E=",
    "cpf": "U2FsdGVkX1+zhCOfQtNso8DyIu7NDkKpdR8XfH0TUIA="
  },
  {
    "num_cand": "U2FsdGVkX1/anRUPaCr1CvvM/9+sTtsPITx8G1AZ2x4=",
    "cpf": "U2FsdGVkX1+eb7G8Ciwul0h6TwrLVNDjJkE4ycThyk0="
  },
  {
    "num_cand": "U2FsdGVkX18Tdn1v4rQWnvrFLXEeR/rF565MH5VYKYk=",
    "cpf": "U2FsdGVkX18C3QpTGgbYxZMRtVGucmDl8hv2+Tu/vsU="
  },
  {
    "num_cand": "U2FsdGVkX19U4RWkwR4eFoyi+jkn16UholDwRX742ps=",
    "cpf": "U2FsdGVkX19M5zmtDpuB8Fz01N3wmOBo/iRvrwF3+KM="
  },
  {
    "num_cand": "U2FsdGVkX1+nU3LlAtRLyA782giWBl5xpbQGGAUg/ks=",
    "cpf": "U2FsdGVkX1+nZ8kR9sXuSvpMqwAuoOOcJD3YBNa3AoQ="
  },
  {
    "num_cand": "U2FsdGVkX18h2Bt83p+pbOlewXaAFQ7DLWE089u/sKg=",
    "cpf": "U2FsdGVkX19H+nuJc/vDVqA4FrBkTh0QRgQ4BGH0kJY="
  },
  {
    "num_cand": "U2FsdGVkX19DwuIrVgbGHxFrgLz/FqUhIbIB9aionTY=",
    "cpf": "U2FsdGVkX189FDtcf7YcJS6riwkKGu4cyjvxt2dv7Lk="
  },
  {
    "num_cand": "U2FsdGVkX1/q8ChOY4lbtE0oSosrqqwZm3kfO5tBCUA=",
    "cpf": "U2FsdGVkX1+Yc6Q7MgiKfsDcyKEs5aQRODDjv0Qyh+g="
  },
  {
    "num_cand": "U2FsdGVkX18UcDiEIAi6t25l3Fq8NHYgVL2QIFy8EAQ=",
    "cpf": "U2FsdGVkX19Wf++UvvNteCMF9FSa1cqK52F8zWjduj0="
  },
  {
    "num_cand": "U2FsdGVkX19wZaWFLI658qs9azJBr+iKPqiyHCEk148=",
    "cpf": "U2FsdGVkX1/y3c8alX4l6jsx75Os78clJspuZkovxZk="
  },
  {
    "num_cand": "U2FsdGVkX18JnBXOnU1OjPguhocSJ5xJsU0wyNV02Ic=",
    "cpf": "U2FsdGVkX1/LvPmlyM7jsbnbvzrtrJMhy2nQssYzS0M="
  },
  {
    "num_cand": "U2FsdGVkX1+yVYYmDKBXP2TEsJBbK4kg35KAozbdqLk=",
    "cpf": "U2FsdGVkX1/PYIeKAkE69R47p3LyxB3V/DjXy4c/Fps="
  },
  {
    "num_cand": "U2FsdGVkX18P3LcFT5IGAjrHW0Uirkej991ZBTspNN8=",
    "cpf": "U2FsdGVkX1+Xh7v37BA72cRgAULRt1fApn73WMkWMms="
  },
  {
    "num_cand": "U2FsdGVkX1+Pf7A6iVrYmiZKDsqB0M2H8i0cdQtRAqQ=",
    "cpf": "U2FsdGVkX1/q9G3tgGk1QkUy8r2dCII+pzJwnKb17NE="
  },
  {
    "num_cand": "U2FsdGVkX1/33UZGfqE4r4NJzbCxQE2hEc+nz9KG+jo=",
    "cpf": "U2FsdGVkX1+sD6+/VnmNAZ/A1B2ex31kIr0KEQqge9s="
  },
  {
    "num_cand": "U2FsdGVkX18ps2gI0nn8/L2w99OSIfPDhgKcKIupjLs=",
    "cpf": "U2FsdGVkX19A13AssDE1JoysaLbJiMOUbX1fjsafK0w="
  },
  {
    "num_cand": "U2FsdGVkX19GZeP0JucWPsdM27pkD/GvCa/G29On9rs=",
    "cpf": "U2FsdGVkX18CRI4zumAglZeA6uiqbi3fYAaiqOv3+JA="
  },
  {
    "num_cand": "U2FsdGVkX1/lG/1txt7u25DgSyw8cxx+Oj7tFqmwmWY=",
    "cpf": "U2FsdGVkX1+1gqxGpwZCouf/JrxyqF8CsdHSk+c7AnI="
  },
  {
    "num_cand": "U2FsdGVkX1+v8/n+ljrQ0SGBydP3+tQ4roK3H/AnyZ8=",
    "cpf": "U2FsdGVkX1+n4j0LBLNQ/EkOKHQ5KRKegea4/4Nwvpk="
  },
  {
    "num_cand": "U2FsdGVkX19sESy754YC0lD1zsSuqhzjQCwZ+B6F8uE=",
    "cpf": "U2FsdGVkX19zhoPwxluXhZj2H0ZFkOixe6m8erNEtB4="
  },
  {
    "num_cand": "U2FsdGVkX18lv9AAv4UfK9o962bxcwzWR/7QlS3eUY8=",
    "cpf": "U2FsdGVkX19TTdYPuP9nrIiuvWytVvRkYX6al22o5qo="
  },
  {
    "num_cand": "U2FsdGVkX1+jhU6iXNa3XptbgXYYhmpuKY2tQPuhL8Q=",
    "cpf": "U2FsdGVkX1/hd42SepwxiBCio97bH48Uum/jNQGAgCo="
  },
  {
    "num_cand": "U2FsdGVkX1929Smop4dpg2k9qXS4NtBzSOfJj8Yddsk=",
    "cpf": "U2FsdGVkX1+Vjf5Ztw975dJsjjZJKEipSNxgXSBjUwg="
  },
  {
    "num_cand": "U2FsdGVkX19660N62sukq7BI6im2AjRSiA+wpu9a9/A=",
    "cpf": "U2FsdGVkX1+Cztcm2prKDHqiqRNq0M6uiW7Gm+YF7+Y="
  },
  {
    "num_cand": "U2FsdGVkX1/Q4b7zaKqC1HZ4r9bDL8QsrYjIGI6LiN0=",
    "cpf": "U2FsdGVkX1+7kSQYamLAcUc9B7WOVEP6ALn9YYMOuVw="
  },
  {
    "num_cand": "U2FsdGVkX18H5UN812RHfSo8CZFGrrI9QfA03gacaVY=",
    "cpf": "U2FsdGVkX1/+urfWrRzeeIUwXhUXRox++oEWJ9VGkok="
  },
  {
    "num_cand": "U2FsdGVkX1/N3aJSwGLmQQ5u8ZLXKMy7pno+e507JS0=",
    "cpf": "U2FsdGVkX1//Y+u5nUR2sh/4169aqv3OYzdbEXgtXJo="
  },
  {
    "num_cand": "U2FsdGVkX182nQtuSu3hjPg0UdrYN6MB+fBXMypYNSQ=",
    "cpf": "U2FsdGVkX19JFRlgZwBmkhEK/to82JbNnw29cWoR00M="
  },
  {
    "num_cand": "U2FsdGVkX18OBH/t9Uo4KsJyMxxN0J72Xts4ysHTr9U=",
    "cpf": "U2FsdGVkX1+AHU/EXBtGZLXQ3GONDc5cEPnv+L/X+f4="
  },
  {
    "num_cand": "U2FsdGVkX19Yisv4v3E1bSjKsfQXzgkD50blCw99H/Y=",
    "cpf": "U2FsdGVkX18Ue4gykNiMpryKEWC3ZLUKFfGkfgR+o3s="
  },
  {
    "num_cand": "U2FsdGVkX18jo5RGoxtQmV3snYfSA7xMav1bgVDEoT8=",
    "cpf": "U2FsdGVkX1/Ck0G7n+I8vDCYpwopiMvDyZpCc9XrLoQ="
  },
  {
    "num_cand": "U2FsdGVkX19Il6QGCZ9Uve/UJen3glemvuY39QKVXIg=",
    "cpf": "U2FsdGVkX19sUZhO8f+O5GAfIYAZDqD5WpjiXsi/zJY="
  },
  {
    "num_cand": "U2FsdGVkX1+RvIJM5qIsKAqcsTMYjPAsFlKsPmBb5lY=",
    "cpf": "U2FsdGVkX18CAktVTkWPtrIV5dr5UFsTBsc5oOKUZ/E="
  },
  {
    "num_cand": "U2FsdGVkX1/d4Ut9/Oqz870E1e/lY3F7Idnu0ys4IUc=",
    "cpf": "U2FsdGVkX1+eSSHFY34K3PfZ+r+i9nQjca8EdqmDMyE="
  },
  {
    "num_cand": "U2FsdGVkX19ifWQJ/VRfCe8j/2jYp6OYbDdGaFGYtIE=",
    "cpf": "U2FsdGVkX1/Ytetd7qn5bS5xqwfXA4Tfq6AXlCF3imo="
  },
  {
    "num_cand": "U2FsdGVkX18WJU5YwGPah7D9LsxK6HldsUScxJ7D21Y=",
    "cpf": "U2FsdGVkX187WXEIeSNxFCB4iXjBSZv1AfzG1G5uECA="
  },
  {
    "num_cand": "U2FsdGVkX18chc/ocrBpR4HQO+LyH1G0Y66aepUKmeg=",
    "cpf": "U2FsdGVkX1+BRsYY9cH7KuUVPv819vdzoaDjPG+/7Zw="
  },
  {
    "num_cand": "U2FsdGVkX1/w6nKtJh1zoSXu2kXsD/Ma5yYkbCpCg4k=",
    "cpf": "U2FsdGVkX1/NEFr8HwSzHWcyPNVjduPXEJQH7NDyGPY="
  },
  {
    "num_cand": "U2FsdGVkX1/tQ/3mTuWgrOE57Usl3+d+YKYyQKoOWbs=",
    "cpf": "U2FsdGVkX19GTEEmRPZxHrUMcqeyk7d7r+CE2UVge0A="
  },
  {
    "num_cand": "U2FsdGVkX18nJensoXpALC3GpbCqYjWXJ+rEku9tEFk=",
    "cpf": "U2FsdGVkX19+f6LYtvJHwrt1ZW3son1ot+28vtKcPao="
  },
  {
    "num_cand": "U2FsdGVkX1/NvLM3TB5vaPbiiT5H8bYe0cQZspJrSjg=",
    "cpf": "U2FsdGVkX1+H3QyzmG3EVROp+7gDAP30cXviLO+mvDY="
  },
  {
    "num_cand": "U2FsdGVkX1/wFoF7wD5ywiezKf5XMDlPM6sLUqhtq0Y=",
    "cpf": "U2FsdGVkX19BG3NlFET+ezhqWIKq1QFzR2keG0nT/zc="
  },
  {
    "num_cand": "U2FsdGVkX18+Fs5yJ29S0zyLKFioLhw94XhyEWGIRYE=",
    "cpf": "U2FsdGVkX1+D98rtX215zJhADMAPPERkXqTcCUMLNOg="
  },
  {
    "num_cand": "U2FsdGVkX18T04kReNzTN7FI5TQImJ1IDp47PlOt6BE=",
    "cpf": "U2FsdGVkX1+zv/u6uDsmnStjaHUfM/3UljgHlgf5LzA="
  },
  {
    "num_cand": "U2FsdGVkX18EncChjbTf775OO+qHWplOx5BI08acblI=",
    "cpf": "U2FsdGVkX1+SjQdm0qPxHAIcVTDuyA+SANpfpqwWmIg="
  },
  {
    "num_cand": "U2FsdGVkX1/iAjU1fiNfgKt1oOQAICHqg6Jg0L+7hGA=",
    "cpf": "U2FsdGVkX1/1SY2MfNjLhhU5FKIVy9X9bMd0XGDzOgs="
  },
  {
    "num_cand": "U2FsdGVkX18ZUnAuGLnTfTGzFVDNIWW2+JBQa3jsLa8=",
    "cpf": "U2FsdGVkX1/i6UVaN8n/3IxkdPTJ7vJRtMYE976TM2c="
  },
  {
    "num_cand": "U2FsdGVkX1/ZUmUC4fyfcRiKqjTXBzHl4mhqMwaLCKA=",
    "cpf": "U2FsdGVkX1+F7EGqCMcfNy6TMA5Sjl9njUMYTdgU2bU="
  },
  {
    "num_cand": "U2FsdGVkX1+7lXfVTlffFLk+ZhR6W0uYQkEAJtNQfF4=",
    "cpf": "U2FsdGVkX18+cY3+1vj32z+58DKckNWD/HyIdjeKw8M="
  },
  {
    "num_cand": "U2FsdGVkX1+dytOT2i+PZPRBT4wJTXXIPP/1hed34b0=",
    "cpf": "U2FsdGVkX1+nVNDsj6WlMNCHy32VCGd1VtTU4V8KYus="
  },
  {
    "num_cand": "U2FsdGVkX18h+f5ohyFUnMMaZ3cCw5rhxiJpxXTPj9Q=",
    "cpf": "U2FsdGVkX1/3YVdwU4yWH/fdLCKXvcXECjQIheBvzX4="
  },
  {
    "num_cand": "U2FsdGVkX18wjtnHKd4TorI0jBLF/WMwIyJgYT/2Oxg=",
    "cpf": "U2FsdGVkX195N71UmOAqoTAD4A3UBTwgsrackpIi8TA="
  },
  {
    "num_cand": "U2FsdGVkX1++Q5SwYnpYAbQLRgCTzbwXFFuIoQVBMho=",
    "cpf": "U2FsdGVkX192dwtINI1cRBnbJF+whfuchAVHnBnW7D4="
  },
  {
    "num_cand": "U2FsdGVkX1+ONHpoOortYZ45ejvFCzjG800gqGQ/+Jg=",
    "cpf": "U2FsdGVkX1+FtOAKmVKaCEE2Z2yukGczc1Xm91+YwdM="
  },
  {
    "num_cand": "U2FsdGVkX18fwyjbJxd1J/w5tqTH3CT0ZSmqf/xGNZ0=",
    "cpf": "U2FsdGVkX1+WekH5r7HRLIn3qRzn4tSzWWDppM/5NFo="
  },
  {
    "num_cand": "U2FsdGVkX1+NimJmwjUA6mYJg3lSKK5syDrDgnYxsDU=",
    "cpf": "U2FsdGVkX1/6D0E2VzOWdnUDRlhYysu60NiFaiE9aW0="
  },
  {
    "num_cand": "U2FsdGVkX18w3EYEOxtZqOgtRwS9QjNTq5DkKKJu/do=",
    "cpf": "U2FsdGVkX1+sXKftw/l50wvq8IHr2WoO0J7xABEqZD0="
  },
  {
    "num_cand": "U2FsdGVkX1/pYhaV4R1wgDR4Wy+pGq7wrsECTb/5vB4=",
    "cpf": "U2FsdGVkX18USoeJh0djZ8VzoHp2FC/puzSAH6/2OIY="
  },
  {
    "num_cand": "U2FsdGVkX1/mr5vnKcpo6NloXAmyQMbIeH7zXpR9HMQ=",
    "cpf": "U2FsdGVkX1+/ecEHJaSx7jJSpXzFI1ALIAJDiHtJAWk="
  },
  {
    "num_cand": "U2FsdGVkX1/ABoXoHc+kpUopGAl/a7f6ncDfGmIlOmk=",
    "cpf": "U2FsdGVkX1/xglmE2oRmyz9G1dydHMRn8FOR7oSFhIE="
  },
  {
    "num_cand": "U2FsdGVkX1+Q7L8ElkKc6/hRamt5tfiymZPIDlKtlBg=",
    "cpf": "U2FsdGVkX18kf8NHsspVSNAz4Y0Si0izSSkwvKKBJtU="
  },
  {
    "num_cand": "U2FsdGVkX18BRtTE8A0JY9HQzIs6KIeOmYO6McE5Nlc=",
    "cpf": "U2FsdGVkX19XZ+2U4rUmhBOWwcdpK/+OIrhNqSEb8Es="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2114/2114_rec_gabx/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
